import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class DefaultService {
    /**
     * Get Documentation
     * @returns any Successful Response
     * @throws ApiError
     */
    static getDocumentationDocsGet() {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/docs',
        });
    }
    /**
     * Send Mail Of Leads
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static sendMailOfLeadsLeadsSendMailPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/leads/send_mail',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Token
     * @param email
     * @returns any Successful Response
     * @throws ApiError
     */
    static getTokenUserGetTokenGet(email) {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/user/get_token',
            query: {
                'email': email,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Auth Token
     * @param email
     * @returns any Successful Response
     * @throws ApiError
     */
    static getAuthTokenUserGetAuthTokenGet(email) {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/user/get_auth_token',
            query: {
                'email': email,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Current User
     * @returns any Successful Response
     * @throws ApiError
     */
    static getCurrentUserUsersGetUserAndOrgGet() {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/users/get_user_and_org',
        });
    }
    /**
     * Map Current User Org
     * @returns any Successful Response
     * @throws ApiError
     */
    static mapCurrentUserOrgUserMapOrgGet() {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/user/map_org',
        });
    }
    /**
     * Get All Store
     * @returns any Successful Response
     * @throws ApiError
     */
    static getAllStoreStoreGetAllStoresGet() {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/store/get_all_stores',
        });
    }
    /**
     * Get All User Mapping
     * @returns UserBNameResponse Successful Response
     * @throws ApiError
     */
    static getAllUserMappingAdminGetAllUserMappingGet() {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/get_all_user_mapping',
        });
    }
    /**
     * Upload B Name User Mapping Csv
     * @param formData
     * @returns any Successful Response
     * @throws ApiError
     */
    static uploadBNameUserMappingCsvAdminUploadBNameUserMappingPost(formData) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin/upload/b_name_user_mapping',
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Merge B Name Ids
     * @param dest
     * @param requestBody
     * @param crossChainAllowed
     * @returns any Successful Response
     * @throws ApiError
     */
    static mergeBNameIdsBMSlugMappingMergeBNameIdsPost(dest, requestBody, crossChainAllowed = false) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/B&M_slug_mapping/merge_b_name_ids',
            query: {
                'dest': dest,
                'cross_chain_allowed': crossChainAllowed,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Create Org
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static createOrgOrgCreatePost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/org/create',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Org Users
     * Returns all users of org if org is passed
     * Returns all users except self of self org if org is not passed
     * @param org
     * @returns any Successful Response
     * @throws ApiError
     */
    static getOrgUsersOrgUsersGet(org) {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/org/users',
            query: {
                'org': org,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Invite Org User
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static inviteOrgUserOrgInviteUserPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/org/invite/user',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Create User With Pass
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static createUserWithPassOrgCreateUserPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/org/create/user',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Delete Org User
     * @param userEmail
     * @returns any Successful Response
     * @throws ApiError
     */
    static deleteOrgUserOrgUserUserEmailDelete(userEmail) {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/org/user/{user_email}',
            path: {
                'user_email': userEmail,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * User Send Magic Link
     * @param userEmail
     * @param emailSubject
     * @param isTemporary
     * @param forAdmin
     * @returns any Successful Response
     * @throws ApiError
     */
    static userSendMagicLinkUserSendMagicLinkPost(userEmail, emailSubject, isTemporary = true, forAdmin = false) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/user/send/magic_link',
            query: {
                'user_email': userEmail,
                'email_subject': emailSubject,
                'is_temporary': isTemporary,
                'for_admin': forAdmin,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Create Subchain
     * For the list of location, accounting_company, and user ids:
     * If the list is None, then skip mapping them, else map the list of ids, if list is empty, then delete all mappings
     * @param chain
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static createSubchainSubchainSetPost(chain, requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/subchain/set',
            query: {
                'chain': chain,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Delete Subchain
     * @param chain
     * @param name
     * @returns any Successful Response
     * @throws ApiError
     */
    static deleteSubchainSubchainDeleteDelete(chain, name) {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/subchain/delete',
            query: {
                'chain': chain,
                'name': name,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Subchains
     * @param chain
     * @returns SubChainData Successful Response
     * @throws ApiError
     */
    static getSubchainsSubchainGetAllGet(chain) {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/subchain/get/all',
            query: {
                'chain': chain,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Map Locations To Subchain
     * If replace is true, then pre-existing location mappings are removed before mapping the new locations
     * @param chain
     * @param requestBody
     * @param subChain
     * @param replace
     * @returns any Successful Response
     * @throws ApiError
     */
    static mapLocationsToSubchainSubchainMapLocationPost(chain, requestBody, subChain, replace = false) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/subchain/map/location',
            query: {
                'chain': chain,
                'sub_chain': subChain,
                'replace': replace,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Map Accounting Cadence Configs To Subchain
     * If replace is true, then pre-existing cadence mappings are removed before mapping the new cadences
     * @param chain
     * @param requestBody
     * @param subChain
     * @param replace
     * @returns any Successful Response
     * @throws ApiError
     */
    static mapAccountingCadenceConfigsToSubchainSubchainMapCadencePost(chain, requestBody, subChain, replace = false) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/subchain/map/cadence',
            query: {
                'chain': chain,
                'sub_chain': subChain,
                'replace': replace,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Map Users To Subchains
     * If replace is true, then pre-existing user mappings are removed before mapping the new users
     * @param chain
     * @param requestBody
     * @param replace
     * @returns any Successful Response
     * @throws ApiError
     */
    static mapUsersToSubchainsSubchainMapUserPost(chain, requestBody, replace = false) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/subchain/map/user',
            query: {
                'chain': chain,
                'replace': replace,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Map Accounting Companies To Subchain
     * If replace is true, then pre-existing company mappings are removed before mapping the new companies
     * @param chain
     * @param requestBody
     * @param subChain
     * @param replace
     * @returns any Successful Response
     * @throws ApiError
     */
    static mapAccountingCompaniesToSubchainSubchainMapAccountingCompanyPost(chain, requestBody, subChain, replace = false) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/subchain/map/accounting_company',
            query: {
                'chain': chain,
                'sub_chain': subChain,
                'replace': replace,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get All User Sub Chains
     * @param chain
     * @returns any Successful Response
     * @throws ApiError
     */
    static getAllUserSubChainsSubchainOrgUsersGet(chain) {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/subchain/org/users',
            query: {
                'chain': chain,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Access Tokens
     * @param org
     * @returns any Successful Response
     * @throws ApiError
     */
    static getAccessTokensPlaidGetAccessTokensPost(org) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/plaid/get_access_tokens',
            query: {
                'org': org,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Create Link Token
     * @param redirectUrl
     * @param org
     * @param itemId
     * @returns any Successful Response
     * @throws ApiError
     */
    static createLinkTokenPlaidCreateLinkTokenPost(redirectUrl, org, itemId) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/plaid/create_link_token',
            query: {
                'redirect_url': redirectUrl,
                'org': org,
                'item_id': itemId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Link Plaid To Dwolla
     * This looks up the plaid access token from firestore for <user_id> and uses it to create a funding source on dwolla.
     * The email must be the one which was used for business registration on dwolla
     * @param org
     * @returns any Successful Response
     * @throws ApiError
     */
    static linkPlaidToDwollaPlaidLinkDwollaPost(org) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/plaid/link_dwolla',
            query: {
                'org': org,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Set Access Token
     * @param publicToken
     * @param org
     * @param userId
     * @returns any Successful Response
     * @throws ApiError
     */
    static setAccessTokenPlaidSetAccessTokenPost(publicToken, org, userId) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/plaid/set_access_token',
            query: {
                'public_token': publicToken,
                'org': org,
                'user_id': userId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Accounts
     * @param userId
     * @returns any Successful Response
     * @throws ApiError
     */
    static getAccountsPlaidAccountsUserIdGet(userId) {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/plaid/accounts/{user_id}',
            path: {
                'user_id': userId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Accounts For Org
     * @param org
     * @returns PlaidAccountsResponse Successful Response
     * @throws ApiError
     */
    static getAccountsForOrgPlaidAccountsGet(org) {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/plaid/accounts',
            query: {
                'org': org,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Disconnect Account
     * @param org
     * @param id
     * @returns any Successful Response
     * @throws ApiError
     */
    static disconnectAccountPlaidDeleteAccountDelete(org, id) {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/plaid/delete/account',
            query: {
                'org': org,
                'id': id,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Plaid Mappings
     * @param org
     * @param itemId
     * @returns any Successful Response
     * @throws ApiError
     */
    static getPlaidMappingsPlaidMappingsGetPost(org, itemId) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/plaid/mappings/get',
            query: {
                'org': org,
                'item_id': itemId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Set Plaid Mappings V2
     * @param org
     * @param itemId
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static setPlaidMappingsV2PlaidMappingsSetV2Post(org, itemId, requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/plaid/mappings/set/v2',
            query: {
                'org': org,
                'item_id': itemId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Set Plaid Mappings
     * @param org
     * @param itemId
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static setPlaidMappingsPlaidMappingsSetPost(org, itemId, requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/plaid/mappings/set',
            query: {
                'org': org,
                'item_id': itemId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Transactions
     * @param userId
     * @param numTransactions
     * @param tokenNum
     * @returns any Successful Response
     * @throws ApiError
     */
    static getTransactionsPlaidTransactionsUserIdGet(userId, numTransactions = 10, tokenNum) {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/plaid/transactions/{user_id}',
            path: {
                'user_id': userId,
            },
            query: {
                'num_transactions': numTransactions,
                'token_num': tokenNum,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Plaid Refresh
     * Refresh plaid transactions for all orgs and all access tokens
     * @returns any Successful Response
     * @throws ApiError
     */
    static plaidRefreshPlaidRefreshPost() {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/plaid/refresh',
        });
    }
    /**
     * Ingest Transactions
     * Fetch the latest transactions for all orgs
     * @returns any Successful Response
     * @throws ApiError
     */
    static ingestTransactionsPlaidIngestTransactionsPost() {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/plaid/ingest_transactions',
        });
    }
    /**
     * Create Company
     * Create an accounting_providers company. Note that multiple company-ids can be created for
     * same company-name. So it's important to look back at current firestore
     * table to not overwrite existing integration.
     *
     * :param chain: Chain
     * @param chain
     * @returns any Successful Response
     * @throws ApiError
     */
    static createCompanyCodatCreateCompanyPost(chain) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/codat/create/company',
            query: {
                'chain': chain,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Update Company
     * Update a company after redirect.
     *
     * :param chain: Chain
     * :param company_id: Company ID returned in redirect url
     * @param chain
     * @param companyId
     * @returns any Successful Response
     * @throws ApiError
     */
    static updateCompanyCodatUpdateConnectionsPost(chain, companyId) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/codat/update/connections',
            query: {
                'chain': chain,
                'company_id': companyId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Create Codat Connection
     * @param companyId
     * @param connectionId
     * @param statusCode
     * @param errorMessage
     * @param redirect
     * @param chain
     * @returns any Successful Response
     * @throws ApiError
     */
    static createCodatConnectionCodatLinkGet(companyId, connectionId, statusCode, errorMessage, redirect, chain) {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/codat/link',
            query: {
                'companyId': companyId,
                'connectionId': connectionId,
                'statusCode': statusCode,
                'errorMessage': errorMessage,
                'redirect': redirect,
                'chain': chain,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Push Journal Entries
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static pushJournalEntriesAccountingJournalEntriesPushPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/accounting/journal_entries/push',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Push Accounting Details To Pg
     * @param formData
     * @returns any Successful Response
     * @throws ApiError
     */
    static pushAccountingDetailsToPgAccountingDetailsPushPost(formData) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/accounting_details/push',
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Create Accounting Freetext Company
     * @param chain
     * @param name
     * @param subtype
     * @returns any Successful Response
     * @throws ApiError
     */
    static createAccountingFreetextCompanyFreetextCreateCompanyPost(chain, name, subtype) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/freetext/create/company',
            query: {
                'chain': chain,
                'name': name,
                'subtype': subtype,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Update Freetext Company Gl Codes
     * @param companyId
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static updateFreetextCompanyGlCodesFreetextCompanyGlCodesPost(companyId, requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/freetext/company/gl/codes',
            query: {
                'company_id': companyId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Update Freetext Company Classes
     * @param companyId
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static updateFreetextCompanyClassesFreetextCompanyClassesPost(companyId, requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/freetext/company/classes',
            query: {
                'company_id': companyId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Accounting Templates
     * @param chain
     * @param accountingProvider
     * @returns AccountingJournalTemplate Successful Response
     * @throws ApiError
     */
    static getAccountingTemplatesAccountingTemplateAllGet(chain, accountingProvider) {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/accounting/template/all',
            query: {
                'chain': chain,
                'accounting_provider': accountingProvider,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Set Accounting Template
     * @param chain
     * @param accountingProvider
     * @param name
     * @param fileName
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static setAccountingTemplateAccountingTemplateSetPost(chain, accountingProvider, name, fileName, requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/accounting/template/set',
            query: {
                'chain': chain,
                'accounting_provider': accountingProvider,
                'name': name,
                'file_name': fileName,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Template Config
     * @param provider
     * @returns AccountingTemplateConfig Successful Response
     * @throws ApiError
     */
    static getTemplateConfigAccountingTemplateConfigGet(provider) {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/accounting/template/config',
            query: {
                'provider': provider,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Template Variables
     * @returns any Successful Response
     * @throws ApiError
     */
    static getTemplateVariablesAccountingTemplateVariablesGet() {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/accounting/template/variables',
        });
    }
    /**
     * Authorize
     * Generate and return the authorization URL.
     *
     * :return: Authorization URL
     * @param chain
     * @param userId
     * @param provider
     * @param redirectDomain
     * @returns any Successful Response
     * @throws ApiError
     */
    static authorizeLinkAuthorizeGet(chain, userId, provider, redirectDomain = 'https://app.loopkitchen.xyz') {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/link/authorize',
            query: {
                'chain': chain,
                'user_id': userId,
                'provider': provider,
                'redirect_domain': redirectDomain,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Accounting Companies
     * Get all the accounting companies connected with a chain
     *
     * :return: list of Companies' details
     * @param chain
     * @returns AccountingCompanyRepsonse Successful Response
     * @throws ApiError
     */
    static getAccountingCompaniesAccountingCompanyAllGet(chain) {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/accounting/company/all',
            query: {
                'chain': chain,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Delete Accounting Company
     * @param companyId
     * @returns any Successful Response
     * @throws ApiError
     */
    static deleteAccountingCompanyAccountingCompanyDeleteDelete(companyId) {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/accounting/company/delete',
            query: {
                'company_id': companyId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Accounting Classes
     * @param companyId
     * @returns AccountingClassInfo Successful Response
     * @throws ApiError
     */
    static getAccountingClassesAccountingClassesGetGet(companyId) {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/accounting/classes/get',
            query: {
                'company_id': companyId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Bulk Download Accounting Classes
     * @param companyId
     * @returns any Successful Response
     * @throws ApiError
     */
    static bulkDownloadAccountingClassesAccountingCompanyClassesDownloadGet(companyId) {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/accounting/company/classes/download',
            query: {
                'company_id': companyId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Bname Mappings
     * @param companyId
     * @returns AccountingBNameMappingResponse Successful Response
     * @throws ApiError
     */
    static getBnameMappingsAccountingBnameMappingsGetGet(companyId) {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/accounting/bname/mappings/get',
            query: {
                'company_id': companyId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Set Bname Mappings
     * @param companyId
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static setBnameMappingsAccountingBnameMappingsSetPost(companyId, requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/accounting/bname/mappings/set',
            query: {
                'company_id': companyId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Bulk Download Gl Codes
     * @param companyId
     * @returns any Successful Response
     * @throws ApiError
     */
    static bulkDownloadGlCodesAccountingCompanyGlCodesDownloadGet(companyId) {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/accounting/company/gl/codes/download',
            query: {
                'company_id': companyId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Gl Codes
     * @param companyId
     * @returns AccountingGLCodeInfo Successful Response
     * @throws ApiError
     */
    static getGlCodesAccountingGlCodesGetGet(companyId) {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/accounting/gl/codes/get',
            query: {
                'company_id': companyId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Gl Mappings
     * @param companyId
     * @param templateId
     * @returns AccountingGLMappingResponse Successful Response
     * @throws ApiError
     */
    static getGlMappingsAccountingGlMappingsGetGet(companyId, templateId) {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/accounting/gl/mappings/get',
            query: {
                'company_id': companyId,
                'template_id': templateId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Set Gl Mappings
     * @param companyId
     * @param requestBody
     * @param templateId
     * @returns any Successful Response
     * @throws ApiError
     */
    static setGlMappingsAccountingGlMappingsSetPost(companyId, requestBody, templateId) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/accounting/gl/mappings/set',
            query: {
                'company_id': companyId,
                'template_id': templateId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Companies Without Gl Mapping
     * @param chain
     * @returns AccountingCompany Successful Response
     * @throws ApiError
     */
    static getCompaniesWithoutGlMappingAccountingGlMappingsUnmappedPost(chain) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/accounting/gl/mappings/unmapped',
            query: {
                'chain': chain,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Accounting Cadence Configs
     * Get all the accounting configurations for a chain
     *
     * :param: chain
     * :param: history - returns push history if true
     * :param: periods - returns the push history for this number of periods
     *
     * :return: list of accounting configuration details
     * @param chain
     * @param history
     * @param periods
     * @returns AccountingCadenceConfigResponse Successful Response
     * @throws ApiError
     */
    static getAccountingCadenceConfigsAccountingConfigurationsGetGet(chain, history = false, periods = 4) {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/accounting/configurations/get',
            query: {
                'chain': chain,
                'history': history,
                'periods': periods,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Accounting Cadence Configs
     * Get all the accounting configurations for a list of chains
     *
     * :param: chains
     * :param: history - returns push history if true
     * :param: periods - returns the push history for this number of periods
     *
     * :return: list of accounting configuration details
     * @param requestBody
     * @param history
     * @param periods
     * @returns AccountingCadenceConfig Successful Response
     * @throws ApiError
     */
    static getAccountingCadenceConfigsAccountingConfigurationsGetAllPost(requestBody, history = false, periods = 4) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/accounting/configurations/get/all',
            query: {
                'history': history,
                'periods': periods,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Set Accounting Cadence Config
     * Create or update an accounting configuration, and also set the bname mappings.
     * Creates new config when id is not provided or cannot be found
     * @param chain
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static setAccountingCadenceConfigAccountingConfigurationSetPost(chain, requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/accounting/configuration/set',
            query: {
                'chain': chain,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Delete Accounting Cadence Config
     * Deletes an accounting cadence config when provided with its postgres id
     * @param configId
     * @returns any Successful Response
     * @throws ApiError
     */
    static deleteAccountingCadenceConfigAccountingConfigurationDeleteDelete(configId) {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/accounting/configuration/delete',
            query: {
                'config_id': configId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Accounting Provider Locations
     * @param chain
     * @returns any Successful Response
     * @throws ApiError
     */
    static getAccountingProviderLocationsAccountingProvidersGet(chain) {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/accounting/providers',
            query: {
                'chain': chain,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Bookkeeping Transactions Paginated
     * Paginated endpoint for BookKeepingTransactions
     * This API wouldn't have typescript client typehinting since the execution
     *
     * :param request: FiltersForQueryPaginated objectgenerate
     * :param provider: Name of the provider
     * @param requestBody
     * @param provider
     * @param templateId
     * @returns any Successful Response
     * @throws ApiError
     */
    static getBookKeepingTransactionsPaginatedApiPaginatedBookKeepingTransactionsDynamicPost(requestBody, provider, templateId) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/paginated/BookKeepingTransactionsDynamic',
            query: {
                'provider': provider,
                'template_id': templateId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Bookkeeping Total Amount
     * Endpoint for BookKeepingTotalAggregate.
     * This API returns the Debit & Total for the given filters
     *
     * :param request: FiltersForQuery object
     * :param provider: Name of the provider
     * @param requestBody
     * @param provider
     * @param templateId
     * @returns any Successful Response
     * @throws ApiError
     */
    static getBookKeepingTotalAmountApiAggregateBookKeepingTotalPost(requestBody, provider, templateId) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/aggregate/BookKeepingTotal',
            query: {
                'provider': provider,
                'template_id': templateId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Generate Book Keeping Csv
     * Generate CSV from a BookKeeping customised queries
     *
     * :param request: Path to the procedure file
     * :param provider: Name of the provider
     * :param template_id: Template id
     * :param validate: If true, validate the ingestion before download
     * @param requestBody
     * @param provider
     * @param templateId
     * @param validate
     * @returns any Successful Response
     * @throws ApiError
     */
    static generateBookKeepingCsvGenerateCsvBookKeepingPost(requestBody, provider, templateId, validate = false) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/generate/csv/BookKeeping',
            query: {
                'provider': provider,
                'template_id': templateId,
                'validate': validate,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Push Journal Entries For Bname
     * @param requestBody
     * @param overridePushOverlap
     * @param overrideTests
     * @param dummy
     * @param user
     * @param pushRunId
     * @param templateId
     * @param cadenceId
     * @returns any Successful Response
     * @throws ApiError
     */
    static pushJournalEntriesForBnameAccountingJournalEntriesBnamePushPost(requestBody, overridePushOverlap = false, overrideTests = false, dummy = false, user, pushRunId, templateId, cadenceId) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/accounting/journal_entries/bname/push',
            query: {
                'override_push_overlap': overridePushOverlap,
                'override_tests': overrideTests,
                'dummy': dummy,
                'user': user,
                'push_run_id': pushRunId,
                'template_id': templateId,
                'cadence_id': cadenceId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Trigger Push Journal Entries
     * @param requestBody
     * @param user
     * @param overridePushOverlap
     * @param overrideTests
     * @param dummy
     * @param templateId
     * @returns any Successful Response
     * @throws ApiError
     */
    static triggerPushJournalEntriesAccountingJournalEntriesTriggerPushPost(requestBody, user, overridePushOverlap = false, overrideTests = false, dummy = false, templateId) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/accounting/journal_entries/trigger/push',
            query: {
                'user': user,
                'override_push_overlap': overridePushOverlap,
                'override_tests': overrideTests,
                'dummy': dummy,
                'template_id': templateId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Transaction Difference
     * Calculate jourrnal transaction difference
     * 1. Fetch logs of last 4 weeks to last 2 weeks from the given date
     * from `AccountingPushLog` table
     * 2. For each push
     * 1.1. Extract csv url and fetch the csv data
     * 1.2. Fetch latest transaction logs of last 4 weeks to last 2 weeks
     * from the given date
     * 1.3. Check the difference of credit and debit
     * 3. Send slack notification for each chain with different debit or credit value
     * @param startDate
     * @returns any Successful Response
     * @throws ApiError
     */
    static getTransactionDifferenceAccountingNotifyJournalDiffGet(startDate = '2024-06-13') {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/accounting/notify/journal/diff',
            query: {
                'start_date': startDate,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Push History
     * @param requestBody
     * @param download
     * @param mapError
     * @returns any Successful Response
     * @throws ApiError
     */
    static getPushHistoryAccountingJournalEntriesPushHistoryPost(requestBody, download = false, mapError = true) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/accounting/journal_entries/push/history',
            query: {
                'download': download,
                'map_error': mapError,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Notify User On Push
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static notifyUserOnPushAccountingJournalEntriesPushNotifyPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/accounting/journal_entries/push/notify',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Trigger Push Journal Cadence
     * @returns any Successful Response
     * @throws ApiError
     */
    static triggerPushJournalCadenceAccountingJournalEntriesTriggerCadencePost() {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/accounting/journal_entries/trigger/cadence',
        });
    }
    /**
     * Accounting Journal Push Overlap
     * @param requestBody
     * @returns PushOverlapResponse Successful Response
     * @throws ApiError
     */
    static accountingJournalPushOverlapAccountingJournalPushOverlapPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/accounting/journal/push/overlap',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Accounting Location Status
     * @param chain
     * @returns AccountingLocationStatus Successful Response
     * @throws ApiError
     */
    static getAccountingLocationStatusAccountingLocationsStatusGet(chain) {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/accounting/locations/status',
            query: {
                'chain': chain,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Accounting Location Status
     * @param requestBody
     * @returns AccountingLocationStatus Successful Response
     * @throws ApiError
     */
    static getAccountingLocationStatusAccountingLocationsStatusAllPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/accounting/locations/status/all',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Toggle Accounting Push Resolution
     * @param id
     * @param resolved
     * @param comment
     * @returns any Successful Response
     * @throws ApiError
     */
    static toggleAccountingPushResolutionAccountingPushResolveSetPost(id, resolved, comment) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/accounting/push/resolve/set',
            query: {
                'id': id,
                'resolved': resolved,
                'comment': comment,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Refresh All Accounting Companies
     * List of chains to refresh, empty list refreshes all chains
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static refreshAllAccountingCompaniesAccountingRefreshPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/accounting/refresh',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Qbo Customer Id
     * Get QBO customer id for a company
     * @param accountingCompanyId
     * @returns any Successful Response
     * @throws ApiError
     */
    static getQboCustomerIdQboCustomersGet(accountingCompanyId) {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/qbo/customers',
            query: {
                'accounting_company_id': accountingCompanyId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Mark Lost Access For Store
     * @param digitalStoreId
     * @param loopAccess
     * @returns any Successful Response
     * @throws ApiError
     */
    static markLostAccessForStoreDigitalStoresAccessLostDigitalStoreIdPost(digitalStoreId, loopAccess = false) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/digital_stores/access/lost/{digital_store_id}',
            path: {
                'digital_store_id': digitalStoreId,
            },
            query: {
                'loop_access': loopAccess,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Mark Lost Access For Username And Platform
     * @param username
     * @param platform
     * @param loopAccess
     * @returns any Successful Response
     * @throws ApiError
     */
    static markLostAccessForUsernameAndPlatformDigitalStoresAccessLostPost(username, platform, loopAccess = false) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/digital_stores/access/lost',
            query: {
                'username': username,
                'platform': platform,
                'loop_access': loopAccess,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Add Edit Comment For Username And Platform
     * @param username
     * @param platform
     * @param comment
     * @returns any Successful Response
     * @throws ApiError
     */
    static addEditCommentForUsernameAndPlatformDigitalStoresCommentPost(username, platform, comment) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/digital_stores/comment/',
            query: {
                'username': username,
                'platform': platform,
                'comment': comment,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Add Edit Comment For Store
     * @param digitalStoreId
     * @param comment
     * @returns any Successful Response
     * @throws ApiError
     */
    static addEditCommentForStoreDigitalStoresCommentDigitalStoreIdPost(digitalStoreId, comment) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/digital_stores/comment/{digital_store_id}',
            path: {
                'digital_store_id': digitalStoreId,
            },
            query: {
                'comment': comment,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Update Cookie For Slug
     * @param slug
     * @param cookie
     * @returns any Successful Response
     * @throws ApiError
     */
    static updateCookieForSlugDigitalStoresCookieUpdatePost(slug, cookie) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/digital_stores/cookie/update',
            query: {
                'slug': slug,
                'cookie': cookie,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Sample Uploads
     * @returns any Successful Response
     * @throws ApiError
     */
    static getSampleUploadsSampleUploadsGet() {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/sample_uploads',
        });
    }
    /**
     * Get All Refresh Configs
     * @returns any Successful Response
     * @throws ApiError
     */
    static getAllRefreshConfigsConfigRefreshAllGet() {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/config/refresh/all',
        });
    }
    /**
     * Create Or Update Refresh Config
     * @param configName
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static createOrUpdateRefreshConfigConfigRefreshCreateOrUpdatePost(configName, requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/config/refresh/create_or_update',
            query: {
                'config_name': configName,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Set Refresh Config
     * @param chain
     * @param configName
     * @returns any Successful Response
     * @throws ApiError
     */
    static setRefreshConfigConfigRefreshSetPost(chain, configName) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/config/refresh/set',
            query: {
                'chain': chain,
                'config_name': configName,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get All Chargeback Configs
     * @returns any Successful Response
     * @throws ApiError
     */
    static getAllChargebackConfigsConfigChargebackGet() {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/config/chargeback',
        });
    }
    /**
     * Get All Chargeback Configs
     * @returns ChargebackConfigResponse Successful Response
     * @throws ApiError
     */
    static getAllChargebackConfigsConfigChargebackV2Get() {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/config/chargeback/v2',
        });
    }
    /**
     * Get All Chargeback Configs Chain
     * @param chainName
     * @returns any Successful Response
     * @throws ApiError
     */
    static getAllChargebackConfigsChainConfigChargebackChainGet(chainName) {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/config/chargeback/chain',
            query: {
                'chain_name': chainName,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get All Chargeback Configs Chain V2
     * @param chainName
     * @param chainLevelBnames
     * @returns ChargebackConfigResponse Successful Response
     * @throws ApiError
     */
    static getAllChargebackConfigsChainV2ConfigChargebackChainV2Get(chainName, chainLevelBnames = false) {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/config/chargeback/chain/v2',
            query: {
                'chain_name': chainName,
                'chain_level_bnames': chainLevelBnames,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Create Or Update Chargeback Config
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static createOrUpdateChargebackConfigConfigChargebackCreateOrUpdatePost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/config/chargeback/create_or_update',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Create Or Update Chargeback Config V2
     * @param requestBody
     * @param chainLevelBnames
     * @returns ChargebackConfigUpdateResponse Successful Response
     * @throws ApiError
     */
    static createOrUpdateChargebackConfigV2ConfigChargebackCreateOrUpdateV2Post(requestBody, chainLevelBnames = false) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/config/chargeback/create_or_update/v2',
            query: {
                'chain_level_bnames': chainLevelBnames,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Onboard Chain Usernames
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static onboardChainUsernamesOnboardChainsUsernamesPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/onboard/chains/usernames',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Latest Onboarding Runs
     * @param chain
     * @param username
     * @param platform
     * @returns any Successful Response
     * @throws ApiError
     */
    static getLatestOnboardingRunsOnboardRecentRunsGet(chain, username, platform) {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/onboard/recent_runs',
            query: {
                'chain': chain,
                'username': username,
                'platform': platform,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Delete Unmapped Empty Bnames
     * @returns any Successful Response
     * @throws ApiError
     */
    static deleteUnmappedEmptyBnamesOnboardCleanUnmappedBnamesPost() {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/onboard/clean/unmapped/bnames',
        });
    }
    /**
     * Chains Add Store Reason Config
     * @param chain
     * @returns any Successful Response
     * @throws ApiError
     */
    static chainsAddStoreReasonConfigChainsChainOnboardPost(chain) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/chains/{chain}/onboard',
            path: {
                'chain': chain,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Callback
     * Handles the callback from intuit quickbooks online integration flow.
     *
     * :param code: Authorization code
     * :param realmId: Realm ID for the company
     * :param state: OAuth 2.0 state
     * @param code
     * @param realmId
     * @param state
     * @returns any Successful Response
     * @throws ApiError
     */
    static callbackIntuitCallbackGet(code, realmId, state) {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/intuit/callback',
            query: {
                'code': code,
                'realmId': realmId,
                'state': state,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Flattened Sheet
     * Get the flattened sheet for all the QBO companies linked to the user.
     *
     * :param username: Username used for the integration flow. eg: anuj@loopkitchen.xyz
     * @param username
     * @returns any Successful Response
     * @throws ApiError
     */
    static getFlattenedSheetAccountingCsvFlattenedGet(username) {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/accounting/csv/flattened',
            query: {
                'username': username,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Callback
     * @param code
     * @param state
     * @returns any Successful Response
     * @throws ApiError
     */
    static callbackXeroCallbackGet(code, state) {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/xero/callback',
            query: {
                'code': code,
                'state': state,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Create Accounting Sage Company
     * @param chain
     * @param loopUserId
     * @param redirect
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static createAccountingSageCompanySageCreateCompanyPost(chain, loopUserId, redirect, requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/sage/create/company',
            query: {
                'chain': chain,
                'loop_user_id': loopUserId,
                'redirect': redirect,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Create Accounting R365 Company
     * @param chain
     * @param name
     * @param r365Domain
     * @param username
     * @param password
     * @returns any Successful Response
     * @throws ApiError
     */
    static createAccountingR365CompanyR365CreateCompanyPost(chain, name, r365Domain, username, password) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/r365/create/company',
            query: {
                'chain': chain,
                'name': name,
                'r365_domain': r365Domain,
                'username': username,
                'password': password,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Update R365 Company Gl Codes
     * @param companyId
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static updateR365CompanyGlCodesR365CompanyGlCodesPost(companyId, requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/r365/company/gl/codes',
            query: {
                'company_id': companyId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Update R365 Company Classes
     * @param companyId
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static updateR365CompanyClassesR365CompanyClassesPost(companyId, requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/r365/company/classes',
            query: {
                'company_id': companyId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Migrate Freetext Mappings To R365
     * @param freetextCompanyId
     * @param r365CompanyId
     * @returns any Successful Response
     * @throws ApiError
     */
    static migrateFreetextMappingsToR365R365MigratePost(freetextCompanyId, r365CompanyId) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/r365/migrate',
            query: {
                'freetext_company_id': freetextCompanyId,
                'r365_company_id': r365CompanyId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Create Accounting Netsuite Company
     * @param chain
     * @param loopUserId
     * @param redirect
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static createAccountingNetsuiteCompanyNetsuiteCreateCompanyPost(chain, loopUserId, redirect, requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/netsuite/create/company',
            query: {
                'chain': chain,
                'loop_user_id': loopUserId,
                'redirect': redirect,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Ingest Journals
     * @returns any Successful Response
     * @throws ApiError
     */
    static ingestJournalsNetsuiteIngestJournalsPost() {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/netsuite/ingest/journals',
        });
    }
    /**
     * Get Manual Ingestion Report Types
     * @returns any Successful Response
     * @throws ApiError
     */
    static getManualIngestionReportTypesManualIngestReportTypesGet() {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/manual/ingest/report/types',
        });
    }
    /**
     * Ingest Report Csv
     * @param startDate
     * @param endDate
     * @param chain
     * @param platform
     * @param reportType
     * @param formData
     * @returns any Successful Response
     * @throws ApiError
     */
    static ingestReportCsvManualIngestReportPost(startDate, endDate, chain, platform, reportType, formData) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/manual/ingest/report',
            query: {
                'start_date': startDate,
                'end_date': endDate,
                'chain': chain,
                'platform': platform,
                'report_type': reportType,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Homepage Roi
     * @returns HomePageROIResponse Successful Response
     * @throws ApiError
     */
    static getHomepageRoiHomepageRoiPost() {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/homepage/roi',
        });
    }
    /**
     * Ingest Crunchtime Transactions
     * @param chain
     * @param formData
     * @returns any Successful Response
     * @throws ApiError
     */
    static ingestCrunchtimeTransactionsCrunchtimeIngestTransactionsPost(chain, formData) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/crunchtime/ingest/transactions',
            query: {
                'chain': chain,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Ingest Crunchtime Transactions
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static ingestCrunchtimeTransactionsCrunchtimeIngestTransactionsV2Post(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/crunchtime/ingest/transactions/v2',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Crunchtime Location Mappings
     * @param chain
     * @returns CrunchtimeLocationMappings Successful Response
     * @throws ApiError
     */
    static getCrunchtimeLocationMappingsCrunchtimeLocationMapGet(chain) {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/crunchtime/location_map',
            query: {
                'chain': chain,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Crunchtime Report Uploads
     * @param chain
     * @returns CrunchtimeUpload Successful Response
     * @throws ApiError
     */
    static getCrunchtimeReportUploadsCrunchtimeIngestionUploadsGet(chain) {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/crunchtime/ingestion/uploads',
            query: {
                'chain': chain,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Crunchtime Location Freshness Date
     * @param chain
     * @returns CrunchtimeLocationFreshnessDate Successful Response
     * @throws ApiError
     */
    static getCrunchtimeLocationFreshnessDateCrunchtimeLocationFreshnessDateGet(chain) {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/crunchtime/location/freshness/date',
            query: {
                'chain': chain,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Ingest Crunchtime Location Mapping
     * @param chain
     * @param formData
     * @returns any Successful Response
     * @throws ApiError
     */
    static ingestCrunchtimeLocationMappingCrunchtimeIngestLocationMapPost(chain, formData) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/crunchtime/ingest/location_map',
            query: {
                'chain': chain,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Ingest Crunchtime Location Mapping
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static ingestCrunchtimeLocationMappingCrunchtimeIngestLocationMapV2Post(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/crunchtime/ingest/location_map/v2',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Ingest Toast Location Mapping
     * @param chain
     * @param formData
     * @returns any Successful Response
     * @throws ApiError
     */
    static ingestToastLocationMappingToastIngestLocationMapPost(chain, formData) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/toast/ingest/location_map',
            query: {
                'chain': chain,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Service Health Status
     * This endpoint will be used to monitor service downtime (Healthcheck endpoint)
     * @returns any Successful Response
     * @throws ApiError
     */
    static serviceHealthStatusHealthGet() {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/health',
        });
    }
    /**
     * Get Email Id To Add
     * @param username
     * @returns any Successful Response
     * @throws ApiError
     */
    static getEmailIdToAddActionsGetEmailIdToAddPost(username) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/actions/get_email_id_to_add',
            query: {
                'username': username,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Create Mailslurp Inbox
     * @param username
     * @returns any Successful Response
     * @throws ApiError
     */
    static createMailslurpInboxActionsCreateMailslurpInboxPost(username) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/actions/create_mailslurp_inbox',
            query: {
                'username': username,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Check Progress Batch
     * @param batchWorkflowUuid
     * @returns OnboardingBatchResponse Successful Response
     * @throws ApiError
     */
    static checkProgressBatchActionsOnboardingCheckProgressBatchPost(batchWorkflowUuid) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/actions/onboarding/check_progress_batch',
            query: {
                'batch_workflow_uuid': batchWorkflowUuid,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Send Slack Message Endpoint
     * @param title
     * @param message
     * @param channel
     * @returns any Successful Response
     * @throws ApiError
     */
    static sendSlackMessageEndpointActionsInternalSendSlackMessagePost(title, message, channel) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/actions/internal/send_slack_message',
            query: {
                'title': title,
                'message': message,
                'channel': channel,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Trigger Onboard Batch Workflow
     * @param requestBody
     * @returns string Successful Response
     * @throws ApiError
     */
    static triggerOnboardBatchWorkflowActionsOnboardingOnboardBatchPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/actions/onboarding/onboard_batch/',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Run Customer Onboarding
     * @param chain
     * @param username
     * @param platform
     * @param userTriggered
     * @returns any Successful Response
     * @throws ApiError
     */
    static runCustomerOnboardingActionsOnboardingCustomerPost(chain, username, platform, userTriggered = false) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/actions/onboarding/customer',
            query: {
                'chain': chain,
                'username': username,
                'platform': platform,
                'user_triggered': userTriggered,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Trigger Credential Workflow
     * @param requestBody
     * @returns string Successful Response
     * @throws ApiError
     */
    static triggerCredentialWorkflowActionsOnboardingOnboardPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/actions/onboarding/onboard/',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Trigger Data Refresh Workflow Onboarding
     * @param days
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static triggerDataRefreshWorkflowOnboardingActionsOnboardingDataRefreshWorkflowPost(days, requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/actions/onboarding/data-refresh-workflow/',
            query: {
                'days': days,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Set Default Refresh Schedule Onboarding
     * @param chain
     * @returns any Successful Response
     * @throws ApiError
     */
    static setDefaultRefreshScheduleOnboardingActionsOnboardingSetDefaultRefreshPost(chain) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/actions/onboarding/set_default_refresh',
            query: {
                'chain': chain,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Trigger Refresh Data And Notify Workflow
     * @param requestBody
     * @returns string Successful Response
     * @throws ApiError
     */
    static triggerRefreshDataAndNotifyWorkflowActionsRefreshDataPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/actions/refresh_data/',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Trigger Onboard Grouping
     * @param org
     * @returns any Successful Response
     * @throws ApiError
     */
    static triggerOnboardGroupingActionsOnboardingTriggerGroupingPost(org) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/actions/onboarding/trigger_grouping/',
            query: {
                'org': org,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Trigger Query
     * @param query
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static triggerQueryActionsTriggerQueryPost(query, requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/actions/trigger_query/',
            query: {
                'query': query,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Trigger Onboard Batch Workflow
     * @param email
     * @returns any Successful Response
     * @throws ApiError
     */
    static triggerOnboardBatchWorkflowActionsOnboardingCreatePasswordPost(email) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/actions/onboarding/create_password/',
            query: {
                'email': email,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Create Org Config Firestore
     * @param orgName
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static createOrgConfigFirestoreActionsOnboardingCreateOrgConfigAndMailslurpPost(orgName, requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/actions/onboarding/create_org_config_and_mailslurp/',
            query: {
                'org_name': orgName,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Map Users To Org
     * Maps a list of users to a single org
     *
     * Parameters
     * ----------
     * org_name : str
     * The org name which will be mapped to all users.
     * user_emails : List[str]
     * List of email ids(str) to map to the given org_name.
     * create_new_user: bool
     * New users will be created if true with given email id and default values.
     * user_names: List[str]
     * List of usernames to map to the given org_name.
     * user_phones: List[str]
     * List of phones(str) to map to the given org_name.
     * @param orgName
     * @param createNewUser
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static mapUsersToOrgActionsOnboardingMapUsersToOrgPost(orgName, createNewUser, requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/actions/onboarding/map_users_to_org/',
            query: {
                'org_name': orgName,
                'create_new_user': createNewUser,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Add Users To Org
     * @param org
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static addUsersToOrgActionsOnboardingAddUsersToOrgPost(org, requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/actions/onboarding/add_users_to_org/',
            query: {
                'org': org,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Download B Name Slug Mapping
     * @param orgName
     * @returns any Successful Response
     * @throws ApiError
     */
    static downloadBNameSlugMappingActionsBulkDownloadBNameSlugMappingOrgNameGet(orgName) {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/actions/bulk/download/b_name_slug_mapping/{org_name}',
            path: {
                'org_name': orgName,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Download Stores And B Names
     * @param orgName
     * @returns any Successful Response
     * @throws ApiError
     */
    static downloadStoresAndBNamesActionsBulkDownloadStoresAndBNamesOrgNamePost(orgName) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/actions/bulk/download_stores_and_b_names/{org_name}',
            path: {
                'org_name': orgName,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Update Stores And B Names
     * 1. Takes in a CSV file with the following columns (slug, vb_name, vb_address, b_name)
     * 2. Updates the b_name_slug_mapping collection with the new b_names.
     * 3. Updates the stores collection with the new mapping and also updates vb_name.
     * 4. Returns slugs that were not present in the store_details collection.
     * @param orgName
     * @param formData
     * @returns string Successful Response
     * @throws ApiError
     */
    static updateStoresAndBNamesActionsBulkUpdateStoresAndBNamesOrgNamePost(orgName, formData) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/actions/bulk/update_stores_and_b_names/{org_name}',
            path: {
                'org_name': orgName,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Bulk Delete Slugs
     * @param orgName
     * @param requestBody
     * @returns string Successful Response
     * @throws ApiError
     */
    static bulkDeleteSlugsActionsBulkDeleteOrgNameDelete(orgName, requestBody) {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/actions/bulk/delete/{org_name}',
            path: {
                'org_name': orgName,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Update Chain For Slugs
     * @param orgName
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static updateChainForSlugsActionsBulkUpdateChainOrgNamePost(orgName, requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/actions/bulk/update/chain/{org_name}',
            path: {
                'org_name': orgName,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Update B Name Slug Mapping Csv
     * @param orgName
     * @param formData
     * @returns any Successful Response
     * @throws ApiError
     */
    static updateBNameSlugMappingCsvActionsBulkUpdateBNameSlugMappingCsvOrgNamePost(orgName, formData) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/actions/bulk/update/b_name_slug_mapping_csv/{org_name}',
            path: {
                'org_name': orgName,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Download Collection
     * @param collectionName
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static downloadCollectionActionsBulkDownloadFirestoreCollectionNamePost(collectionName, requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/actions/bulk/download/firestore/{collection_name}',
            path: {
                'collection_name': collectionName,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Download Store Details
     * Download csv for store details for a given org
     *
     * Parameters
     * ----------
     * org_name : str
     * The org name for which store details will be downloaded.
     * @param orgName
     * @returns any Successful Response
     * @throws ApiError
     */
    static downloadStoreDetailsActionsBulkDownloadStoreDetailsOrgNameGet(orgName) {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/actions/bulk/download/store_details/{org_name}',
            path: {
                'org_name': orgName,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Update Store Details Csv
     * Update store details for a given org
     *
     * Parameters
     * ----------
     * file : csv
     * The csv file containing store details to be updated.
     * @param orgName
     * @param formData
     * @returns any Successful Response
     * @throws ApiError
     */
    static updateStoreDetailsCsvActionsBulkUpdateStoreDetailsCsvOrgNamePost(orgName, formData) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/actions/bulk/update/store_details_csv/{org_name}',
            path: {
                'org_name': orgName,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Check Progress
     * @param workflowUuid
     * @returns OnboardingProgressResponse Successful Response
     * @throws ApiError
     */
    static checkProgressActionsOnboardingCheckProgressPost(workflowUuid) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/actions/onboarding/check_progress',
            query: {
                'workflowUuid': workflowUuid,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Stop Marketing Campaign
     * @param slug
     * @param campaignId
     * @returns any Successful Response
     * @throws ApiError
     */
    static stopMarketingCampaignStopMarketingCampaignPut(slug, campaignId) {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/stop_marketing_campaign',
            query: {
                'slug': slug,
                'campaignId': campaignId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Is Marketing Campaign Active
     * @param slug
     * @param campaignId
     * @returns boolean Successful Response
     * @throws ApiError
     */
    static isMarketingCampaignActiveIsMarketingCampaignActiveGet(slug, campaignId) {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/is_marketing_campaign_active',
            query: {
                'slug': slug,
                'campaignId': campaignId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Change Menu Hours
     * @param slug
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static changeMenuHoursChangeMenuHoursPut(slug, requestBody) {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/change_menu_hours',
            query: {
                'slug': slug,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Change Ad Budget
     * @param slug
     * @param adBudget
     * @returns any Successful Response
     * @throws ApiError
     */
    static changeAdBudgetChangeAdBudgetPut(slug, adBudget) {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/change_ad_budget',
            query: {
                'slug': slug,
                'adBudget': adBudget,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Change Prep Time
     * @param slug
     * @param prepTime
     * @returns any Successful Response
     * @throws ApiError
     */
    static changePrepTimeChangePrepTimePut(slug, prepTime) {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/change_prep_time',
            query: {
                'slug': slug,
                'prepTime': prepTime,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Review Reply
     * @param reviewId
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static reviewReplyReviewReplyPost(reviewId, requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/review/reply',
            query: {
                'reviewId': reviewId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Offline Stores
     * @returns any Successful Response
     * @throws ApiError
     */
    static getOfflineStoresStoresOfflineGet() {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/stores/offline',
        });
    }
    /**
     * Refresh Store Availability
     * @param slug
     * @returns StoreAvailabilityRefreshResponse Successful Response
     * @throws ApiError
     */
    static refreshStoreAvailabilityStoreAvailabilityRefreshSlugPost(slug) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/store_availability/refresh/{slug}',
            path: {
                'slug': slug,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Set Stores Status
     * Sets the availability status of the store to the given status.
     * Supports all platforms.
     * @param requestBody
     * @param manual
     * @returns dao__store_availability__StoreAvailability Successful Response
     * @throws ApiError
     */
    static setStoresStatusSetStoreStatusPost(requestBody, manual = true) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/set/store/status',
            query: {
                'manual': manual,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Set Stores Status Bulk
     * Sets the list of stores to online status. Supports all platforms.
     * @param requestBody
     * @param manual
     * @returns StoreAvailabilityResponse Successful Response
     * @throws ApiError
     */
    static setStoresStatusBulkSetStoreOnlineBulkPost(requestBody, manual = true) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/set/store/online/bulk',
            query: {
                'manual': manual,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Dispute Order
     * @param orderId
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static disputeOrderDisputeOrderPut(orderId, requestBody) {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/dispute_order',
            query: {
                'order_id': orderId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Payload For Dispute
     * @param requestBody
     * @returns DisputeData Successful Response
     * @throws ApiError
     */
    static getPayloadForDisputeGetPayloadForDisputePost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/get_payload_for_dispute',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Status Reasons
     * Get status reasons for a store
     * :@param  slug: store id of which we want the status reasons
     * :@return: status reasons for the store
     * @param slug Get reason for the store to be closed
     * @returns StatusReasonResponseModel Successful Response
     * @throws ApiError
     */
    static getStatusReasonsGetBackendStatusReasonGet(slug) {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/get_backend_status_reason',
            query: {
                'slug': slug,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Status Reasons Bulk
     * Get status reasons for stores in bulk
     * :@param  slugs: list of  store id of which we want the status reasons
     * :@return: list of status reasons for the store
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static getStatusReasonsBulkGetBackendStatusReasonBulkPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/get_backend_status_reason_bulk',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Stop Campaigns
     * Each campaign dict must have two fields 'id' and 'slug'
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static stopCampaignsStopCampaignPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/stop_campaign',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Campaign Types
     * @returns string Successful Response
     * @throws ApiError
     */
    static getCampaignTypesGetCampaignTypesGet() {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/get_campaign_types',
        });
    }
    /**
     * Get Recommended Campaigns
     * @param campaignType
     * @param requestBody
     * @param limit
     * @param offset
     * @returns RecommendedCampaignResponse Successful Response
     * @throws ApiError
     */
    static getRecommendedCampaignsGetRecommendedCampaignsPost(campaignType, requestBody, limit = 30, offset) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/get_recommended_campaigns',
            query: {
                'campaign_type': campaignType,
                'limit': limit,
                'offset': offset,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Active Campaigns
     * @param campaignType
     * @param requestBody
     * @param limit
     * @param offset
     * @returns ActiveCampaignResponse Successful Response
     * @throws ApiError
     */
    static getActiveCampaignsGetActiveCampaignsPost(campaignType, requestBody, limit = 30, offset) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/get_active_campaigns',
            query: {
                'campaign_type': campaignType,
                'limit': limit,
                'offset': offset,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Start Campaign
     * The campaign dict must have the following fields 'slug', 'campaign_type', and the optional fields 'days',
     * 'audience', 'weekly_budget', 'spend_x', 'save_y', 'item_id', 'minimum_spend', 'discount_percent'
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static startCampaignStartCampaignPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/start_campaign',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Start Campaigns Bulk
     * The csv rows must have the following fields 'slug', 'campaign_type', and the optional fields 'days',
     * 'audience', 'weekly_budget', 'spend_x', 'save_y', 'item_id', 'minimum_spend', 'discount_percent'
     * @param formData
     * @returns any Successful Response
     * @throws ApiError
     */
    static startCampaignsBulkStartCampaignsBulkPost(formData) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/start_campaigns_bulk',
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Delete Onboard Credentials
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static deleteOnboardCredentialsDeleteCredentialsPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/delete_credentials',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Remap Onboard Credentials
     * @param prevChain
     * @param newChain
     * @param username
     * @returns any Successful Response
     * @throws ApiError
     */
    static remapOnboardCredentialsRemapCredentialsPost(prevChain, newChain, username) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/remap_credentials',
            query: {
                'prev_chain': prevChain,
                'new_chain': newChain,
                'username': username,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Add Onboard Credentials
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static addOnboardCredentialsAddOnboardCredentialsPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/add_onboard_credentials',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Add Chain
     * @param chain
     * @returns any Successful Response
     * @throws ApiError
     */
    static addChainChainsCreatePost(chain) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/chains/create',
            query: {
                'chain': chain,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Access Emails
     * @param username
     * @returns any Successful Response
     * @throws ApiError
     */
    static getAccessEmailsUsernameAccessEmailsGet(username) {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/username/access_emails',
            query: {
                'username': username,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Run Ingestion Dbt
     * @returns any Successful Response
     * @throws ApiError
     */
    static runIngestionDbtIngestionDbtRefreshPost() {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/ingestion/dbt/refresh',
        });
    }
    /**
     * Run Dbt Full Refresh
     * @returns any Successful Response
     * @throws ApiError
     */
    static runDbtFullRefreshDbtRefreshFullPost() {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dbt/refresh/full',
        });
    }
    /**
     * Add Backup User For Store
     * @param storeId
     * @param backupUsername
     * @param platform
     * @returns any Successful Response
     * @throws ApiError
     */
    static addBackupUserForStoreAddBackupUserForStorePost(storeId, backupUsername, platform) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/add_backup_user_for_store',
            query: {
                'store_id': storeId,
                'backup_username': backupUsername,
                'platform': platform,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Add Backup Users For Chain
     * @param chainName
     * @param platform
     * @param username
     * @param createInbox
     * @returns any Successful Response
     * @throws ApiError
     */
    static addBackupUsersForChainAddBackupUsersForChainPost(chainName, platform, username, createInbox = true) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/add_backup_users_for_chain',
            query: {
                'chain_name': chainName,
                'platform': platform,
                'username': username,
                'create_inbox': createInbox,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Add Backup Users
     * @returns any Successful Response
     * @throws ApiError
     */
    static addBackupUsersAddBackupUsersGet() {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/add_backup_users',
        });
    }
    /**
     * Get All Files
     * @param path
     * @returns any Successful Response
     * @throws ApiError
     */
    static getAllFilesFilesAllGet(path) {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/files/all',
            query: {
                'path': path,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Order Breakdown
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static getOrderBreakdownFinanceOrderBreakdownPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/finance/order/breakdown',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Attribution Type Transactions
     * @param attributionType
     * @param requestBody
     * @param limit
     * @param offset
     * @param orderBy
     * @returns AttributedOrderTransactions Successful Response
     * @throws ApiError
     */
    static getAttributionTypeTransactionsFinanceOrderTransactionsPost(attributionType, requestBody, limit = 30, offset, orderBy = 'transaction_timestamp') {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/finance/order/transactions',
            query: {
                'attribution_type': attributionType,
                'limit': limit,
                'offset': offset,
                'order_by': orderBy,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Order Transactions B Name
     * @param requestBody
     * @param limit
     * @param offset
     * @param orderBy
     * @param ascending
     * @returns any Successful Response
     * @throws ApiError
     */
    static getOrderTransactionsBNameFinanceOrderTransactionsBNamePost(requestBody, limit = 30, offset, orderBy = 'order_date', ascending = false) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/finance/order/transactions/b_name',
            query: {
                'limit': limit,
                'offset': offset,
                'order_by': orderBy,
                'ascending': ascending,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Payout Breakdown
     * @param requestBody
     * @returns PayoutBreakdownResponse Successful Response
     * @throws ApiError
     */
    static getPayoutBreakdownFinancePayoutBreakdownPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/finance/payout/breakdown',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Payout Transactions
     * @param requestBody
     * @param limit
     * @param offset
     * @param orderBy
     * @param verified
     * @returns FinancePayoutTransactionsResponse Successful Response
     * @throws ApiError
     */
    static getPayoutTransactionsFinancePayoutTransactionsPost(requestBody, limit = 30, offset, orderBy = 'payout_date', verified = false) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/finance/payout/transactions',
            query: {
                'limit': limit,
                'offset': offset,
                'order_by': orderBy,
                'verified': verified,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Payout Transactions B Name
     * @param requestBody
     * @param limit
     * @param offset
     * @param orderBy
     * @param ascending
     * @returns FinancePayoutTransactionsBNameResponse Successful Response
     * @throws ApiError
     */
    static getPayoutTransactionsBNameFinancePayoutTransactionsBNamePost(requestBody, limit = 30, offset, orderBy = 'payout_date', ascending = false) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/finance/payout/transactions/b_name',
            query: {
                'limit': limit,
                'offset': offset,
                'order_by': orderBy,
                'ascending': ascending,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Order Transactions By Month
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static getOrderTransactionsByMonthFinanceOrderTransactionsMonthPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/finance/order/transactions/month',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Payout Breakdown Analytics
     * @param requestBody
     * @param verified
     * @returns any Successful Response
     * @throws ApiError
     */
    static getPayoutBreakdownAnalyticsFinancePayoutAnalyticsPost(requestBody, verified = false) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/finance/payout/analytics',
            query: {
                'verified': verified,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Bank Transactions
     * @param requestBody
     * @returns FinanceBankTransactionsResponse Successful Response
     * @throws ApiError
     */
    static getBankTransactionsFinanceBankTransactionsPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/finance/bank/transactions',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Upload Bank Transactions
     * @param formData
     * @returns any Successful Response
     * @throws ApiError
     */
    static uploadBankTransactionsFinanceBankTransactionsUploadPost(formData) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/finance/bank/transactions/upload',
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Transaction By Tx Date
     * @param requestBody
     * @returns FinanceTransactionsByTxDateResponse Successful Response
     * @throws ApiError
     */
    static getTransactionByTxDateFinanceTransactionsTxDatePost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/finance/transactions/tx_date',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Chargeback Transactions
     * @param requestBody
     * @param limit
     * @param offset
     * @param orderBy
     * @param payoutType
     * @returns ChargebackGroupedOrders Successful Response
     * @throws ApiError
     */
    static getChargebackTransactionsChargebacksTransactionsPost(requestBody, limit = 30, offset, orderBy = 'order_id', payoutType) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/chargebacks/transactions',
            query: {
                'limit': limit,
                'offset': offset,
                'order_by': orderBy,
                'payout_type': payoutType,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Chargeback Transactions Unattributed
     * @param requestBody
     * @param limit
     * @param offset
     * @param orderBy
     * @returns ChargebackUnattributedTransactions Successful Response
     * @throws ApiError
     */
    static getChargebackTransactionsUnattributedChargebacksTransactionsUnattributedPost(requestBody, limit = 30, offset, orderBy = 'payout_date') {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/chargebacks/transactions/unattributed',
            query: {
                'limit': limit,
                'offset': offset,
                'order_by': orderBy,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Chargeback Transactions
     * @param attributionType
     * @param requestBody
     * @returns ChargebackTransactionSummary Successful Response
     * @throws ApiError
     */
    static getChargebackTransactionsChargebacksTransactionsSummaryPost(attributionType, requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/chargebacks/transactions/summary',
            query: {
                'attribution_type': attributionType,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Chargeback Orders
     * @param requestBody
     * @returns ChargebackOrders Successful Response
     * @throws ApiError
     */
    static getChargebackOrdersChargebacksOrdersPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/chargebacks/orders',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Chargeback Orders V2
     * @param requestBody
     * @param limit
     * @param offset
     * @param orderBy
     * @returns ChargebackOrdersV2 Successful Response
     * @throws ApiError
     */
    static getChargebackOrdersV2ChargebacksOrdersV2Post(requestBody, limit = 30, offset, orderBy = 'order_id') {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/chargebacks/orders/v2',
            query: {
                'limit': limit,
                'offset': offset,
                'order_by': orderBy,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Chargeback Orders Summary
     * @param requestBody
     * @returns ChargebackOrderSummary Successful Response
     * @throws ApiError
     */
    static getChargebackOrdersSummaryChargebacksOrdersSummaryPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/chargebacks/orders/summary',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Chargeback Orders Summary V2
     * @param requestBody
     * @returns ChargebackOrderSummaryV2 Successful Response
     * @throws ApiError
     */
    static getChargebackOrdersSummaryV2ChargebacksOrdersSummaryV2Post(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/chargebacks/orders/summary/v2',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Chargeback Order Json
     * @param orderId
     * @param orderTimestamp
     * @returns any Successful Response
     * @throws ApiError
     */
    static getChargebackOrderJsonChargebacksOrdersOrderIdPost(orderId, orderTimestamp) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/chargebacks/orders/{order_id}',
            path: {
                'order_id': orderId,
            },
            query: {
                'order_timestamp': orderTimestamp,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Chargeback Reversals
     * @param chain
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static getChargebackReversalsChargebacksReversalsChainPost(chain, requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/chargebacks/reversals/{chain}',
            path: {
                'chain': chain,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Chargeback Matrix
     * @param requestBody
     * @returns ChargebackMatrix Successful Response
     * @throws ApiError
     */
    static getChargebackMatrixChargebacksMatrixPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/chargebacks/matrix',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Update Chargeback Tracking On Loop Dashboard
     * @returns any Successful Response
     * @throws ApiError
     */
    static updateChargebackTrackingOnLoopDashboardUpdateChargebackTrackingPost() {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/update_chargeback_tracking',
        });
    }
    /**
     * Call Benchmarks Competition Metrics
     * @param requestBody
     * @returns BenchmarkCompetitionMetrics Successful Response
     * @throws ApiError
     */
    static callBenchmarksCompetitionMetricsApiBenchmarksCompetitionMetricsPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/benchmarks/competition_metrics',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Benchmarks Competition Metrics
     * @param requestBody
     * @param isPaginated
     * @returns BenchmarkCompetitionMetricsPaginated Successful Response
     * @throws ApiError
     */
    static callBenchmarksCompetitionMetricsApiPaginatedBenchmarksCompetitionMetricsPost(requestBody, isPaginated = true) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/paginated/benchmarks/competition_metrics',
            query: {
                'is_paginated': isPaginated,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Benchmarks Competition Metrics Daterangecompare
     * @param requestBody
     * @returns BenchmarkCompetitionMetricsDateRangeCompare Successful Response
     * @throws ApiError
     */
    static benchmarksCompetitionMetricsDateRangeCompareApiDateRangeCompareBenchmarksCompetitionMetricsPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/benchmarks/competition_metrics',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Benchmarks Competition Metrics Daterangecomparegranular
     * @param requestBody
     * @returns BenchmarkCompetitionMetricsDateRangeCompareGranular Successful Response
     * @throws ApiError
     */
    static benchmarksCompetitionMetricsDateRangeCompareGranularApiDateRangeCompareGranularBenchmarksCompetitionMetricsPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/granular/benchmarks/competition_metrics',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Export Benchmarks Competition Metrics
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static exportBenchmarksCompetitionMetricsApiExportBenchmarksCompetitionMetricsPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/export/benchmarks/competition_metrics',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Kpi Dashboard Chargebackdatewise
     * @param requestBody
     * @returns ChargebackDatewise Successful Response
     * @throws ApiError
     */
    static callKpiDashboardChargebackDatewiseApiKpiDashboardChargebackDatewisePost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/kpi_dashboard/ChargebackDatewise',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Kpi Dashboard Chargebackdatewise
     * @param requestBody
     * @param isPaginated
     * @returns ChargebackDatewisePaginated Successful Response
     * @throws ApiError
     */
    static callKpiDashboardChargebackDatewiseApiPaginatedKpiDashboardChargebackDatewisePost(requestBody, isPaginated = true) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/paginated/kpi_dashboard/ChargebackDatewise',
            query: {
                'is_paginated': isPaginated,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Kpi Dashboard Chargebackdatewise Daterangecompare
     * @param requestBody
     * @returns ChargebackDatewiseDateRangeCompare Successful Response
     * @throws ApiError
     */
    static kpiDashboardChargebackDatewiseDateRangeCompareApiDateRangeCompareKpiDashboardChargebackDatewisePost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/kpi_dashboard/ChargebackDatewise',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Kpi Dashboard Chargebackdatewise Daterangecomparegranular
     * @param requestBody
     * @returns ChargebackDatewiseDateRangeCompareGranular Successful Response
     * @throws ApiError
     */
    static kpiDashboardChargebackDatewiseDateRangeCompareGranularApiDateRangeCompareGranularKpiDashboardChargebackDatewisePost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/granular/kpi_dashboard/ChargebackDatewise',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Export Kpi Dashboard Chargebackdatewise
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static exportKpiDashboardChargebackDatewiseApiExportKpiDashboardChargebackDatewisePost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/export/kpi_dashboard/ChargebackDatewise',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Storeautoturnonorders
     * @param requestBody
     * @returns dynamic__models__StoreAutoTurnOnOrders__StoreAutoTurnOnOrders Successful Response
     * @throws ApiError
     */
    static callStoreAutoTurnOnOrdersApiStoreAutoTurnOnOrdersPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/StoreAutoTurnOnOrders',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Storeautoturnonorders
     * @param requestBody
     * @param isPaginated
     * @returns StoreAutoTurnOnOrdersPaginated Successful Response
     * @throws ApiError
     */
    static callStoreAutoTurnOnOrdersApiPaginatedStoreAutoTurnOnOrdersPost(requestBody, isPaginated = true) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/paginated/StoreAutoTurnOnOrders',
            query: {
                'is_paginated': isPaginated,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Storeautoturnonorders Daterangecompare
     * @param requestBody
     * @returns StoreAutoTurnOnOrdersDateRangeCompare Successful Response
     * @throws ApiError
     */
    static storeAutoTurnOnOrdersDateRangeCompareApiDateRangeCompareStoreAutoTurnOnOrdersPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/StoreAutoTurnOnOrders',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Storeautoturnonorders Daterangecomparegranular
     * @param requestBody
     * @returns StoreAutoTurnOnOrdersDateRangeCompareGranular Successful Response
     * @throws ApiError
     */
    static storeAutoTurnOnOrdersDateRangeCompareGranularApiDateRangeCompareGranularStoreAutoTurnOnOrdersPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/granular/StoreAutoTurnOnOrders',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Export Storeautoturnonorders
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static exportStoreAutoTurnOnOrdersApiExportStoreAutoTurnOnOrdersPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/export/StoreAutoTurnOnOrders',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Pos List Card Types
     * @param requestBody
     * @returns PosCardType Successful Response
     * @throws ApiError
     */
    static callPosListCardTypesApiPosListCardTypesPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/pos/list_card_types',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Pos List Card Types
     * @param requestBody
     * @param isPaginated
     * @returns PosCardTypePaginated Successful Response
     * @throws ApiError
     */
    static callPosListCardTypesApiPaginatedPosListCardTypesPost(requestBody, isPaginated = true) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/paginated/pos/list_card_types',
            query: {
                'is_paginated': isPaginated,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Pos List Card Types Daterangecompare
     * @param requestBody
     * @returns PosCardTypeDateRangeCompare Successful Response
     * @throws ApiError
     */
    static posListCardTypesDateRangeCompareApiDateRangeComparePosListCardTypesPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/pos/list_card_types',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Pos List Card Types Daterangecomparegranular
     * @param requestBody
     * @returns PosCardTypeDateRangeCompareGranular Successful Response
     * @throws ApiError
     */
    static posListCardTypesDateRangeCompareGranularApiDateRangeCompareGranularPosListCardTypesPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/granular/pos/list_card_types',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Export Pos List Card Types
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static exportPosListCardTypesApiExportPosListCardTypesPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/export/pos/list_card_types',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Order Accuracy Error Category Subcategory Counts
     * @param requestBody
     * @returns ErrorCategorySubcategoryCounts Successful Response
     * @throws ApiError
     */
    static callOrderAccuracyErrorCategorySubcategoryCountsApiOrderAccuracyErrorCategorySubcategoryCountsPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/order_accuracy/error_category_subcategory_counts',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Order Accuracy Error Category Subcategory Counts
     * @param requestBody
     * @param isPaginated
     * @returns ErrorCategorySubcategoryCountsPaginated Successful Response
     * @throws ApiError
     */
    static callOrderAccuracyErrorCategorySubcategoryCountsApiPaginatedOrderAccuracyErrorCategorySubcategoryCountsPost(requestBody, isPaginated = true) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/paginated/order_accuracy/error_category_subcategory_counts',
            query: {
                'is_paginated': isPaginated,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Order Accuracy Error Category Subcategory Counts Daterangecompare
     * @param requestBody
     * @returns ErrorCategorySubcategoryCountsDateRangeCompare Successful Response
     * @throws ApiError
     */
    static orderAccuracyErrorCategorySubcategoryCountsDateRangeCompareApiDateRangeCompareOrderAccuracyErrorCategorySubcategoryCountsPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/order_accuracy/error_category_subcategory_counts',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Order Accuracy Error Category Subcategory Counts Daterangecomparegranular
     * @param requestBody
     * @returns ErrorCategorySubcategoryCountsDateRangeCompareGranular Successful Response
     * @throws ApiError
     */
    static orderAccuracyErrorCategorySubcategoryCountsDateRangeCompareGranularApiDateRangeCompareGranularOrderAccuracyErrorCategorySubcategoryCountsPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/granular/order_accuracy/error_category_subcategory_counts',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Export Order Accuracy Error Category Subcategory Counts
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static exportOrderAccuracyErrorCategorySubcategoryCountsApiExportOrderAccuracyErrorCategorySubcategoryCountsPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/export/order_accuracy/error_category_subcategory_counts',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Transactionsbypayoutid
     * @param requestBody
     * @returns TransactionsByPayoutId Successful Response
     * @throws ApiError
     */
    static callTransactionsByPayoutIdApiTransactionsByPayoutIdPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/TransactionsByPayoutId',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Transactionsbypayoutid
     * @param requestBody
     * @param isPaginated
     * @returns TransactionsByPayoutIdPaginated Successful Response
     * @throws ApiError
     */
    static callTransactionsByPayoutIdApiPaginatedTransactionsByPayoutIdPost(requestBody, isPaginated = true) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/paginated/TransactionsByPayoutId',
            query: {
                'is_paginated': isPaginated,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Transactionsbypayoutid Daterangecompare
     * @param requestBody
     * @returns TransactionsByPayoutIdDateRangeCompare Successful Response
     * @throws ApiError
     */
    static transactionsByPayoutIdDateRangeCompareApiDateRangeCompareTransactionsByPayoutIdPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/TransactionsByPayoutId',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Transactionsbypayoutid Daterangecomparegranular
     * @param requestBody
     * @returns TransactionsByPayoutIdDateRangeCompareGranular Successful Response
     * @throws ApiError
     */
    static transactionsByPayoutIdDateRangeCompareGranularApiDateRangeCompareGranularTransactionsByPayoutIdPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/granular/TransactionsByPayoutId',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Export Transactionsbypayoutid
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static exportTransactionsByPayoutIdApiExportTransactionsByPayoutIdPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/export/TransactionsByPayoutId',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Drill Down Generated Metricskpi Unique Values
     * @param requestBody
     * @returns UniqueValuesForColumn Successful Response
     * @throws ApiError
     */
    static callDrillDownGeneratedMetricsKpiUniqueValuesApiDrillDownGeneratedMetricsKpiUniqueValuesPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/drill_down_generated/MetricsKPI/unique_values',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Drill Down Generated Metricskpi Unique Values
     * @param requestBody
     * @param isPaginated
     * @returns UniqueValuesForColumnPaginated Successful Response
     * @throws ApiError
     */
    static callDrillDownGeneratedMetricsKpiUniqueValuesApiPaginatedDrillDownGeneratedMetricsKpiUniqueValuesPost(requestBody, isPaginated = true) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/paginated/drill_down_generated/MetricsKPI/unique_values',
            query: {
                'is_paginated': isPaginated,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Drill Down Generated Metricskpi Unique Values Daterangecompare
     * @param requestBody
     * @returns UniqueValuesForColumnDateRangeCompare Successful Response
     * @throws ApiError
     */
    static drillDownGeneratedMetricsKpiUniqueValuesDateRangeCompareApiDateRangeCompareDrillDownGeneratedMetricsKpiUniqueValuesPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/drill_down_generated/MetricsKPI/unique_values',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Drill Down Generated Metricskpi Unique Values Daterangecomparegranular
     * @param requestBody
     * @returns UniqueValuesForColumnDateRangeCompareGranular Successful Response
     * @throws ApiError
     */
    static drillDownGeneratedMetricsKpiUniqueValuesDateRangeCompareGranularApiDateRangeCompareGranularDrillDownGeneratedMetricsKpiUniqueValuesPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/granular/drill_down_generated/MetricsKPI/unique_values',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Export Drill Down Generated Metricskpi Unique Values
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static exportDrillDownGeneratedMetricsKpiUniqueValuesApiExportDrillDownGeneratedMetricsKpiUniqueValuesPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/export/drill_down_generated/MetricsKPI/unique_values',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Issue Discovery Insights Item Errors By Time
     * @param requestBody
     * @returns ItemErrorsByTime Successful Response
     * @throws ApiError
     */
    static callIssueDiscoveryInsightsItemErrorsByTimeApiIssueDiscoveryInsightsItemErrorsByTimePost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/issue_discovery/insights/item_errors/by_time',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Issue Discovery Insights Item Errors By Time
     * @param requestBody
     * @param isPaginated
     * @returns ItemErrorsByTimePaginated Successful Response
     * @throws ApiError
     */
    static callIssueDiscoveryInsightsItemErrorsByTimeApiPaginatedIssueDiscoveryInsightsItemErrorsByTimePost(requestBody, isPaginated = true) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/paginated/issue_discovery/insights/item_errors/by_time',
            query: {
                'is_paginated': isPaginated,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Issue Discovery Insights Item Errors By Time Daterangecompare
     * @param requestBody
     * @returns ItemErrorsByTimeDateRangeCompare Successful Response
     * @throws ApiError
     */
    static issueDiscoveryInsightsItemErrorsByTimeDateRangeCompareApiDateRangeCompareIssueDiscoveryInsightsItemErrorsByTimePost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/issue_discovery/insights/item_errors/by_time',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Issue Discovery Insights Item Errors By Time Daterangecomparegranular
     * @param requestBody
     * @returns ItemErrorsByTimeDateRangeCompareGranular Successful Response
     * @throws ApiError
     */
    static issueDiscoveryInsightsItemErrorsByTimeDateRangeCompareGranularApiDateRangeCompareGranularIssueDiscoveryInsightsItemErrorsByTimePost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/granular/issue_discovery/insights/item_errors/by_time',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Export Issue Discovery Insights Item Errors By Time
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static exportIssueDiscoveryInsightsItemErrorsByTimeApiExportIssueDiscoveryInsightsItemErrorsByTimePost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/export/issue_discovery/insights/item_errors/by_time',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Storeavailability
     * @param requestBody
     * @returns dynamic__models__StoreAvailability__StoreAvailability Successful Response
     * @throws ApiError
     */
    static callStoreAvailabilityApiStoreAvailabilityPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/StoreAvailability',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Storeavailability
     * @param requestBody
     * @param isPaginated
     * @returns StoreAvailabilityPaginated Successful Response
     * @throws ApiError
     */
    static callStoreAvailabilityApiPaginatedStoreAvailabilityPost(requestBody, isPaginated = true) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/paginated/StoreAvailability',
            query: {
                'is_paginated': isPaginated,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Storeavailability Daterangecompare
     * @param requestBody
     * @returns StoreAvailabilityDateRangeCompare Successful Response
     * @throws ApiError
     */
    static storeAvailabilityDateRangeCompareApiDateRangeCompareStoreAvailabilityPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/StoreAvailability',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Storeavailability Daterangecomparegranular
     * @param requestBody
     * @returns StoreAvailabilityDateRangeCompareGranular Successful Response
     * @throws ApiError
     */
    static storeAvailabilityDateRangeCompareGranularApiDateRangeCompareGranularStoreAvailabilityPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/granular/StoreAvailability',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Export Storeavailability
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static exportStoreAvailabilityApiExportStoreAvailabilityPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/export/StoreAvailability',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Kpi Dashboard Lostsaledatewise
     * @param requestBody
     * @returns LostSaleDatewise Successful Response
     * @throws ApiError
     */
    static callKpiDashboardLostSaleDatewiseApiKpiDashboardLostSaleDatewisePost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/kpi_dashboard/LostSaleDatewise',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Kpi Dashboard Lostsaledatewise
     * @param requestBody
     * @param isPaginated
     * @returns LostSaleDatewisePaginated Successful Response
     * @throws ApiError
     */
    static callKpiDashboardLostSaleDatewiseApiPaginatedKpiDashboardLostSaleDatewisePost(requestBody, isPaginated = true) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/paginated/kpi_dashboard/LostSaleDatewise',
            query: {
                'is_paginated': isPaginated,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Kpi Dashboard Lostsaledatewise Daterangecompare
     * @param requestBody
     * @returns LostSaleDatewiseDateRangeCompare Successful Response
     * @throws ApiError
     */
    static kpiDashboardLostSaleDatewiseDateRangeCompareApiDateRangeCompareKpiDashboardLostSaleDatewisePost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/kpi_dashboard/LostSaleDatewise',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Kpi Dashboard Lostsaledatewise Daterangecomparegranular
     * @param requestBody
     * @returns LostSaleDatewiseDateRangeCompareGranular Successful Response
     * @throws ApiError
     */
    static kpiDashboardLostSaleDatewiseDateRangeCompareGranularApiDateRangeCompareGranularKpiDashboardLostSaleDatewisePost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/granular/kpi_dashboard/LostSaleDatewise',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Export Kpi Dashboard Lostsaledatewise
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static exportKpiDashboardLostSaleDatewiseApiExportKpiDashboardLostSaleDatewisePost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/export/kpi_dashboard/LostSaleDatewise',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Pos List Locations
     * @param requestBody
     * @returns PosLocation Successful Response
     * @throws ApiError
     */
    static callPosListLocationsApiPosListLocationsPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/pos/list_locations',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Pos List Locations
     * @param requestBody
     * @param isPaginated
     * @returns PosLocationPaginated Successful Response
     * @throws ApiError
     */
    static callPosListLocationsApiPaginatedPosListLocationsPost(requestBody, isPaginated = true) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/paginated/pos/list_locations',
            query: {
                'is_paginated': isPaginated,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Pos List Locations Daterangecompare
     * @param requestBody
     * @returns PosLocationDateRangeCompare Successful Response
     * @throws ApiError
     */
    static posListLocationsDateRangeCompareApiDateRangeComparePosListLocationsPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/pos/list_locations',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Pos List Locations Daterangecomparegranular
     * @param requestBody
     * @returns PosLocationDateRangeCompareGranular Successful Response
     * @throws ApiError
     */
    static posListLocationsDateRangeCompareGranularApiDateRangeCompareGranularPosListLocationsPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/granular/pos/list_locations',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Export Pos List Locations
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static exportPosListLocationsApiExportPosListLocationsPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/export/pos/list_locations',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Ingestion Slug Date Runs
     * @param requestBody
     * @returns IngestionSlugDateRuns Successful Response
     * @throws ApiError
     */
    static callIngestionSlugDateRunsApiIngestionSlugDateRunsPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/ingestion/slug_date_runs',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Ingestion Slug Date Runs
     * @param requestBody
     * @param isPaginated
     * @returns IngestionSlugDateRunsPaginated Successful Response
     * @throws ApiError
     */
    static callIngestionSlugDateRunsApiPaginatedIngestionSlugDateRunsPost(requestBody, isPaginated = true) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/paginated/ingestion/slug_date_runs',
            query: {
                'is_paginated': isPaginated,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Ingestion Slug Date Runs Daterangecompare
     * @param requestBody
     * @returns IngestionSlugDateRunsDateRangeCompare Successful Response
     * @throws ApiError
     */
    static ingestionSlugDateRunsDateRangeCompareApiDateRangeCompareIngestionSlugDateRunsPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/ingestion/slug_date_runs',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Ingestion Slug Date Runs Daterangecomparegranular
     * @param requestBody
     * @returns IngestionSlugDateRunsDateRangeCompareGranular Successful Response
     * @throws ApiError
     */
    static ingestionSlugDateRunsDateRangeCompareGranularApiDateRangeCompareGranularIngestionSlugDateRunsPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/granular/ingestion/slug_date_runs',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Export Ingestion Slug Date Runs
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static exportIngestionSlugDateRunsApiExportIngestionSlugDateRunsPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/export/ingestion/slug_date_runs',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Marketingmetricv2
     * @param requestBody
     * @returns MarketingMetricAggregateV2 Successful Response
     * @throws ApiError
     */
    static callMarketingMetricV2ApiMarketingMetricV2Post(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/MarketingMetricV2',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Marketingmetricv2
     * @param requestBody
     * @param isPaginated
     * @returns MarketingMetricAggregateV2Paginated Successful Response
     * @throws ApiError
     */
    static callMarketingMetricV2ApiPaginatedMarketingMetricV2Post(requestBody, isPaginated = true) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/paginated/MarketingMetricV2',
            query: {
                'is_paginated': isPaginated,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Marketingmetricv2 Daterangecompare
     * @param requestBody
     * @returns MarketingMetricAggregateV2DateRangeCompare Successful Response
     * @throws ApiError
     */
    static marketingMetricV2DateRangeCompareApiDateRangeCompareMarketingMetricV2Post(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/MarketingMetricV2',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Marketingmetricv2 Daterangecomparegranular
     * @param requestBody
     * @returns MarketingMetricAggregateV2DateRangeCompareGranular Successful Response
     * @throws ApiError
     */
    static marketingMetricV2DateRangeCompareGranularApiDateRangeCompareGranularMarketingMetricV2Post(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/granular/MarketingMetricV2',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Export Marketingmetricv2
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static exportMarketingMetricV2ApiExportMarketingMetricV2Post(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/export/MarketingMetricV2',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Transactionsbypayoutidaggregate
     * @param requestBody
     * @returns TransactionsByPayoutIdAggregate Successful Response
     * @throws ApiError
     */
    static callTransactionsByPayoutIdAggregateApiTransactionsByPayoutIdAggregatePost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/TransactionsByPayoutIdAggregate',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Transactionsbypayoutidaggregate Daterangecompare
     * @param requestBody
     * @returns TransactionsByPayoutIdAggregateDateRangeCompare Successful Response
     * @throws ApiError
     */
    static transactionsByPayoutIdAggregateDateRangeCompareApiDateRangeCompareTransactionsByPayoutIdAggregatePost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/TransactionsByPayoutIdAggregate',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Order Accuracy Error Data By Shift
     * @param requestBody
     * @returns ErrorDataByShift Successful Response
     * @throws ApiError
     */
    static callOrderAccuracyErrorDataByShiftApiOrderAccuracyErrorDataByShiftPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/order_accuracy/error_data_by_shift',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Order Accuracy Error Data By Shift
     * @param requestBody
     * @param isPaginated
     * @returns ErrorDataByShiftPaginated Successful Response
     * @throws ApiError
     */
    static callOrderAccuracyErrorDataByShiftApiPaginatedOrderAccuracyErrorDataByShiftPost(requestBody, isPaginated = true) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/paginated/order_accuracy/error_data_by_shift',
            query: {
                'is_paginated': isPaginated,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Order Accuracy Error Data By Shift Daterangecompare
     * @param requestBody
     * @returns ErrorDataByShiftDateRangeCompare Successful Response
     * @throws ApiError
     */
    static orderAccuracyErrorDataByShiftDateRangeCompareApiDateRangeCompareOrderAccuracyErrorDataByShiftPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/order_accuracy/error_data_by_shift',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Order Accuracy Error Data By Shift Daterangecomparegranular
     * @param requestBody
     * @returns ErrorDataByShiftDateRangeCompareGranular Successful Response
     * @throws ApiError
     */
    static orderAccuracyErrorDataByShiftDateRangeCompareGranularApiDateRangeCompareGranularOrderAccuracyErrorDataByShiftPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/granular/order_accuracy/error_data_by_shift',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Export Order Accuracy Error Data By Shift
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static exportOrderAccuracyErrorDataByShiftApiExportOrderAccuracyErrorDataByShiftPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/export/order_accuracy/error_data_by_shift',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Order Accuracy Error Overview
     * @param requestBody
     * @returns ErrorOverviewAggregate Successful Response
     * @throws ApiError
     */
    static callOrderAccuracyErrorOverviewApiOrderAccuracyErrorOverviewPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/order_accuracy/error_overview',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Order Accuracy Error Overview Daterangecompare
     * @param requestBody
     * @returns ErrorOverviewAggregateDateRangeCompare Successful Response
     * @throws ApiError
     */
    static orderAccuracyErrorOverviewDateRangeCompareApiDateRangeCompareOrderAccuracyErrorOverviewPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/order_accuracy/error_overview',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Reviewaggregate
     * @param requestBody
     * @returns ReviewAggregate Successful Response
     * @throws ApiError
     */
    static callReviewAggregateApiReviewAggregatePost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/ReviewAggregate',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Reviewaggregate Daterangecompare
     * @param requestBody
     * @returns ReviewAggregateDateRangeCompare Successful Response
     * @throws ApiError
     */
    static reviewAggregateDateRangeCompareApiDateRangeCompareReviewAggregatePost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/ReviewAggregate',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Olo All Categories
     * @param requestBody
     * @returns OloItemCategory Successful Response
     * @throws ApiError
     */
    static callOloAllCategoriesApiOloAllCategoriesPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/olo/all_categories',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Olo All Categories
     * @param requestBody
     * @param isPaginated
     * @returns OloItemCategoryPaginated Successful Response
     * @throws ApiError
     */
    static callOloAllCategoriesApiPaginatedOloAllCategoriesPost(requestBody, isPaginated = true) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/paginated/olo/all_categories',
            query: {
                'is_paginated': isPaginated,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Olo All Categories Daterangecompare
     * @param requestBody
     * @returns OloItemCategoryDateRangeCompare Successful Response
     * @throws ApiError
     */
    static oloAllCategoriesDateRangeCompareApiDateRangeCompareOloAllCategoriesPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/olo/all_categories',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Olo All Categories Daterangecomparegranular
     * @param requestBody
     * @returns OloItemCategoryDateRangeCompareGranular Successful Response
     * @throws ApiError
     */
    static oloAllCategoriesDateRangeCompareGranularApiDateRangeCompareGranularOloAllCategoriesPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/granular/olo/all_categories',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Export Olo All Categories
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static exportOloAllCategoriesApiExportOloAllCategoriesPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/export/olo/all_categories',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Thirdpartyfeesummary
     * @param requestBody
     * @returns ThirdPartyFeeSummaryModel Successful Response
     * @throws ApiError
     */
    static callThirdPartyFeeSummaryApiThirdPartyFeeSummaryPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/ThirdPartyFeeSummary',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Thirdpartyfeesummary Daterangecompare
     * @param requestBody
     * @returns ThirdPartyFeeSummaryModelDateRangeCompare Successful Response
     * @throws ApiError
     */
    static thirdPartyFeeSummaryDateRangeCompareApiDateRangeCompareThirdPartyFeeSummaryPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/ThirdPartyFeeSummary',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Storeavailabilitymatrixaggregate
     * @param requestBody
     * @returns StoreAvailabilityMatrixAggregate Successful Response
     * @throws ApiError
     */
    static callStoreAvailabilityMatrixAggregateApiStoreAvailabilityMatrixAggregatePost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/StoreAvailabilityMatrixAggregate',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Storeavailabilitymatrixaggregate Daterangecompare
     * @param requestBody
     * @returns StoreAvailabilityMatrixAggregateDateRangeCompare Successful Response
     * @throws ApiError
     */
    static storeAvailabilityMatrixAggregateDateRangeCompareApiDateRangeCompareStoreAvailabilityMatrixAggregatePost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/StoreAvailabilityMatrixAggregate',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Chargebacksummary
     * @param requestBody
     * @returns ChargebackSummaryModel Successful Response
     * @throws ApiError
     */
    static callChargebackSummaryApiChargebackSummaryPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/ChargebackSummary',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Chargebacksummary Daterangecompare
     * @param requestBody
     * @returns ChargebackSummaryModelDateRangeCompare Successful Response
     * @throws ApiError
     */
    static chargebackSummaryDateRangeCompareApiDateRangeCompareChargebackSummaryPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/ChargebackSummary',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Averageuptimeaggregate
     * @param requestBody
     * @returns AverageUptimeAggregate Successful Response
     * @throws ApiError
     */
    static callAverageUptimeAggregateApiAverageUptimeAggregatePost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/AverageUptimeAggregate',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Averageuptimeaggregate Daterangecompare
     * @param requestBody
     * @returns AverageUptimeAggregateDateRangeCompare Successful Response
     * @throws ApiError
     */
    static averageUptimeAggregateDateRangeCompareApiDateRangeCompareAverageUptimeAggregatePost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/AverageUptimeAggregate',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Marketingmetric
     * @param requestBody
     * @returns MarketingMetricAggregate Successful Response
     * @throws ApiError
     */
    static callMarketingMetricApiMarketingMetricPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/MarketingMetric',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Marketingmetric Daterangecompare
     * @param requestBody
     * @returns MarketingMetricAggregateDateRangeCompare Successful Response
     * @throws ApiError
     */
    static marketingMetricDateRangeCompareApiDateRangeCompareMarketingMetricPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/MarketingMetric',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Testmodelquery
     * @param requestBody
     * @returns TestModel Successful Response
     * @throws ApiError
     */
    static callTestModelQueryApiTestModelQueryPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/TestModelQuery',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Testmodelquery
     * @param requestBody
     * @param isPaginated
     * @returns TestModelPaginated Successful Response
     * @throws ApiError
     */
    static callTestModelQueryApiPaginatedTestModelQueryPost(requestBody, isPaginated = true) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/paginated/TestModelQuery',
            query: {
                'is_paginated': isPaginated,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Testmodelquery Daterangecompare
     * @param requestBody
     * @returns TestModelDateRangeCompare Successful Response
     * @throws ApiError
     */
    static testModelQueryDateRangeCompareApiDateRangeCompareTestModelQueryPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/TestModelQuery',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Testmodelquery Daterangecomparegranular
     * @param requestBody
     * @returns TestModelDateRangeCompareGranular Successful Response
     * @throws ApiError
     */
    static testModelQueryDateRangeCompareGranularApiDateRangeCompareGranularTestModelQueryPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/granular/TestModelQuery',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Export Testmodelquery
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static exportTestModelQueryApiExportTestModelQueryPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/export/TestModelQuery',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Storecount
     * @param requestBody
     * @returns StoreCountAggregate Successful Response
     * @throws ApiError
     */
    static callStoreCountApiStoreCountPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/StoreCount',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Storecount Daterangecompare
     * @param requestBody
     * @returns StoreCountAggregateDateRangeCompare Successful Response
     * @throws ApiError
     */
    static storeCountDateRangeCompareApiDateRangeCompareStoreCountPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/StoreCount',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Storeratingreviewscampaign
     * @param requestBody
     * @returns StoreRatingReviewsCampaign Successful Response
     * @throws ApiError
     */
    static callStoreRatingReviewsCampaignApiStoreRatingReviewsCampaignPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/StoreRatingReviewsCampaign',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Storeratingreviewscampaign
     * @param requestBody
     * @param isPaginated
     * @returns StoreRatingReviewsCampaignPaginated Successful Response
     * @throws ApiError
     */
    static callStoreRatingReviewsCampaignApiPaginatedStoreRatingReviewsCampaignPost(requestBody, isPaginated = true) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/paginated/StoreRatingReviewsCampaign',
            query: {
                'is_paginated': isPaginated,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Storeratingreviewscampaign Daterangecompare
     * @param requestBody
     * @returns StoreRatingReviewsCampaignDateRangeCompare Successful Response
     * @throws ApiError
     */
    static storeRatingReviewsCampaignDateRangeCompareApiDateRangeCompareStoreRatingReviewsCampaignPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/StoreRatingReviewsCampaign',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Storeratingreviewscampaign Daterangecomparegranular
     * @param requestBody
     * @returns StoreRatingReviewsCampaignDateRangeCompareGranular Successful Response
     * @throws ApiError
     */
    static storeRatingReviewsCampaignDateRangeCompareGranularApiDateRangeCompareGranularStoreRatingReviewsCampaignPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/granular/StoreRatingReviewsCampaign',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Export Storeratingreviewscampaign
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static exportStoreRatingReviewsCampaignApiExportStoreRatingReviewsCampaignPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/export/StoreRatingReviewsCampaign',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Pos Aggregate Metrics For 3P Vs Pos
     * @param requestBody
     * @returns PosThirdPartySummaryAggregate Successful Response
     * @throws ApiError
     */
    static callPosAggregateMetricsFor3PVsPosApiPosAggregateMetricsFor3PVsPosPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/pos/aggregate_metrics_for_3p_vs_pos',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Pos Aggregate Metrics For 3P Vs Pos Daterangecompare
     * @param requestBody
     * @returns PosThirdPartySummaryAggregateDateRangeCompare Successful Response
     * @throws ApiError
     */
    static posAggregateMetricsFor3PVsPosDateRangeCompareApiDateRangeComparePosAggregateMetricsFor3PVsPosPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/pos/aggregate_metrics_for_3p_vs_pos',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Pos List Of Variances
     * @param requestBody
     * @returns PosThirdPartyVarianceList Successful Response
     * @throws ApiError
     */
    static callPosListOfVariancesApiPosListOfVariancesPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/pos/list_of_variances',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Pos List Of Variances
     * @param requestBody
     * @param isPaginated
     * @returns PosThirdPartyVarianceListPaginated Successful Response
     * @throws ApiError
     */
    static callPosListOfVariancesApiPaginatedPosListOfVariancesPost(requestBody, isPaginated = true) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/paginated/pos/list_of_variances',
            query: {
                'is_paginated': isPaginated,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Pos List Of Variances Daterangecompare
     * @param requestBody
     * @returns PosThirdPartyVarianceListDateRangeCompare Successful Response
     * @throws ApiError
     */
    static posListOfVariancesDateRangeCompareApiDateRangeComparePosListOfVariancesPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/pos/list_of_variances',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Pos List Of Variances Daterangecomparegranular
     * @param requestBody
     * @returns PosThirdPartyVarianceListDateRangeCompareGranular Successful Response
     * @throws ApiError
     */
    static posListOfVariancesDateRangeCompareGranularApiDateRangeCompareGranularPosListOfVariancesPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/granular/pos/list_of_variances',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Export Pos List Of Variances
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static exportPosListOfVariancesApiExportPosListOfVariancesPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/export/pos/list_of_variances',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Campaigndetail
     * @param requestBody
     * @returns CampaignDetailPaginated Successful Response
     * @throws ApiError
     */
    static callCampaignDetailApiCampaignDetailPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/CampaignDetail',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Campaigndetail
     * @param requestBody
     * @param isPaginated
     * @returns CampaignDetailPaginatedPaginated Successful Response
     * @throws ApiError
     */
    static callCampaignDetailApiPaginatedCampaignDetailPost(requestBody, isPaginated = true) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/paginated/CampaignDetail',
            query: {
                'is_paginated': isPaginated,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Campaigndetail Daterangecompare
     * @param requestBody
     * @returns CampaignDetailPaginatedDateRangeCompare Successful Response
     * @throws ApiError
     */
    static campaignDetailDateRangeCompareApiDateRangeCompareCampaignDetailPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/CampaignDetail',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Campaigndetail Daterangecomparegranular
     * @param requestBody
     * @returns CampaignDetailPaginatedDateRangeCompareGranular Successful Response
     * @throws ApiError
     */
    static campaignDetailDateRangeCompareGranularApiDateRangeCompareGranularCampaignDetailPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/granular/CampaignDetail',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Export Campaigndetail
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static exportCampaignDetailApiExportCampaignDetailPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/export/CampaignDetail',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Allorderdetails
     * @param requestBody
     * @returns AllOrderDetails Successful Response
     * @throws ApiError
     */
    static callAllOrderDetailsApiAllOrderDetailsPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/AllOrderDetails',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Allorderdetails
     * @param requestBody
     * @param isPaginated
     * @returns AllOrderDetailsPaginated Successful Response
     * @throws ApiError
     */
    static callAllOrderDetailsApiPaginatedAllOrderDetailsPost(requestBody, isPaginated = true) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/paginated/AllOrderDetails',
            query: {
                'is_paginated': isPaginated,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Allorderdetails Daterangecompare
     * @param requestBody
     * @returns AllOrderDetailsDateRangeCompare Successful Response
     * @throws ApiError
     */
    static allOrderDetailsDateRangeCompareApiDateRangeCompareAllOrderDetailsPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/AllOrderDetails',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Allorderdetails Daterangecomparegranular
     * @param requestBody
     * @returns AllOrderDetailsDateRangeCompareGranular Successful Response
     * @throws ApiError
     */
    static allOrderDetailsDateRangeCompareGranularApiDateRangeCompareGranularAllOrderDetailsPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/granular/AllOrderDetails',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Export Allorderdetails
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static exportAllOrderDetailsApiExportAllOrderDetailsPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/export/AllOrderDetails',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Drill Down Generated Metricskpi Grouped List Of Entries
     * @param requestBody
     * @returns MetricsKPIDrillDownOutput Successful Response
     * @throws ApiError
     */
    static callDrillDownGeneratedMetricsKpiGroupedListOfEntriesApiDrillDownGeneratedMetricsKpiGroupedListOfEntriesPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/drill_down_generated/MetricsKPI/grouped_list_of_entries',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Drill Down Generated Metricskpi Grouped List Of Entries
     * @param requestBody
     * @param isPaginated
     * @returns MetricsKPIDrillDownOutputPaginated Successful Response
     * @throws ApiError
     */
    static callDrillDownGeneratedMetricsKpiGroupedListOfEntriesApiPaginatedDrillDownGeneratedMetricsKpiGroupedListOfEntriesPost(requestBody, isPaginated = true) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/paginated/drill_down_generated/MetricsKPI/grouped_list_of_entries',
            query: {
                'is_paginated': isPaginated,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Drill Down Generated Metricskpi Grouped List Of Entries Daterangecompare
     * @param requestBody
     * @returns MetricsKPIDrillDownOutputDateRangeCompare Successful Response
     * @throws ApiError
     */
    static drillDownGeneratedMetricsKpiGroupedListOfEntriesDateRangeCompareApiDateRangeCompareDrillDownGeneratedMetricsKpiGroupedListOfEntriesPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/drill_down_generated/MetricsKPI/grouped_list_of_entries',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Drill Down Generated Metricskpi Grouped List Of Entries Daterangecomparegranular
     * @param requestBody
     * @returns MetricsKPIDrillDownOutputDateRangeCompareGranular Successful Response
     * @throws ApiError
     */
    static drillDownGeneratedMetricsKpiGroupedListOfEntriesDateRangeCompareGranularApiDateRangeCompareGranularDrillDownGeneratedMetricsKpiGroupedListOfEntriesPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/granular/drill_down_generated/MetricsKPI/grouped_list_of_entries',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Export Drill Down Generated Metricskpi Grouped List Of Entries
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static exportDrillDownGeneratedMetricsKpiGroupedListOfEntriesApiExportDrillDownGeneratedMetricsKpiGroupedListOfEntriesPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/export/drill_down_generated/MetricsKPI/grouped_list_of_entries',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Chargebackbnames
     * @param requestBody
     * @returns ChargebackBnames Successful Response
     * @throws ApiError
     */
    static callChargebackBnamesApiChargebackBnamesPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/ChargebackBnames',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Chargebackbnames
     * @param requestBody
     * @param isPaginated
     * @returns ChargebackBnamesPaginated Successful Response
     * @throws ApiError
     */
    static callChargebackBnamesApiPaginatedChargebackBnamesPost(requestBody, isPaginated = true) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/paginated/ChargebackBnames',
            query: {
                'is_paginated': isPaginated,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Chargebackbnames Daterangecompare
     * @param requestBody
     * @returns ChargebackBnamesDateRangeCompare Successful Response
     * @throws ApiError
     */
    static chargebackBnamesDateRangeCompareApiDateRangeCompareChargebackBnamesPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/ChargebackBnames',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Chargebackbnames Daterangecomparegranular
     * @param requestBody
     * @returns ChargebackBnamesDateRangeCompareGranular Successful Response
     * @throws ApiError
     */
    static chargebackBnamesDateRangeCompareGranularApiDateRangeCompareGranularChargebackBnamesPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/granular/ChargebackBnames',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Export Chargebackbnames
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static exportChargebackBnamesApiExportChargebackBnamesPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/export/ChargebackBnames',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Homepageroi
     * @param requestBody
     * @returns HomePageROI Successful Response
     * @throws ApiError
     */
    static callHomePageRoiApiHomePageRoiPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/HomePageROI',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Homepageroi
     * @param requestBody
     * @param isPaginated
     * @returns HomePageROIPaginated Successful Response
     * @throws ApiError
     */
    static callHomePageRoiApiPaginatedHomePageRoiPost(requestBody, isPaginated = true) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/paginated/HomePageROI',
            query: {
                'is_paginated': isPaginated,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Homepageroi Daterangecompare
     * @param requestBody
     * @returns HomePageROIDateRangeCompare Successful Response
     * @throws ApiError
     */
    static homePageRoiDateRangeCompareApiDateRangeCompareHomePageRoiPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/HomePageROI',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Homepageroi Daterangecomparegranular
     * @param requestBody
     * @returns HomePageROIDateRangeCompareGranular Successful Response
     * @throws ApiError
     */
    static homePageRoiDateRangeCompareGranularApiDateRangeCompareGranularHomePageRoiPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/granular/HomePageROI',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Export Homepageroi
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static exportHomePageRoiApiExportHomePageRoiPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/export/HomePageROI',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Issuediscoverysummary
     * @param requestBody
     * @returns IssueDiscoverySummary Successful Response
     * @throws ApiError
     */
    static callIssueDiscoverySummaryApiIssueDiscoverySummaryPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/IssueDiscoverySummary',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Issuediscoverysummary
     * @param requestBody
     * @param isPaginated
     * @returns IssueDiscoverySummaryPaginated Successful Response
     * @throws ApiError
     */
    static callIssueDiscoverySummaryApiPaginatedIssueDiscoverySummaryPost(requestBody, isPaginated = true) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/paginated/IssueDiscoverySummary',
            query: {
                'is_paginated': isPaginated,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Issuediscoverysummary Daterangecompare
     * @param requestBody
     * @returns IssueDiscoverySummaryDateRangeCompare Successful Response
     * @throws ApiError
     */
    static issueDiscoverySummaryDateRangeCompareApiDateRangeCompareIssueDiscoverySummaryPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/IssueDiscoverySummary',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Issuediscoverysummary Daterangecomparegranular
     * @param requestBody
     * @returns IssueDiscoverySummaryDateRangeCompareGranular Successful Response
     * @throws ApiError
     */
    static issueDiscoverySummaryDateRangeCompareGranularApiDateRangeCompareGranularIssueDiscoverySummaryPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/granular/IssueDiscoverySummary',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Export Issuediscoverysummary
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static exportIssueDiscoverySummaryApiExportIssueDiscoverySummaryPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/export/IssueDiscoverySummary',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Financepayoutaggregatequery
     * @param requestBody
     * @returns FinancePayoutAggregate Successful Response
     * @throws ApiError
     */
    static callFinancePayoutAggregateQueryApiFinancePayoutAggregateQueryPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/FinancePayoutAggregateQuery',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Financepayoutaggregatequery Daterangecompare
     * @param requestBody
     * @returns FinancePayoutAggregateDateRangeCompare Successful Response
     * @throws ApiError
     */
    static financePayoutAggregateQueryDateRangeCompareApiDateRangeCompareFinancePayoutAggregateQueryPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/FinancePayoutAggregateQuery',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Review
     * @param requestBody
     * @returns dynamic__models__Review__Review Successful Response
     * @throws ApiError
     */
    static callReviewApiReviewPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Review',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Review
     * @param requestBody
     * @param isPaginated
     * @returns ReviewPaginated Successful Response
     * @throws ApiError
     */
    static callReviewApiPaginatedReviewPost(requestBody, isPaginated = true) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/paginated/Review',
            query: {
                'is_paginated': isPaginated,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Review Daterangecompare
     * @param requestBody
     * @returns ReviewDateRangeCompare Successful Response
     * @throws ApiError
     */
    static reviewDateRangeCompareApiDateRangeCompareReviewPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/Review',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Review Daterangecomparegranular
     * @param requestBody
     * @returns ReviewDateRangeCompareGranular Successful Response
     * @throws ApiError
     */
    static reviewDateRangeCompareGranularApiDateRangeCompareGranularReviewPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/granular/Review',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Export Review
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static exportReviewApiExportReviewPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/export/Review',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Order Fulfillment Types
     * @param requestBody
     * @returns OrderFulfillmentTypes Successful Response
     * @throws ApiError
     */
    static callOrderFulfillmentTypesApiOrderFulfillmentTypesPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/order_fulfillment_types',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Order Fulfillment Types
     * @param requestBody
     * @param isPaginated
     * @returns OrderFulfillmentTypesPaginated Successful Response
     * @throws ApiError
     */
    static callOrderFulfillmentTypesApiPaginatedOrderFulfillmentTypesPost(requestBody, isPaginated = true) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/paginated/order_fulfillment_types',
            query: {
                'is_paginated': isPaginated,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Order Fulfillment Types Daterangecompare
     * @param requestBody
     * @returns OrderFulfillmentTypesDateRangeCompare Successful Response
     * @throws ApiError
     */
    static orderFulfillmentTypesDateRangeCompareApiDateRangeCompareOrderFulfillmentTypesPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/order_fulfillment_types',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Order Fulfillment Types Daterangecomparegranular
     * @param requestBody
     * @returns OrderFulfillmentTypesDateRangeCompareGranular Successful Response
     * @throws ApiError
     */
    static orderFulfillmentTypesDateRangeCompareGranularApiDateRangeCompareGranularOrderFulfillmentTypesPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/granular/order_fulfillment_types',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Export Order Fulfillment Types
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static exportOrderFulfillmentTypesApiExportOrderFulfillmentTypesPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/export/order_fulfillment_types',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Order Accuracy Error Category Subcategory Distribution
     * @param requestBody
     * @returns ErrorCategorySubcategoryDistribution Successful Response
     * @throws ApiError
     */
    static callOrderAccuracyErrorCategorySubcategoryDistributionApiOrderAccuracyErrorCategorySubcategoryDistributionPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/order_accuracy/error_category_subcategory_distribution',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Order Accuracy Error Category Subcategory Distribution
     * @param requestBody
     * @param isPaginated
     * @returns ErrorCategorySubcategoryDistributionPaginated Successful Response
     * @throws ApiError
     */
    static callOrderAccuracyErrorCategorySubcategoryDistributionApiPaginatedOrderAccuracyErrorCategorySubcategoryDistributionPost(requestBody, isPaginated = true) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/paginated/order_accuracy/error_category_subcategory_distribution',
            query: {
                'is_paginated': isPaginated,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Order Accuracy Error Category Subcategory Distribution Daterangecompare
     * @param requestBody
     * @returns ErrorCategorySubcategoryDistributionDateRangeCompare Successful Response
     * @throws ApiError
     */
    static orderAccuracyErrorCategorySubcategoryDistributionDateRangeCompareApiDateRangeCompareOrderAccuracyErrorCategorySubcategoryDistributionPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/order_accuracy/error_category_subcategory_distribution',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Order Accuracy Error Category Subcategory Distribution Daterangecomparegranular
     * @param requestBody
     * @returns ErrorCategorySubcategoryDistributionDateRangeCompareGranular Successful Response
     * @throws ApiError
     */
    static orderAccuracyErrorCategorySubcategoryDistributionDateRangeCompareGranularApiDateRangeCompareGranularOrderAccuracyErrorCategorySubcategoryDistributionPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/granular/order_accuracy/error_category_subcategory_distribution',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Export Order Accuracy Error Category Subcategory Distribution
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static exportOrderAccuracyErrorCategorySubcategoryDistributionApiExportOrderAccuracyErrorCategorySubcategoryDistributionPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/export/order_accuracy/error_category_subcategory_distribution',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Ratingreviewv2
     * @param requestBody
     * @returns RatingReviewV2 Successful Response
     * @throws ApiError
     */
    static callRatingReviewV2ApiRatingReviewV2Post(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/RatingReviewV2',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Ratingreviewv2
     * @param requestBody
     * @param isPaginated
     * @returns RatingReviewV2Paginated Successful Response
     * @throws ApiError
     */
    static callRatingReviewV2ApiPaginatedRatingReviewV2Post(requestBody, isPaginated = true) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/paginated/RatingReviewV2',
            query: {
                'is_paginated': isPaginated,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Ratingreviewv2 Daterangecompare
     * @param requestBody
     * @returns RatingReviewV2DateRangeCompare Successful Response
     * @throws ApiError
     */
    static ratingReviewV2DateRangeCompareApiDateRangeCompareRatingReviewV2Post(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/RatingReviewV2',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Ratingreviewv2 Daterangecomparegranular
     * @param requestBody
     * @returns RatingReviewV2DateRangeCompareGranular Successful Response
     * @throws ApiError
     */
    static ratingReviewV2DateRangeCompareGranularApiDateRangeCompareGranularRatingReviewV2Post(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/granular/RatingReviewV2',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Export Ratingreviewv2
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static exportRatingReviewV2ApiExportRatingReviewV2Post(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/export/RatingReviewV2',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Pos List Pos Types
     * @param requestBody
     * @returns PosType Successful Response
     * @throws ApiError
     */
    static callPosListPosTypesApiPosListPosTypesPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/pos/list_pos_types',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Pos List Pos Types
     * @param requestBody
     * @param isPaginated
     * @returns PosTypePaginated Successful Response
     * @throws ApiError
     */
    static callPosListPosTypesApiPaginatedPosListPosTypesPost(requestBody, isPaginated = true) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/paginated/pos/list_pos_types',
            query: {
                'is_paginated': isPaginated,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Pos List Pos Types Daterangecompare
     * @param requestBody
     * @returns PosTypeDateRangeCompare Successful Response
     * @throws ApiError
     */
    static posListPosTypesDateRangeCompareApiDateRangeComparePosListPosTypesPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/pos/list_pos_types',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Pos List Pos Types Daterangecomparegranular
     * @param requestBody
     * @returns PosTypeDateRangeCompareGranular Successful Response
     * @throws ApiError
     */
    static posListPosTypesDateRangeCompareGranularApiDateRangeCompareGranularPosListPosTypesPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/granular/pos/list_pos_types',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Export Pos List Pos Types
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static exportPosListPosTypesApiExportPosListPosTypesPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/export/pos/list_pos_types',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Order Accuracy Error Hour Week
     * @param requestBody
     * @returns ErrorHourWeek Successful Response
     * @throws ApiError
     */
    static callOrderAccuracyErrorHourWeekApiOrderAccuracyErrorHourWeekPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/order_accuracy/error_hour_week',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Order Accuracy Error Hour Week
     * @param requestBody
     * @param isPaginated
     * @returns ErrorHourWeekPaginated Successful Response
     * @throws ApiError
     */
    static callOrderAccuracyErrorHourWeekApiPaginatedOrderAccuracyErrorHourWeekPost(requestBody, isPaginated = true) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/paginated/order_accuracy/error_hour_week',
            query: {
                'is_paginated': isPaginated,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Order Accuracy Error Hour Week Daterangecompare
     * @param requestBody
     * @returns ErrorHourWeekDateRangeCompare Successful Response
     * @throws ApiError
     */
    static orderAccuracyErrorHourWeekDateRangeCompareApiDateRangeCompareOrderAccuracyErrorHourWeekPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/order_accuracy/error_hour_week',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Order Accuracy Error Hour Week Daterangecomparegranular
     * @param requestBody
     * @returns ErrorHourWeekDateRangeCompareGranular Successful Response
     * @throws ApiError
     */
    static orderAccuracyErrorHourWeekDateRangeCompareGranularApiDateRangeCompareGranularOrderAccuracyErrorHourWeekPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/granular/order_accuracy/error_hour_week',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Export Order Accuracy Error Hour Week
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static exportOrderAccuracyErrorHourWeekApiExportOrderAccuracyErrorHourWeekPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/export/order_accuracy/error_hour_week',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Marketingquery
     * @param requestBody
     * @returns MarketingAggregate Successful Response
     * @throws ApiError
     */
    static callMarketingQueryApiMarketingQueryPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/MarketingQuery',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Marketingquery Daterangecompare
     * @param requestBody
     * @returns MarketingAggregateDateRangeCompare Successful Response
     * @throws ApiError
     */
    static marketingQueryDateRangeCompareApiDateRangeCompareMarketingQueryPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/MarketingQuery',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Kpi Dashboard Marketingkpidatewise
     * @param requestBody
     * @returns MarketingKPIDatewise Successful Response
     * @throws ApiError
     */
    static callKpiDashboardMarketingKpiDatewiseApiKpiDashboardMarketingKpiDatewisePost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/kpi_dashboard/MarketingKPIDatewise',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Kpi Dashboard Marketingkpidatewise
     * @param requestBody
     * @param isPaginated
     * @returns MarketingKPIDatewisePaginated Successful Response
     * @throws ApiError
     */
    static callKpiDashboardMarketingKpiDatewiseApiPaginatedKpiDashboardMarketingKpiDatewisePost(requestBody, isPaginated = true) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/paginated/kpi_dashboard/MarketingKPIDatewise',
            query: {
                'is_paginated': isPaginated,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Kpi Dashboard Marketingkpidatewise Daterangecompare
     * @param requestBody
     * @returns MarketingKPIDatewiseDateRangeCompare Successful Response
     * @throws ApiError
     */
    static kpiDashboardMarketingKpiDatewiseDateRangeCompareApiDateRangeCompareKpiDashboardMarketingKpiDatewisePost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/kpi_dashboard/MarketingKPIDatewise',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Kpi Dashboard Marketingkpidatewise Daterangecomparegranular
     * @param requestBody
     * @returns MarketingKPIDatewiseDateRangeCompareGranular Successful Response
     * @throws ApiError
     */
    static kpiDashboardMarketingKpiDatewiseDateRangeCompareGranularApiDateRangeCompareGranularKpiDashboardMarketingKpiDatewisePost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/granular/kpi_dashboard/MarketingKPIDatewise',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Export Kpi Dashboard Marketingkpidatewise
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static exportKpiDashboardMarketingKpiDatewiseApiExportKpiDashboardMarketingKpiDatewisePost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/export/kpi_dashboard/MarketingKPIDatewise',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Kpi Dashboard Ratingsdatewise
     * @param requestBody
     * @returns RatingsDatewise Successful Response
     * @throws ApiError
     */
    static callKpiDashboardRatingsDatewiseApiKpiDashboardRatingsDatewisePost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/kpi_dashboard/RatingsDatewise',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Kpi Dashboard Ratingsdatewise
     * @param requestBody
     * @param isPaginated
     * @returns RatingsDatewisePaginated Successful Response
     * @throws ApiError
     */
    static callKpiDashboardRatingsDatewiseApiPaginatedKpiDashboardRatingsDatewisePost(requestBody, isPaginated = true) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/paginated/kpi_dashboard/RatingsDatewise',
            query: {
                'is_paginated': isPaginated,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Kpi Dashboard Ratingsdatewise Daterangecompare
     * @param requestBody
     * @returns RatingsDatewiseDateRangeCompare Successful Response
     * @throws ApiError
     */
    static kpiDashboardRatingsDatewiseDateRangeCompareApiDateRangeCompareKpiDashboardRatingsDatewisePost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/kpi_dashboard/RatingsDatewise',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Kpi Dashboard Ratingsdatewise Daterangecomparegranular
     * @param requestBody
     * @returns RatingsDatewiseDateRangeCompareGranular Successful Response
     * @throws ApiError
     */
    static kpiDashboardRatingsDatewiseDateRangeCompareGranularApiDateRangeCompareGranularKpiDashboardRatingsDatewisePost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/granular/kpi_dashboard/RatingsDatewise',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Export Kpi Dashboard Ratingsdatewise
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static exportKpiDashboardRatingsDatewiseApiExportKpiDashboardRatingsDatewisePost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/export/kpi_dashboard/RatingsDatewise',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Olo Finance Filters
     * @param requestBody
     * @returns OloFinanceFiltersAggregate Successful Response
     * @throws ApiError
     */
    static callOloFinanceFiltersApiOloFinanceFiltersPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/olo/finance_filters',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Olo Finance Filters Daterangecompare
     * @param requestBody
     * @returns OloFinanceFiltersAggregateDateRangeCompare Successful Response
     * @throws ApiError
     */
    static oloFinanceFiltersDateRangeCompareApiDateRangeCompareOloFinanceFiltersPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/olo/finance_filters',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Bookkeepingtxwithpayouts
     * @param requestBody
     * @returns BookKeepingTxWithPayouts Successful Response
     * @throws ApiError
     */
    static callBookKeepingTxWithPayoutsApiBookKeepingTxWithPayoutsPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/BookKeepingTxWithPayouts',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Bookkeepingtxwithpayouts
     * @param requestBody
     * @param isPaginated
     * @returns BookKeepingTxWithPayoutsPaginated Successful Response
     * @throws ApiError
     */
    static callBookKeepingTxWithPayoutsApiPaginatedBookKeepingTxWithPayoutsPost(requestBody, isPaginated = true) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/paginated/BookKeepingTxWithPayouts',
            query: {
                'is_paginated': isPaginated,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Bookkeepingtxwithpayouts Daterangecompare
     * @param requestBody
     * @returns BookKeepingTxWithPayoutsDateRangeCompare Successful Response
     * @throws ApiError
     */
    static bookKeepingTxWithPayoutsDateRangeCompareApiDateRangeCompareBookKeepingTxWithPayoutsPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/BookKeepingTxWithPayouts',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Bookkeepingtxwithpayouts Daterangecomparegranular
     * @param requestBody
     * @returns BookKeepingTxWithPayoutsDateRangeCompareGranular Successful Response
     * @throws ApiError
     */
    static bookKeepingTxWithPayoutsDateRangeCompareGranularApiDateRangeCompareGranularBookKeepingTxWithPayoutsPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/granular/BookKeepingTxWithPayouts',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Export Bookkeepingtxwithpayouts
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static exportBookKeepingTxWithPayoutsApiExportBookKeepingTxWithPayoutsPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/export/BookKeepingTxWithPayouts',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Campaignlowperforming
     * @param requestBody
     * @returns CampaignLowPerforming Successful Response
     * @throws ApiError
     */
    static callCampaignLowPerformingApiCampaignLowPerformingPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/CampaignLowPerforming',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Campaignlowperforming
     * @param requestBody
     * @param isPaginated
     * @returns CampaignLowPerformingPaginated Successful Response
     * @throws ApiError
     */
    static callCampaignLowPerformingApiPaginatedCampaignLowPerformingPost(requestBody, isPaginated = true) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/paginated/CampaignLowPerforming',
            query: {
                'is_paginated': isPaginated,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Campaignlowperforming Daterangecompare
     * @param requestBody
     * @returns CampaignLowPerformingDateRangeCompare Successful Response
     * @throws ApiError
     */
    static campaignLowPerformingDateRangeCompareApiDateRangeCompareCampaignLowPerformingPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/CampaignLowPerforming',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Campaignlowperforming Daterangecomparegranular
     * @param requestBody
     * @returns CampaignLowPerformingDateRangeCompareGranular Successful Response
     * @throws ApiError
     */
    static campaignLowPerformingDateRangeCompareGranularApiDateRangeCompareGranularCampaignLowPerformingPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/granular/CampaignLowPerforming',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Export Campaignlowperforming
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static exportCampaignLowPerformingApiExportCampaignLowPerformingPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/export/CampaignLowPerforming',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Errororderssummary
     * @param requestBody
     * @returns ErrorOrdersSummaryModel Successful Response
     * @throws ApiError
     */
    static callErrorOrdersSummaryApiErrorOrdersSummaryPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/ErrorOrdersSummary',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Errororderssummary Daterangecompare
     * @param requestBody
     * @returns ErrorOrdersSummaryModelDateRangeCompare Successful Response
     * @throws ApiError
     */
    static errorOrdersSummaryDateRangeCompareApiDateRangeCompareErrorOrdersSummaryPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/ErrorOrdersSummary',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Allorderdetailsaggregate
     * @param requestBody
     * @returns AllOrderDetailsAggregate Successful Response
     * @throws ApiError
     */
    static callAllOrderDetailsAggregateApiAllOrderDetailsAggregatePost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/AllOrderDetailsAggregate',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Allorderdetailsaggregate Daterangecompare
     * @param requestBody
     * @returns AllOrderDetailsAggregateDateRangeCompare Successful Response
     * @throws ApiError
     */
    static allOrderDetailsAggregateDateRangeCompareApiDateRangeCompareAllOrderDetailsAggregatePost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/AllOrderDetailsAggregate',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Ingestion Chain Progress
     * @param requestBody
     * @returns IngestionChainProgress Successful Response
     * @throws ApiError
     */
    static callIngestionChainProgressApiIngestionChainProgressPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/ingestion/chain_progress',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Ingestion Chain Progress
     * @param requestBody
     * @param isPaginated
     * @returns IngestionChainProgressPaginated Successful Response
     * @throws ApiError
     */
    static callIngestionChainProgressApiPaginatedIngestionChainProgressPost(requestBody, isPaginated = true) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/paginated/ingestion/chain_progress',
            query: {
                'is_paginated': isPaginated,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Ingestion Chain Progress Daterangecompare
     * @param requestBody
     * @returns IngestionChainProgressDateRangeCompare Successful Response
     * @throws ApiError
     */
    static ingestionChainProgressDateRangeCompareApiDateRangeCompareIngestionChainProgressPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/ingestion/chain_progress',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Ingestion Chain Progress Daterangecomparegranular
     * @param requestBody
     * @returns IngestionChainProgressDateRangeCompareGranular Successful Response
     * @throws ApiError
     */
    static ingestionChainProgressDateRangeCompareGranularApiDateRangeCompareGranularIngestionChainProgressPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/granular/ingestion/chain_progress',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Export Ingestion Chain Progress
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static exportIngestionChainProgressApiExportIngestionChainProgressPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/export/ingestion/chain_progress',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Olo All Items
     * @param requestBody
     * @returns OloItemDetails Successful Response
     * @throws ApiError
     */
    static callOloAllItemsApiOloAllItemsPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/olo/all_items',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Olo All Items
     * @param requestBody
     * @param isPaginated
     * @returns OloItemDetailsPaginated Successful Response
     * @throws ApiError
     */
    static callOloAllItemsApiPaginatedOloAllItemsPost(requestBody, isPaginated = true) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/paginated/olo/all_items',
            query: {
                'is_paginated': isPaginated,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Olo All Items Daterangecompare
     * @param requestBody
     * @returns OloItemDetailsDateRangeCompare Successful Response
     * @throws ApiError
     */
    static oloAllItemsDateRangeCompareApiDateRangeCompareOloAllItemsPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/olo/all_items',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Olo All Items Daterangecomparegranular
     * @param requestBody
     * @returns OloItemDetailsDateRangeCompareGranular Successful Response
     * @throws ApiError
     */
    static oloAllItemsDateRangeCompareGranularApiDateRangeCompareGranularOloAllItemsPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/granular/olo/all_items',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Export Olo All Items
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static exportOloAllItemsApiExportOloAllItemsPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/export/olo/all_items',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Storeautoturnon
     * @param requestBody
     * @returns StoreAutoTurnOn Successful Response
     * @throws ApiError
     */
    static callStoreAutoTurnOnApiStoreAutoTurnOnPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/StoreAutoTurnOn',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Storeautoturnon
     * @param requestBody
     * @param isPaginated
     * @returns StoreAutoTurnOnPaginated Successful Response
     * @throws ApiError
     */
    static callStoreAutoTurnOnApiPaginatedStoreAutoTurnOnPost(requestBody, isPaginated = true) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/paginated/StoreAutoTurnOn',
            query: {
                'is_paginated': isPaginated,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Storeautoturnon Daterangecompare
     * @param requestBody
     * @returns StoreAutoTurnOnDateRangeCompare Successful Response
     * @throws ApiError
     */
    static storeAutoTurnOnDateRangeCompareApiDateRangeCompareStoreAutoTurnOnPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/StoreAutoTurnOn',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Storeautoturnon Daterangecomparegranular
     * @param requestBody
     * @returns StoreAutoTurnOnDateRangeCompareGranular Successful Response
     * @throws ApiError
     */
    static storeAutoTurnOnDateRangeCompareGranularApiDateRangeCompareGranularStoreAutoTurnOnPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/granular/StoreAutoTurnOn',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Export Storeautoturnon
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static exportStoreAutoTurnOnApiExportStoreAutoTurnOnPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/export/StoreAutoTurnOn',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Olo Customer Data
     * @param requestBody
     * @returns OloCustomerDataAggregate Successful Response
     * @throws ApiError
     */
    static callOloCustomerDataApiOloCustomerDataPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/olo/customer_data',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Olo Customer Data Daterangecompare
     * @param requestBody
     * @returns OloCustomerDataAggregateDateRangeCompare Successful Response
     * @throws ApiError
     */
    static oloCustomerDataDateRangeCompareApiDateRangeCompareOloCustomerDataPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/olo/customer_data',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Drill Down Generated Ratings Unique Values
     * @param requestBody
     * @returns UniqueValuesForColumn Successful Response
     * @throws ApiError
     */
    static callDrillDownGeneratedRatingsUniqueValuesApiDrillDownGeneratedRatingsUniqueValuesPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/drill_down_generated/Ratings/unique_values',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Drill Down Generated Ratings Unique Values
     * @param requestBody
     * @param isPaginated
     * @returns UniqueValuesForColumnPaginated Successful Response
     * @throws ApiError
     */
    static callDrillDownGeneratedRatingsUniqueValuesApiPaginatedDrillDownGeneratedRatingsUniqueValuesPost(requestBody, isPaginated = true) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/paginated/drill_down_generated/Ratings/unique_values',
            query: {
                'is_paginated': isPaginated,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Drill Down Generated Ratings Unique Values Daterangecompare
     * @param requestBody
     * @returns UniqueValuesForColumnDateRangeCompare Successful Response
     * @throws ApiError
     */
    static drillDownGeneratedRatingsUniqueValuesDateRangeCompareApiDateRangeCompareDrillDownGeneratedRatingsUniqueValuesPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/drill_down_generated/Ratings/unique_values',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Drill Down Generated Ratings Unique Values Daterangecomparegranular
     * @param requestBody
     * @returns UniqueValuesForColumnDateRangeCompareGranular Successful Response
     * @throws ApiError
     */
    static drillDownGeneratedRatingsUniqueValuesDateRangeCompareGranularApiDateRangeCompareGranularDrillDownGeneratedRatingsUniqueValuesPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/granular/drill_down_generated/Ratings/unique_values',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Export Drill Down Generated Ratings Unique Values
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static exportDrillDownGeneratedRatingsUniqueValuesApiExportDrillDownGeneratedRatingsUniqueValuesPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/export/drill_down_generated/Ratings/unique_values',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Olo Order Transactions
     * @param requestBody
     * @returns OloOrderTransaction Successful Response
     * @throws ApiError
     */
    static callOloOrderTransactionsApiOloOrderTransactionsPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/olo/order_transactions',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Olo Order Transactions
     * @param requestBody
     * @param isPaginated
     * @returns OloOrderTransactionPaginated Successful Response
     * @throws ApiError
     */
    static callOloOrderTransactionsApiPaginatedOloOrderTransactionsPost(requestBody, isPaginated = true) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/paginated/olo/order_transactions',
            query: {
                'is_paginated': isPaginated,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Olo Order Transactions Daterangecompare
     * @param requestBody
     * @returns OloOrderTransactionDateRangeCompare Successful Response
     * @throws ApiError
     */
    static oloOrderTransactionsDateRangeCompareApiDateRangeCompareOloOrderTransactionsPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/olo/order_transactions',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Olo Order Transactions Daterangecomparegranular
     * @param requestBody
     * @returns OloOrderTransactionDateRangeCompareGranular Successful Response
     * @throws ApiError
     */
    static oloOrderTransactionsDateRangeCompareGranularApiDateRangeCompareGranularOloOrderTransactionsPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/granular/olo/order_transactions',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Export Olo Order Transactions
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static exportOloOrderTransactionsApiExportOloOrderTransactionsPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/export/olo/order_transactions',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Pos Aggregate Metrics For Payout
     * @param requestBody
     * @returns PosTransactionsSummaryAggregate Successful Response
     * @throws ApiError
     */
    static callPosAggregateMetricsForPayoutApiPosAggregateMetricsForPayoutPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/pos/aggregate_metrics_for_payout',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Pos Aggregate Metrics For Payout Daterangecompare
     * @param requestBody
     * @returns PosTransactionsSummaryAggregateDateRangeCompare Successful Response
     * @throws ApiError
     */
    static posAggregateMetricsForPayoutDateRangeCompareApiDateRangeComparePosAggregateMetricsForPayoutPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/pos/aggregate_metrics_for_payout',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Olo All Customers
     * @param requestBody
     * @returns OloCustomerMetrics Successful Response
     * @throws ApiError
     */
    static callOloAllCustomersApiOloAllCustomersPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/olo/all_customers',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Olo All Customers
     * @param requestBody
     * @param isPaginated
     * @returns OloCustomerMetricsPaginated Successful Response
     * @throws ApiError
     */
    static callOloAllCustomersApiPaginatedOloAllCustomersPost(requestBody, isPaginated = true) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/paginated/olo/all_customers',
            query: {
                'is_paginated': isPaginated,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Olo All Customers Daterangecompare
     * @param requestBody
     * @returns OloCustomerMetricsDateRangeCompare Successful Response
     * @throws ApiError
     */
    static oloAllCustomersDateRangeCompareApiDateRangeCompareOloAllCustomersPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/olo/all_customers',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Olo All Customers Daterangecomparegranular
     * @param requestBody
     * @returns OloCustomerMetricsDateRangeCompareGranular Successful Response
     * @throws ApiError
     */
    static oloAllCustomersDateRangeCompareGranularApiDateRangeCompareGranularOloAllCustomersPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/granular/olo/all_customers',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Export Olo All Customers
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static exportOloAllCustomersApiExportOloAllCustomersPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/export/olo/all_customers',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Olo Store Finances Aggregate
     * @param requestBody
     * @returns OloFinanceAggregate Successful Response
     * @throws ApiError
     */
    static callOloStoreFinancesAggregateApiOloStoreFinancesAggregatePost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/olo/store_finances_aggregate',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Olo Store Finances Aggregate Daterangecompare
     * @param requestBody
     * @returns OloFinanceAggregateDateRangeCompare Successful Response
     * @throws ApiError
     */
    static oloStoreFinancesAggregateDateRangeCompareApiDateRangeCompareOloStoreFinancesAggregatePost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/olo/store_finances_aggregate',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Bankreconciliationaggregate
     * @param requestBody
     * @returns BankReconciliationAggregateResponse Successful Response
     * @throws ApiError
     */
    static callBankReconciliationAggregateApiBankReconciliationAggregatePost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/BankReconciliationAggregate',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Bankreconciliationaggregate
     * @param requestBody
     * @param isPaginated
     * @returns BankReconciliationAggregateResponsePaginated Successful Response
     * @throws ApiError
     */
    static callBankReconciliationAggregateApiPaginatedBankReconciliationAggregatePost(requestBody, isPaginated = true) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/paginated/BankReconciliationAggregate',
            query: {
                'is_paginated': isPaginated,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Bankreconciliationaggregate Daterangecompare
     * @param requestBody
     * @returns BankReconciliationAggregateResponseDateRangeCompare Successful Response
     * @throws ApiError
     */
    static bankReconciliationAggregateDateRangeCompareApiDateRangeCompareBankReconciliationAggregatePost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/BankReconciliationAggregate',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Bankreconciliationaggregate Daterangecomparegranular
     * @param requestBody
     * @returns BankReconciliationAggregateResponseDateRangeCompareGranular Successful Response
     * @throws ApiError
     */
    static bankReconciliationAggregateDateRangeCompareGranularApiDateRangeCompareGranularBankReconciliationAggregatePost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/granular/BankReconciliationAggregate',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Export Bankreconciliationaggregate
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static exportBankReconciliationAggregateApiExportBankReconciliationAggregatePost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/export/BankReconciliationAggregate',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Issue Discovery Insights Item Errors By Item
     * @param requestBody
     * @returns ItemErrorsByItem Successful Response
     * @throws ApiError
     */
    static callIssueDiscoveryInsightsItemErrorsByItemApiIssueDiscoveryInsightsItemErrorsByItemPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/issue_discovery/insights/item_errors/by_item',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Issue Discovery Insights Item Errors By Item
     * @param requestBody
     * @param isPaginated
     * @returns ItemErrorsByItemPaginated Successful Response
     * @throws ApiError
     */
    static callIssueDiscoveryInsightsItemErrorsByItemApiPaginatedIssueDiscoveryInsightsItemErrorsByItemPost(requestBody, isPaginated = true) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/paginated/issue_discovery/insights/item_errors/by_item',
            query: {
                'is_paginated': isPaginated,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Issue Discovery Insights Item Errors By Item Daterangecompare
     * @param requestBody
     * @returns ItemErrorsByItemDateRangeCompare Successful Response
     * @throws ApiError
     */
    static issueDiscoveryInsightsItemErrorsByItemDateRangeCompareApiDateRangeCompareIssueDiscoveryInsightsItemErrorsByItemPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/issue_discovery/insights/item_errors/by_item',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Issue Discovery Insights Item Errors By Item Daterangecomparegranular
     * @param requestBody
     * @returns ItemErrorsByItemDateRangeCompareGranular Successful Response
     * @throws ApiError
     */
    static issueDiscoveryInsightsItemErrorsByItemDateRangeCompareGranularApiDateRangeCompareGranularIssueDiscoveryInsightsItemErrorsByItemPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/granular/issue_discovery/insights/item_errors/by_item',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Export Issue Discovery Insights Item Errors By Item
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static exportIssueDiscoveryInsightsItemErrorsByItemApiExportIssueDiscoveryInsightsItemErrorsByItemPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/export/issue_discovery/insights/item_errors/by_item',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Storeavailabilitymatrixreasons
     * @param requestBody
     * @returns StoreAvailabilityMatrixReasons Successful Response
     * @throws ApiError
     */
    static callStoreAvailabilityMatrixReasonsApiStoreAvailabilityMatrixReasonsPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/StoreAvailabilityMatrixReasons',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Storeavailabilitymatrixreasons
     * @param requestBody
     * @param isPaginated
     * @returns StoreAvailabilityMatrixReasonsPaginated Successful Response
     * @throws ApiError
     */
    static callStoreAvailabilityMatrixReasonsApiPaginatedStoreAvailabilityMatrixReasonsPost(requestBody, isPaginated = true) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/paginated/StoreAvailabilityMatrixReasons',
            query: {
                'is_paginated': isPaginated,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Storeavailabilitymatrixreasons Daterangecompare
     * @param requestBody
     * @returns StoreAvailabilityMatrixReasonsDateRangeCompare Successful Response
     * @throws ApiError
     */
    static storeAvailabilityMatrixReasonsDateRangeCompareApiDateRangeCompareStoreAvailabilityMatrixReasonsPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/StoreAvailabilityMatrixReasons',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Storeavailabilitymatrixreasons Daterangecomparegranular
     * @param requestBody
     * @returns StoreAvailabilityMatrixReasonsDateRangeCompareGranular Successful Response
     * @throws ApiError
     */
    static storeAvailabilityMatrixReasonsDateRangeCompareGranularApiDateRangeCompareGranularStoreAvailabilityMatrixReasonsPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/granular/StoreAvailabilityMatrixReasons',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Export Storeavailabilitymatrixreasons
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static exportStoreAvailabilityMatrixReasonsApiExportStoreAvailabilityMatrixReasonsPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/export/StoreAvailabilityMatrixReasons',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Pos List Payouts
     * @param requestBody
     * @returns PosPayouts Successful Response
     * @throws ApiError
     */
    static callPosListPayoutsApiPosListPayoutsPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/pos/list_payouts',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Pos List Payouts
     * @param requestBody
     * @param isPaginated
     * @returns PosPayoutsPaginated Successful Response
     * @throws ApiError
     */
    static callPosListPayoutsApiPaginatedPosListPayoutsPost(requestBody, isPaginated = true) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/paginated/pos/list_payouts',
            query: {
                'is_paginated': isPaginated,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Pos List Payouts Daterangecompare
     * @param requestBody
     * @returns PosPayoutsDateRangeCompare Successful Response
     * @throws ApiError
     */
    static posListPayoutsDateRangeCompareApiDateRangeComparePosListPayoutsPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/pos/list_payouts',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Pos List Payouts Daterangecomparegranular
     * @param requestBody
     * @returns PosPayoutsDateRangeCompareGranular Successful Response
     * @throws ApiError
     */
    static posListPayoutsDateRangeCompareGranularApiDateRangeCompareGranularPosListPayoutsPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/granular/pos/list_payouts',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Export Pos List Payouts
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static exportPosListPayoutsApiExportPosListPayoutsPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/export/pos/list_payouts',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Pos Aggregate Metrics For 3P Vs Pos Orders
     * @param requestBody
     * @returns PosThirdPartyOrdersAggregate Successful Response
     * @throws ApiError
     */
    static callPosAggregateMetricsFor3PVsPosOrdersApiPosAggregateMetricsFor3PVsPosOrdersPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/pos/aggregate_metrics_for_3p_vs_pos_orders',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Pos Aggregate Metrics For 3P Vs Pos Orders Daterangecompare
     * @param requestBody
     * @returns PosThirdPartyOrdersAggregateDateRangeCompare Successful Response
     * @throws ApiError
     */
    static posAggregateMetricsFor3PVsPosOrdersDateRangeCompareApiDateRangeComparePosAggregateMetricsFor3PVsPosOrdersPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/pos/aggregate_metrics_for_3p_vs_pos_orders',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Salessummary
     * @param requestBody
     * @returns SalesSummaryModel Successful Response
     * @throws ApiError
     */
    static callSalesSummaryApiSalesSummaryPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/SalesSummary',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Salessummary Daterangecompare
     * @param requestBody
     * @returns SalesSummaryModelDateRangeCompare Successful Response
     * @throws ApiError
     */
    static salesSummaryDateRangeCompareApiDateRangeCompareSalesSummaryPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/SalesSummary',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Campaigninactive
     * @param requestBody
     * @returns CampaignInactive Successful Response
     * @throws ApiError
     */
    static callCampaignInactiveApiCampaignInactivePost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/CampaignInactive',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Campaigninactive
     * @param requestBody
     * @param isPaginated
     * @returns CampaignInactivePaginated Successful Response
     * @throws ApiError
     */
    static callCampaignInactiveApiPaginatedCampaignInactivePost(requestBody, isPaginated = true) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/paginated/CampaignInactive',
            query: {
                'is_paginated': isPaginated,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Campaigninactive Daterangecompare
     * @param requestBody
     * @returns CampaignInactiveDateRangeCompare Successful Response
     * @throws ApiError
     */
    static campaignInactiveDateRangeCompareApiDateRangeCompareCampaignInactivePost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/CampaignInactive',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Campaigninactive Daterangecomparegranular
     * @param requestBody
     * @returns CampaignInactiveDateRangeCompareGranular Successful Response
     * @throws ApiError
     */
    static campaignInactiveDateRangeCompareGranularApiDateRangeCompareGranularCampaignInactivePost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/granular/CampaignInactive',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Export Campaigninactive
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static exportCampaignInactiveApiExportCampaignInactivePost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/export/CampaignInactive',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Order Accuracy Error Orders By Shift
     * @param requestBody
     * @returns ErrorOrdersByShift Successful Response
     * @throws ApiError
     */
    static callOrderAccuracyErrorOrdersByShiftApiOrderAccuracyErrorOrdersByShiftPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/order_accuracy/error_orders_by_shift',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Order Accuracy Error Orders By Shift
     * @param requestBody
     * @param isPaginated
     * @returns ErrorOrdersByShiftPaginated Successful Response
     * @throws ApiError
     */
    static callOrderAccuracyErrorOrdersByShiftApiPaginatedOrderAccuracyErrorOrdersByShiftPost(requestBody, isPaginated = true) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/paginated/order_accuracy/error_orders_by_shift',
            query: {
                'is_paginated': isPaginated,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Order Accuracy Error Orders By Shift Daterangecompare
     * @param requestBody
     * @returns ErrorOrdersByShiftDateRangeCompare Successful Response
     * @throws ApiError
     */
    static orderAccuracyErrorOrdersByShiftDateRangeCompareApiDateRangeCompareOrderAccuracyErrorOrdersByShiftPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/order_accuracy/error_orders_by_shift',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Order Accuracy Error Orders By Shift Daterangecomparegranular
     * @param requestBody
     * @returns ErrorOrdersByShiftDateRangeCompareGranular Successful Response
     * @throws ApiError
     */
    static orderAccuracyErrorOrdersByShiftDateRangeCompareGranularApiDateRangeCompareGranularOrderAccuracyErrorOrdersByShiftPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/granular/order_accuracy/error_orders_by_shift',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Export Order Accuracy Error Orders By Shift
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static exportOrderAccuracyErrorOrdersByShiftApiExportOrderAccuracyErrorOrdersByShiftPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/export/order_accuracy/error_orders_by_shift',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Drill Down Generated Financeordertransactions Grouped List Of Entries
     * @param requestBody
     * @returns FinanceOrderTransactionsDrillDownOutput Successful Response
     * @throws ApiError
     */
    static callDrillDownGeneratedFinanceOrderTransactionsGroupedListOfEntriesApiDrillDownGeneratedFinanceOrderTransactionsGroupedListOfEntriesPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/drill_down_generated/FinanceOrderTransactions/grouped_list_of_entries',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Drill Down Generated Financeordertransactions Grouped List Of Entries
     * @param requestBody
     * @param isPaginated
     * @returns FinanceOrderTransactionsDrillDownOutputPaginated Successful Response
     * @throws ApiError
     */
    static callDrillDownGeneratedFinanceOrderTransactionsGroupedListOfEntriesApiPaginatedDrillDownGeneratedFinanceOrderTransactionsGroupedListOfEntriesPost(requestBody, isPaginated = true) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/paginated/drill_down_generated/FinanceOrderTransactions/grouped_list_of_entries',
            query: {
                'is_paginated': isPaginated,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Drill Down Generated Financeordertransactions Grouped List Of Entries Daterangecompare
     * @param requestBody
     * @returns FinanceOrderTransactionsDrillDownOutputDateRangeCompare Successful Response
     * @throws ApiError
     */
    static drillDownGeneratedFinanceOrderTransactionsGroupedListOfEntriesDateRangeCompareApiDateRangeCompareDrillDownGeneratedFinanceOrderTransactionsGroupedListOfEntriesPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/drill_down_generated/FinanceOrderTransactions/grouped_list_of_entries',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Drill Down Generated Financeordertransactions Grouped List Of Entries Daterangecomparegranular
     * @param requestBody
     * @returns FinanceOrderTransactionsDrillDownOutputDateRangeCompareGranular Successful Response
     * @throws ApiError
     */
    static drillDownGeneratedFinanceOrderTransactionsGroupedListOfEntriesDateRangeCompareGranularApiDateRangeCompareGranularDrillDownGeneratedFinanceOrderTransactionsGroupedListOfEntriesPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/granular/drill_down_generated/FinanceOrderTransactions/grouped_list_of_entries',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Export Drill Down Generated Financeordertransactions Grouped List Of Entries
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static exportDrillDownGeneratedFinanceOrderTransactionsGroupedListOfEntriesApiExportDrillDownGeneratedFinanceOrderTransactionsGroupedListOfEntriesPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/export/drill_down_generated/FinanceOrderTransactions/grouped_list_of_entries',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Bookkeepingtransactions
     * @param requestBody
     * @returns BookKeepingTransactions Successful Response
     * @throws ApiError
     */
    static callBookKeepingTransactionsApiBookKeepingTransactionsPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/BookKeepingTransactions',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Bookkeepingtransactions
     * @param requestBody
     * @param isPaginated
     * @returns BookKeepingTransactionsPaginated Successful Response
     * @throws ApiError
     */
    static callBookKeepingTransactionsApiPaginatedBookKeepingTransactionsPost(requestBody, isPaginated = true) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/paginated/BookKeepingTransactions',
            query: {
                'is_paginated': isPaginated,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Bookkeepingtransactions Daterangecompare
     * @param requestBody
     * @returns BookKeepingTransactionsDateRangeCompare Successful Response
     * @throws ApiError
     */
    static bookKeepingTransactionsDateRangeCompareApiDateRangeCompareBookKeepingTransactionsPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/BookKeepingTransactions',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Bookkeepingtransactions Daterangecomparegranular
     * @param requestBody
     * @returns BookKeepingTransactionsDateRangeCompareGranular Successful Response
     * @throws ApiError
     */
    static bookKeepingTransactionsDateRangeCompareGranularApiDateRangeCompareGranularBookKeepingTransactionsPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/granular/BookKeepingTransactions',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Export Bookkeepingtransactions
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static exportBookKeepingTransactionsApiExportBookKeepingTransactionsPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/export/BookKeepingTransactions',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Benchmarks Bname Metrics
     * @param requestBody
     * @returns BenchmarkBNameMetrics Successful Response
     * @throws ApiError
     */
    static callBenchmarksBnameMetricsApiBenchmarksBnameMetricsPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/benchmarks/bname_metrics',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Benchmarks Bname Metrics
     * @param requestBody
     * @param isPaginated
     * @returns BenchmarkBNameMetricsPaginated Successful Response
     * @throws ApiError
     */
    static callBenchmarksBnameMetricsApiPaginatedBenchmarksBnameMetricsPost(requestBody, isPaginated = true) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/paginated/benchmarks/bname_metrics',
            query: {
                'is_paginated': isPaginated,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Benchmarks Bname Metrics Daterangecompare
     * @param requestBody
     * @returns BenchmarkBNameMetricsDateRangeCompare Successful Response
     * @throws ApiError
     */
    static benchmarksBnameMetricsDateRangeCompareApiDateRangeCompareBenchmarksBnameMetricsPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/benchmarks/bname_metrics',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Benchmarks Bname Metrics Daterangecomparegranular
     * @param requestBody
     * @returns BenchmarkBNameMetricsDateRangeCompareGranular Successful Response
     * @throws ApiError
     */
    static benchmarksBnameMetricsDateRangeCompareGranularApiDateRangeCompareGranularBenchmarksBnameMetricsPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/granular/benchmarks/bname_metrics',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Export Benchmarks Bname Metrics
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static exportBenchmarksBnameMetricsApiExportBenchmarksBnameMetricsPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/export/benchmarks/bname_metrics',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Campaigncount
     * @param requestBody
     * @returns CampaignCountAggregate Successful Response
     * @throws ApiError
     */
    static callCampaignCountApiCampaignCountPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/CampaignCount',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Campaigncount Daterangecompare
     * @param requestBody
     * @returns CampaignCountAggregateDateRangeCompare Successful Response
     * @throws ApiError
     */
    static campaignCountDateRangeCompareApiDateRangeCompareCampaignCountPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/CampaignCount',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Accountingpushhistory
     * @param requestBody
     * @returns AccountingPushHistory Successful Response
     * @throws ApiError
     */
    static callAccountingPushHistoryApiAccountingPushHistoryPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/AccountingPushHistory',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Accountingpushhistory
     * @param requestBody
     * @param isPaginated
     * @returns AccountingPushHistoryPaginated Successful Response
     * @throws ApiError
     */
    static callAccountingPushHistoryApiPaginatedAccountingPushHistoryPost(requestBody, isPaginated = true) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/paginated/AccountingPushHistory',
            query: {
                'is_paginated': isPaginated,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Accountingpushhistory Daterangecompare
     * @param requestBody
     * @returns AccountingPushHistoryDateRangeCompare Successful Response
     * @throws ApiError
     */
    static accountingPushHistoryDateRangeCompareApiDateRangeCompareAccountingPushHistoryPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/AccountingPushHistory',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Accountingpushhistory Daterangecomparegranular
     * @param requestBody
     * @returns AccountingPushHistoryDateRangeCompareGranular Successful Response
     * @throws ApiError
     */
    static accountingPushHistoryDateRangeCompareGranularApiDateRangeCompareGranularAccountingPushHistoryPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/granular/AccountingPushHistory',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Export Accountingpushhistory
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static exportAccountingPushHistoryApiExportAccountingPushHistoryPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/export/AccountingPushHistory',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Drill Down Generated Financeordertransactions Unique Values
     * @param requestBody
     * @returns UniqueValuesForColumn Successful Response
     * @throws ApiError
     */
    static callDrillDownGeneratedFinanceOrderTransactionsUniqueValuesApiDrillDownGeneratedFinanceOrderTransactionsUniqueValuesPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/drill_down_generated/FinanceOrderTransactions/unique_values',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Drill Down Generated Financeordertransactions Unique Values
     * @param requestBody
     * @param isPaginated
     * @returns UniqueValuesForColumnPaginated Successful Response
     * @throws ApiError
     */
    static callDrillDownGeneratedFinanceOrderTransactionsUniqueValuesApiPaginatedDrillDownGeneratedFinanceOrderTransactionsUniqueValuesPost(requestBody, isPaginated = true) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/paginated/drill_down_generated/FinanceOrderTransactions/unique_values',
            query: {
                'is_paginated': isPaginated,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Drill Down Generated Financeordertransactions Unique Values Daterangecompare
     * @param requestBody
     * @returns UniqueValuesForColumnDateRangeCompare Successful Response
     * @throws ApiError
     */
    static drillDownGeneratedFinanceOrderTransactionsUniqueValuesDateRangeCompareApiDateRangeCompareDrillDownGeneratedFinanceOrderTransactionsUniqueValuesPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/drill_down_generated/FinanceOrderTransactions/unique_values',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Drill Down Generated Financeordertransactions Unique Values Daterangecomparegranular
     * @param requestBody
     * @returns UniqueValuesForColumnDateRangeCompareGranular Successful Response
     * @throws ApiError
     */
    static drillDownGeneratedFinanceOrderTransactionsUniqueValuesDateRangeCompareGranularApiDateRangeCompareGranularDrillDownGeneratedFinanceOrderTransactionsUniqueValuesPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/granular/drill_down_generated/FinanceOrderTransactions/unique_values',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Export Drill Down Generated Financeordertransactions Unique Values
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static exportDrillDownGeneratedFinanceOrderTransactionsUniqueValuesApiExportDrillDownGeneratedFinanceOrderTransactionsUniqueValuesPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/export/drill_down_generated/FinanceOrderTransactions/unique_values',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Kpi Dashboard Salesdatewise
     * @param requestBody
     * @returns SalesDatewise Successful Response
     * @throws ApiError
     */
    static callKpiDashboardSalesDatewiseApiKpiDashboardSalesDatewisePost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/kpi_dashboard/SalesDatewise',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Kpi Dashboard Salesdatewise
     * @param requestBody
     * @param isPaginated
     * @returns SalesDatewisePaginated Successful Response
     * @throws ApiError
     */
    static callKpiDashboardSalesDatewiseApiPaginatedKpiDashboardSalesDatewisePost(requestBody, isPaginated = true) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/paginated/kpi_dashboard/SalesDatewise',
            query: {
                'is_paginated': isPaginated,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Kpi Dashboard Salesdatewise Daterangecompare
     * @param requestBody
     * @returns SalesDatewiseDateRangeCompare Successful Response
     * @throws ApiError
     */
    static kpiDashboardSalesDatewiseDateRangeCompareApiDateRangeCompareKpiDashboardSalesDatewisePost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/kpi_dashboard/SalesDatewise',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Kpi Dashboard Salesdatewise Daterangecomparegranular
     * @param requestBody
     * @returns SalesDatewiseDateRangeCompareGranular Successful Response
     * @throws ApiError
     */
    static kpiDashboardSalesDatewiseDateRangeCompareGranularApiDateRangeCompareGranularKpiDashboardSalesDatewisePost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/granular/kpi_dashboard/SalesDatewise',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Export Kpi Dashboard Salesdatewise
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static exportKpiDashboardSalesDatewiseApiExportKpiDashboardSalesDatewisePost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/export/kpi_dashboard/SalesDatewise',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Storeavailabilitysummary
     * @param requestBody
     * @returns StoreAvailabilitySummary Successful Response
     * @throws ApiError
     */
    static callStoreAvailabilitySummaryApiStoreAvailabilitySummaryPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/StoreAvailabilitySummary',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Storeavailabilitysummary
     * @param requestBody
     * @param isPaginated
     * @returns StoreAvailabilitySummaryPaginated Successful Response
     * @throws ApiError
     */
    static callStoreAvailabilitySummaryApiPaginatedStoreAvailabilitySummaryPost(requestBody, isPaginated = true) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/paginated/StoreAvailabilitySummary',
            query: {
                'is_paginated': isPaginated,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Storeavailabilitysummary Daterangecompare
     * @param requestBody
     * @returns StoreAvailabilitySummaryDateRangeCompare Successful Response
     * @throws ApiError
     */
    static storeAvailabilitySummaryDateRangeCompareApiDateRangeCompareStoreAvailabilitySummaryPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/StoreAvailabilitySummary',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Storeavailabilitysummary Daterangecomparegranular
     * @param requestBody
     * @returns StoreAvailabilitySummaryDateRangeCompareGranular Successful Response
     * @throws ApiError
     */
    static storeAvailabilitySummaryDateRangeCompareGranularApiDateRangeCompareGranularStoreAvailabilitySummaryPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/granular/StoreAvailabilitySummary',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Export Storeavailabilitysummary
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static exportStoreAvailabilitySummaryApiExportStoreAvailabilitySummaryPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/export/StoreAvailabilitySummary',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Pos Payouts Summary
     * @param requestBody
     * @returns PosPayoutsSummaryAggregate Successful Response
     * @throws ApiError
     */
    static callPosPayoutsSummaryApiPosPayoutsSummaryPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/pos/payouts_summary',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Pos Payouts Summary Daterangecompare
     * @param requestBody
     * @returns PosPayoutsSummaryAggregateDateRangeCompare Successful Response
     * @throws ApiError
     */
    static posPayoutsSummaryDateRangeCompareApiDateRangeComparePosPayoutsSummaryPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/pos/payouts_summary',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Store Mapping History
     * @param requestBody
     * @returns dynamic__models__StoreMappingHistory__StoreMappingHistory Successful Response
     * @throws ApiError
     */
    static callStoreMappingHistoryApiStoreMappingHistoryPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/store_mapping_history',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Store Mapping History
     * @param requestBody
     * @param isPaginated
     * @returns StoreMappingHistoryPaginated Successful Response
     * @throws ApiError
     */
    static callStoreMappingHistoryApiPaginatedStoreMappingHistoryPost(requestBody, isPaginated = true) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/paginated/store_mapping_history',
            query: {
                'is_paginated': isPaginated,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Store Mapping History Daterangecompare
     * @param requestBody
     * @returns StoreMappingHistoryDateRangeCompare Successful Response
     * @throws ApiError
     */
    static storeMappingHistoryDateRangeCompareApiDateRangeCompareStoreMappingHistoryPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/store_mapping_history',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Store Mapping History Daterangecomparegranular
     * @param requestBody
     * @returns StoreMappingHistoryDateRangeCompareGranular Successful Response
     * @throws ApiError
     */
    static storeMappingHistoryDateRangeCompareGranularApiDateRangeCompareGranularStoreMappingHistoryPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/granular/store_mapping_history',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Export Store Mapping History
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static exportStoreMappingHistoryApiExportStoreMappingHistoryPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/export/store_mapping_history',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Ratingssummary
     * @param requestBody
     * @returns RatingsSummaryModel Successful Response
     * @throws ApiError
     */
    static callRatingsSummaryApiRatingsSummaryPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/RatingsSummary',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Ratingssummary Daterangecompare
     * @param requestBody
     * @returns RatingsSummaryModelDateRangeCompare Successful Response
     * @throws ApiError
     */
    static ratingsSummaryDateRangeCompareApiDateRangeCompareRatingsSummaryPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/RatingsSummary',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Storemappingsalesanddowntime
     * @param requestBody
     * @returns StoreMappingSalesAndDowntime Successful Response
     * @throws ApiError
     */
    static callStoreMappingSalesAndDowntimeApiStoreMappingSalesAndDowntimePost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/StoreMappingSalesAndDowntime',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Storemappingsalesanddowntime
     * @param requestBody
     * @param isPaginated
     * @returns StoreMappingSalesAndDowntimePaginated Successful Response
     * @throws ApiError
     */
    static callStoreMappingSalesAndDowntimeApiPaginatedStoreMappingSalesAndDowntimePost(requestBody, isPaginated = true) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/paginated/StoreMappingSalesAndDowntime',
            query: {
                'is_paginated': isPaginated,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Storemappingsalesanddowntime Daterangecompare
     * @param requestBody
     * @returns StoreMappingSalesAndDowntimeDateRangeCompare Successful Response
     * @throws ApiError
     */
    static storeMappingSalesAndDowntimeDateRangeCompareApiDateRangeCompareStoreMappingSalesAndDowntimePost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/StoreMappingSalesAndDowntime',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Storemappingsalesanddowntime Daterangecomparegranular
     * @param requestBody
     * @returns StoreMappingSalesAndDowntimeDateRangeCompareGranular Successful Response
     * @throws ApiError
     */
    static storeMappingSalesAndDowntimeDateRangeCompareGranularApiDateRangeCompareGranularStoreMappingSalesAndDowntimePost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/granular/StoreMappingSalesAndDowntime',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Export Storemappingsalesanddowntime
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static exportStoreMappingSalesAndDowntimeApiExportStoreMappingSalesAndDowntimePost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/export/StoreMappingSalesAndDowntime',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Adsdetails
     * @param requestBody
     * @returns AdsDetailsAggregate Successful Response
     * @throws ApiError
     */
    static callAdsDetailsApiAdsDetailsPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/AdsDetails',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Adsdetails Daterangecompare
     * @param requestBody
     * @returns AdsDetailsAggregateDateRangeCompare Successful Response
     * @throws ApiError
     */
    static adsDetailsDateRangeCompareApiDateRangeCompareAdsDetailsPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/AdsDetails',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Inactivestores
     * @param requestBody
     * @returns InactiveStores Successful Response
     * @throws ApiError
     */
    static callInactiveStoresApiInactiveStoresPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/InactiveStores',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Inactivestores
     * @param requestBody
     * @param isPaginated
     * @returns InactiveStoresPaginated Successful Response
     * @throws ApiError
     */
    static callInactiveStoresApiPaginatedInactiveStoresPost(requestBody, isPaginated = true) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/paginated/InactiveStores',
            query: {
                'is_paginated': isPaginated,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Inactivestores Daterangecompare
     * @param requestBody
     * @returns InactiveStoresDateRangeCompare Successful Response
     * @throws ApiError
     */
    static inactiveStoresDateRangeCompareApiDateRangeCompareInactiveStoresPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/InactiveStores',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Inactivestores Daterangecomparegranular
     * @param requestBody
     * @returns InactiveStoresDateRangeCompareGranular Successful Response
     * @throws ApiError
     */
    static inactiveStoresDateRangeCompareGranularApiDateRangeCompareGranularInactiveStoresPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/granular/InactiveStores',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Export Inactivestores
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static exportInactiveStoresApiExportInactiveStoresPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/export/InactiveStores',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Drill Down Generated Ratings Grouped List Of Entries
     * @param requestBody
     * @returns RatingsDrillDownOutput Successful Response
     * @throws ApiError
     */
    static callDrillDownGeneratedRatingsGroupedListOfEntriesApiDrillDownGeneratedRatingsGroupedListOfEntriesPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/drill_down_generated/Ratings/grouped_list_of_entries',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Drill Down Generated Ratings Grouped List Of Entries
     * @param requestBody
     * @param isPaginated
     * @returns RatingsDrillDownOutputPaginated Successful Response
     * @throws ApiError
     */
    static callDrillDownGeneratedRatingsGroupedListOfEntriesApiPaginatedDrillDownGeneratedRatingsGroupedListOfEntriesPost(requestBody, isPaginated = true) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/paginated/drill_down_generated/Ratings/grouped_list_of_entries',
            query: {
                'is_paginated': isPaginated,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Drill Down Generated Ratings Grouped List Of Entries Daterangecompare
     * @param requestBody
     * @returns RatingsDrillDownOutputDateRangeCompare Successful Response
     * @throws ApiError
     */
    static drillDownGeneratedRatingsGroupedListOfEntriesDateRangeCompareApiDateRangeCompareDrillDownGeneratedRatingsGroupedListOfEntriesPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/drill_down_generated/Ratings/grouped_list_of_entries',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Drill Down Generated Ratings Grouped List Of Entries Daterangecomparegranular
     * @param requestBody
     * @returns RatingsDrillDownOutputDateRangeCompareGranular Successful Response
     * @throws ApiError
     */
    static drillDownGeneratedRatingsGroupedListOfEntriesDateRangeCompareGranularApiDateRangeCompareGranularDrillDownGeneratedRatingsGroupedListOfEntriesPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/granular/drill_down_generated/Ratings/grouped_list_of_entries',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Export Drill Down Generated Ratings Grouped List Of Entries
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static exportDrillDownGeneratedRatingsGroupedListOfEntriesApiExportDrillDownGeneratedRatingsGroupedListOfEntriesPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/export/drill_down_generated/Ratings/grouped_list_of_entries',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Pos Pos 3P Orders Variance
     * @param requestBody
     * @returns Pos3POrdersVariance Successful Response
     * @throws ApiError
     */
    static callPosPos3POrdersVarianceApiPosPos3POrdersVariancePost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/pos/pos_3p_orders_variance',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Pos Pos 3P Orders Variance
     * @param requestBody
     * @param isPaginated
     * @returns Pos3POrdersVariancePaginated Successful Response
     * @throws ApiError
     */
    static callPosPos3POrdersVarianceApiPaginatedPosPos3POrdersVariancePost(requestBody, isPaginated = true) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/paginated/pos/pos_3p_orders_variance',
            query: {
                'is_paginated': isPaginated,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Pos Pos 3P Orders Variance Daterangecompare
     * @param requestBody
     * @returns Pos3POrdersVarianceDateRangeCompare Successful Response
     * @throws ApiError
     */
    static posPos3POrdersVarianceDateRangeCompareApiDateRangeComparePosPos3POrdersVariancePost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/pos/pos_3p_orders_variance',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Pos Pos 3P Orders Variance Daterangecomparegranular
     * @param requestBody
     * @returns Pos3POrdersVarianceDateRangeCompareGranular Successful Response
     * @throws ApiError
     */
    static posPos3POrdersVarianceDateRangeCompareGranularApiDateRangeCompareGranularPosPos3POrdersVariancePost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/granular/pos/pos_3p_orders_variance',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Export Pos Pos 3P Orders Variance
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static exportPosPos3POrdersVarianceApiExportPosPos3POrdersVariancePost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/export/pos/pos_3p_orders_variance',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Marketingkpisummary
     * @param requestBody
     * @returns MarketingKPISummaryModel Successful Response
     * @throws ApiError
     */
    static callMarketingKpiSummaryApiMarketingKpiSummaryPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/MarketingKPISummary',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Marketingkpisummary Daterangecompare
     * @param requestBody
     * @returns MarketingKPISummaryModelDateRangeCompare Successful Response
     * @throws ApiError
     */
    static marketingKpiSummaryDateRangeCompareApiDateRangeCompareMarketingKpiSummaryPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/MarketingKPISummary',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Storeavailabilityactions
     * @param requestBody
     * @returns StoreAvailabilityActions Successful Response
     * @throws ApiError
     */
    static callStoreAvailabilityActionsApiStoreAvailabilityActionsPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/StoreAvailabilityActions',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Storeavailabilityactions
     * @param requestBody
     * @param isPaginated
     * @returns StoreAvailabilityActionsPaginated Successful Response
     * @throws ApiError
     */
    static callStoreAvailabilityActionsApiPaginatedStoreAvailabilityActionsPost(requestBody, isPaginated = true) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/paginated/StoreAvailabilityActions',
            query: {
                'is_paginated': isPaginated,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Storeavailabilityactions Daterangecompare
     * @param requestBody
     * @returns StoreAvailabilityActionsDateRangeCompare Successful Response
     * @throws ApiError
     */
    static storeAvailabilityActionsDateRangeCompareApiDateRangeCompareStoreAvailabilityActionsPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/StoreAvailabilityActions',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Storeavailabilityactions Daterangecomparegranular
     * @param requestBody
     * @returns StoreAvailabilityActionsDateRangeCompareGranular Successful Response
     * @throws ApiError
     */
    static storeAvailabilityActionsDateRangeCompareGranularApiDateRangeCompareGranularStoreAvailabilityActionsPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/granular/StoreAvailabilityActions',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Export Storeavailabilityactions
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static exportStoreAvailabilityActionsApiExportStoreAvailabilityActionsPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/export/StoreAvailabilityActions',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Accountingjournals
     * @param requestBody
     * @returns AccountingJournals Successful Response
     * @throws ApiError
     */
    static callAccountingJournalsApiAccountingJournalsPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/AccountingJournals',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Accountingjournals
     * @param requestBody
     * @param isPaginated
     * @returns AccountingJournalsPaginated Successful Response
     * @throws ApiError
     */
    static callAccountingJournalsApiPaginatedAccountingJournalsPost(requestBody, isPaginated = true) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/paginated/AccountingJournals',
            query: {
                'is_paginated': isPaginated,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Accountingjournals Daterangecompare
     * @param requestBody
     * @returns AccountingJournalsDateRangeCompare Successful Response
     * @throws ApiError
     */
    static accountingJournalsDateRangeCompareApiDateRangeCompareAccountingJournalsPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/AccountingJournals',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Accountingjournals Daterangecomparegranular
     * @param requestBody
     * @returns AccountingJournalsDateRangeCompareGranular Successful Response
     * @throws ApiError
     */
    static accountingJournalsDateRangeCompareGranularApiDateRangeCompareGranularAccountingJournalsPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/granular/AccountingJournals',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Export Accountingjournals
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static exportAccountingJournalsApiExportAccountingJournalsPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/export/AccountingJournals',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Uptimebylocation
     * @param requestBody
     * @returns UptimeByLocation Successful Response
     * @throws ApiError
     */
    static callUptimeByLocationApiUptimeByLocationPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/UptimeByLocation',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Uptimebylocation
     * @param requestBody
     * @param isPaginated
     * @returns UptimeByLocationPaginated Successful Response
     * @throws ApiError
     */
    static callUptimeByLocationApiPaginatedUptimeByLocationPost(requestBody, isPaginated = true) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/paginated/UptimeByLocation',
            query: {
                'is_paginated': isPaginated,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Uptimebylocation Daterangecompare
     * @param requestBody
     * @returns UptimeByLocationDateRangeCompare Successful Response
     * @throws ApiError
     */
    static uptimeByLocationDateRangeCompareApiDateRangeCompareUptimeByLocationPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/UptimeByLocation',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Uptimebylocation Daterangecomparegranular
     * @param requestBody
     * @returns UptimeByLocationDateRangeCompareGranular Successful Response
     * @throws ApiError
     */
    static uptimeByLocationDateRangeCompareGranularApiDateRangeCompareGranularUptimeByLocationPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/granular/UptimeByLocation',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Export Uptimebylocation
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static exportUptimeByLocationApiExportUptimeByLocationPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/export/UptimeByLocation',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Kpi Dashboard Thirdpartyfeedatewise
     * @param requestBody
     * @returns ThirdPartyFeeDatewise Successful Response
     * @throws ApiError
     */
    static callKpiDashboardThirdPartyFeeDatewiseApiKpiDashboardThirdPartyFeeDatewisePost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/kpi_dashboard/ThirdPartyFeeDatewise',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Kpi Dashboard Thirdpartyfeedatewise
     * @param requestBody
     * @param isPaginated
     * @returns ThirdPartyFeeDatewisePaginated Successful Response
     * @throws ApiError
     */
    static callKpiDashboardThirdPartyFeeDatewiseApiPaginatedKpiDashboardThirdPartyFeeDatewisePost(requestBody, isPaginated = true) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/paginated/kpi_dashboard/ThirdPartyFeeDatewise',
            query: {
                'is_paginated': isPaginated,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Kpi Dashboard Thirdpartyfeedatewise Daterangecompare
     * @param requestBody
     * @returns ThirdPartyFeeDatewiseDateRangeCompare Successful Response
     * @throws ApiError
     */
    static kpiDashboardThirdPartyFeeDatewiseDateRangeCompareApiDateRangeCompareKpiDashboardThirdPartyFeeDatewisePost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/kpi_dashboard/ThirdPartyFeeDatewise',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Kpi Dashboard Thirdpartyfeedatewise Daterangecomparegranular
     * @param requestBody
     * @returns ThirdPartyFeeDatewiseDateRangeCompareGranular Successful Response
     * @throws ApiError
     */
    static kpiDashboardThirdPartyFeeDatewiseDateRangeCompareGranularApiDateRangeCompareGranularKpiDashboardThirdPartyFeeDatewisePost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/granular/kpi_dashboard/ThirdPartyFeeDatewise',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Export Kpi Dashboard Thirdpartyfeedatewise
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static exportKpiDashboardThirdPartyFeeDatewiseApiExportKpiDashboardThirdPartyFeeDatewisePost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/export/kpi_dashboard/ThirdPartyFeeDatewise',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Pos List Transactions For Payout
     * @param requestBody
     * @returns PosTransactionsForPayout Successful Response
     * @throws ApiError
     */
    static callPosListTransactionsForPayoutApiPosListTransactionsForPayoutPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/pos/list_transactions_for_payout',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Pos List Transactions For Payout
     * @param requestBody
     * @param isPaginated
     * @returns PosTransactionsForPayoutPaginated Successful Response
     * @throws ApiError
     */
    static callPosListTransactionsForPayoutApiPaginatedPosListTransactionsForPayoutPost(requestBody, isPaginated = true) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/paginated/pos/list_transactions_for_payout',
            query: {
                'is_paginated': isPaginated,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Pos List Transactions For Payout Daterangecompare
     * @param requestBody
     * @returns PosTransactionsForPayoutDateRangeCompare Successful Response
     * @throws ApiError
     */
    static posListTransactionsForPayoutDateRangeCompareApiDateRangeComparePosListTransactionsForPayoutPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/pos/list_transactions_for_payout',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Pos List Transactions For Payout Daterangecomparegranular
     * @param requestBody
     * @returns PosTransactionsForPayoutDateRangeCompareGranular Successful Response
     * @throws ApiError
     */
    static posListTransactionsForPayoutDateRangeCompareGranularApiDateRangeCompareGranularPosListTransactionsForPayoutPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/granular/pos/list_transactions_for_payout',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Export Pos List Transactions For Payout
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static exportPosListTransactionsForPayoutApiExportPosListTransactionsForPayoutPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/export/pos/list_transactions_for_payout',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Ratingreview
     * @param requestBody
     * @returns RatingReview Successful Response
     * @throws ApiError
     */
    static callRatingReviewApiRatingReviewPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/RatingReview',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Ratingreview
     * @param requestBody
     * @param isPaginated
     * @returns RatingReviewPaginated Successful Response
     * @throws ApiError
     */
    static callRatingReviewApiPaginatedRatingReviewPost(requestBody, isPaginated = true) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/paginated/RatingReview',
            query: {
                'is_paginated': isPaginated,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Ratingreview Daterangecompare
     * @param requestBody
     * @returns RatingReviewDateRangeCompare Successful Response
     * @throws ApiError
     */
    static ratingReviewDateRangeCompareApiDateRangeCompareRatingReviewPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/RatingReview',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Ratingreview Daterangecomparegranular
     * @param requestBody
     * @returns RatingReviewDateRangeCompareGranular Successful Response
     * @throws ApiError
     */
    static ratingReviewDateRangeCompareGranularApiDateRangeCompareGranularRatingReviewPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/granular/RatingReview',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Export Ratingreview
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static exportRatingReviewApiExportRatingReviewPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/export/RatingReview',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Lostsalesummary
     * @param requestBody
     * @returns LostSaleSummaryModel Successful Response
     * @throws ApiError
     */
    static callLostSaleSummaryApiLostSaleSummaryPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/LostSaleSummary',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Lostsalesummary Daterangecompare
     * @param requestBody
     * @returns LostSaleSummaryModelDateRangeCompare Successful Response
     * @throws ApiError
     */
    static lostSaleSummaryDateRangeCompareApiDateRangeCompareLostSaleSummaryPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/LostSaleSummary',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Ingestion Slug Daily Status
     * @param requestBody
     * @returns IngestionSlugDailyStatus Successful Response
     * @throws ApiError
     */
    static callIngestionSlugDailyStatusApiIngestionSlugDailyStatusPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/ingestion/slug_daily_status',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Ingestion Slug Daily Status
     * @param requestBody
     * @param isPaginated
     * @returns IngestionSlugDailyStatusPaginated Successful Response
     * @throws ApiError
     */
    static callIngestionSlugDailyStatusApiPaginatedIngestionSlugDailyStatusPost(requestBody, isPaginated = true) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/paginated/ingestion/slug_daily_status',
            query: {
                'is_paginated': isPaginated,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Ingestion Slug Daily Status Daterangecompare
     * @param requestBody
     * @returns IngestionSlugDailyStatusDateRangeCompare Successful Response
     * @throws ApiError
     */
    static ingestionSlugDailyStatusDateRangeCompareApiDateRangeCompareIngestionSlugDailyStatusPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/ingestion/slug_daily_status',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Ingestion Slug Daily Status Daterangecomparegranular
     * @param requestBody
     * @returns IngestionSlugDailyStatusDateRangeCompareGranular Successful Response
     * @throws ApiError
     */
    static ingestionSlugDailyStatusDateRangeCompareGranularApiDateRangeCompareGranularIngestionSlugDailyStatusPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/granular/ingestion/slug_daily_status',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Export Ingestion Slug Daily Status
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static exportIngestionSlugDailyStatusApiExportIngestionSlugDailyStatusPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/export/ingestion/slug_daily_status',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Order Accuracy Error Orders By Item
     * @param requestBody
     * @returns ErrorOrdersByItem Successful Response
     * @throws ApiError
     */
    static callOrderAccuracyErrorOrdersByItemApiOrderAccuracyErrorOrdersByItemPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/order_accuracy/error_orders_by_item',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Order Accuracy Error Orders By Item
     * @param requestBody
     * @param isPaginated
     * @returns ErrorOrdersByItemPaginated Successful Response
     * @throws ApiError
     */
    static callOrderAccuracyErrorOrdersByItemApiPaginatedOrderAccuracyErrorOrdersByItemPost(requestBody, isPaginated = true) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/paginated/order_accuracy/error_orders_by_item',
            query: {
                'is_paginated': isPaginated,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Order Accuracy Error Orders By Item Daterangecompare
     * @param requestBody
     * @returns ErrorOrdersByItemDateRangeCompare Successful Response
     * @throws ApiError
     */
    static orderAccuracyErrorOrdersByItemDateRangeCompareApiDateRangeCompareOrderAccuracyErrorOrdersByItemPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/order_accuracy/error_orders_by_item',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Order Accuracy Error Orders By Item Daterangecomparegranular
     * @param requestBody
     * @returns ErrorOrdersByItemDateRangeCompareGranular Successful Response
     * @throws ApiError
     */
    static orderAccuracyErrorOrdersByItemDateRangeCompareGranularApiDateRangeCompareGranularOrderAccuracyErrorOrdersByItemPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/granular/order_accuracy/error_orders_by_item',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Export Order Accuracy Error Orders By Item
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static exportOrderAccuracyErrorOrdersByItemApiExportOrderAccuracyErrorOrdersByItemPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/export/order_accuracy/error_orders_by_item',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Autoturnsummary
     * @param requestBody
     * @returns StoreAutoTurnSummaryAggregate Successful Response
     * @throws ApiError
     */
    static callAutoTurnSummaryApiAutoTurnSummaryPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/AutoTurnSummary',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Autoturnsummary Daterangecompare
     * @param requestBody
     * @returns StoreAutoTurnSummaryAggregateDateRangeCompare Successful Response
     * @throws ApiError
     */
    static autoTurnSummaryDateRangeCompareApiDateRangeCompareAutoTurnSummaryPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/AutoTurnSummary',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Bookkeepingtotalaggregate
     * @param requestBody
     * @returns BookKeepingTotalAggregate Successful Response
     * @throws ApiError
     */
    static callBookKeepingTotalAggregateApiBookKeepingTotalAggregatePost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/BookKeepingTotalAggregate',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Bookkeepingtotalaggregate Daterangecompare
     * @param requestBody
     * @returns BookKeepingTotalAggregateDateRangeCompare Successful Response
     * @throws ApiError
     */
    static bookKeepingTotalAggregateDateRangeCompareApiDateRangeCompareBookKeepingTotalAggregatePost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/BookKeepingTotalAggregate',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Uptimebyplatform
     * @param requestBody
     * @returns UptimeByPlatform Successful Response
     * @throws ApiError
     */
    static callUptimeByPlatformApiUptimeByPlatformPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/UptimeByPlatform',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Uptimebyplatform
     * @param requestBody
     * @param isPaginated
     * @returns UptimeByPlatformPaginated Successful Response
     * @throws ApiError
     */
    static callUptimeByPlatformApiPaginatedUptimeByPlatformPost(requestBody, isPaginated = true) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/paginated/UptimeByPlatform',
            query: {
                'is_paginated': isPaginated,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Uptimebyplatform Daterangecompare
     * @param requestBody
     * @returns UptimeByPlatformDateRangeCompare Successful Response
     * @throws ApiError
     */
    static uptimeByPlatformDateRangeCompareApiDateRangeCompareUptimeByPlatformPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/UptimeByPlatform',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Uptimebyplatform Daterangecomparegranular
     * @param requestBody
     * @returns UptimeByPlatformDateRangeCompareGranular Successful Response
     * @throws ApiError
     */
    static uptimeByPlatformDateRangeCompareGranularApiDateRangeCompareGranularUptimeByPlatformPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/granular/UptimeByPlatform',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Export Uptimebyplatform
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static exportUptimeByPlatformApiExportUptimeByPlatformPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/export/UptimeByPlatform',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Olo Store Finances
     * @param requestBody
     * @returns OloStoreFinance Successful Response
     * @throws ApiError
     */
    static callOloStoreFinancesApiOloStoreFinancesPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/olo/store_finances',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Olo Store Finances
     * @param requestBody
     * @param isPaginated
     * @returns OloStoreFinancePaginated Successful Response
     * @throws ApiError
     */
    static callOloStoreFinancesApiPaginatedOloStoreFinancesPost(requestBody, isPaginated = true) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/paginated/olo/store_finances',
            query: {
                'is_paginated': isPaginated,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Olo Store Finances Daterangecompare
     * @param requestBody
     * @returns OloStoreFinanceDateRangeCompare Successful Response
     * @throws ApiError
     */
    static oloStoreFinancesDateRangeCompareApiDateRangeCompareOloStoreFinancesPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/olo/store_finances',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Olo Store Finances Daterangecomparegranular
     * @param requestBody
     * @returns OloStoreFinanceDateRangeCompareGranular Successful Response
     * @throws ApiError
     */
    static oloStoreFinancesDateRangeCompareGranularApiDateRangeCompareGranularOloStoreFinancesPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/granular/olo/store_finances',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Export Olo Store Finances
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static exportOloStoreFinancesApiExportOloStoreFinancesPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/export/olo/store_finances',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Financepayoutplatform
     * @param requestBody
     * @returns FinancePayoutPlatform Successful Response
     * @throws ApiError
     */
    static callFinancePayoutPlatformApiFinancePayoutPlatformPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/FinancePayoutPlatform',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Financepayoutplatform
     * @param requestBody
     * @param isPaginated
     * @returns FinancePayoutPlatformPaginated Successful Response
     * @throws ApiError
     */
    static callFinancePayoutPlatformApiPaginatedFinancePayoutPlatformPost(requestBody, isPaginated = true) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/paginated/FinancePayoutPlatform',
            query: {
                'is_paginated': isPaginated,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Financepayoutplatform Daterangecompare
     * @param requestBody
     * @returns FinancePayoutPlatformDateRangeCompare Successful Response
     * @throws ApiError
     */
    static financePayoutPlatformDateRangeCompareApiDateRangeCompareFinancePayoutPlatformPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/FinancePayoutPlatform',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Financepayoutplatform Daterangecomparegranular
     * @param requestBody
     * @returns FinancePayoutPlatformDateRangeCompareGranular Successful Response
     * @throws ApiError
     */
    static financePayoutPlatformDateRangeCompareGranularApiDateRangeCompareGranularFinancePayoutPlatformPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/granular/FinancePayoutPlatform',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Export Financepayoutplatform
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static exportFinancePayoutPlatformApiExportFinancePayoutPlatformPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/export/FinancePayoutPlatform',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Error Subcategories
     * @param requestBody
     * @returns OrdersErrorSubcategory Successful Response
     * @throws ApiError
     */
    static callErrorSubcategoriesApiErrorSubcategoriesPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/error_subcategories',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Error Subcategories
     * @param requestBody
     * @param isPaginated
     * @returns OrdersErrorSubcategoryPaginated Successful Response
     * @throws ApiError
     */
    static callErrorSubcategoriesApiPaginatedErrorSubcategoriesPost(requestBody, isPaginated = true) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/paginated/error_subcategories',
            query: {
                'is_paginated': isPaginated,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Error Subcategories Daterangecompare
     * @param requestBody
     * @returns OrdersErrorSubcategoryDateRangeCompare Successful Response
     * @throws ApiError
     */
    static errorSubcategoriesDateRangeCompareApiDateRangeCompareErrorSubcategoriesPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/error_subcategories',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Error Subcategories Daterangecomparegranular
     * @param requestBody
     * @returns OrdersErrorSubcategoryDateRangeCompareGranular Successful Response
     * @throws ApiError
     */
    static errorSubcategoriesDateRangeCompareGranularApiDateRangeCompareGranularErrorSubcategoriesPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/granular/error_subcategories',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Export Error Subcategories
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static exportErrorSubcategoriesApiExportErrorSubcategoriesPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/export/error_subcategories',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Campaigndetailv2
     * @param requestBody
     * @returns CampaignDetailPaginatedV2 Successful Response
     * @throws ApiError
     */
    static callCampaignDetailV2ApiCampaignDetailV2Post(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/CampaignDetailV2',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Campaigndetailv2
     * @param requestBody
     * @param isPaginated
     * @returns CampaignDetailPaginatedV2Paginated Successful Response
     * @throws ApiError
     */
    static callCampaignDetailV2ApiPaginatedCampaignDetailV2Post(requestBody, isPaginated = true) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/paginated/CampaignDetailV2',
            query: {
                'is_paginated': isPaginated,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Campaigndetailv2 Daterangecompare
     * @param requestBody
     * @returns CampaignDetailPaginatedV2DateRangeCompare Successful Response
     * @throws ApiError
     */
    static campaignDetailV2DateRangeCompareApiDateRangeCompareCampaignDetailV2Post(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/CampaignDetailV2',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Campaigndetailv2 Daterangecomparegranular
     * @param requestBody
     * @returns CampaignDetailPaginatedV2DateRangeCompareGranular Successful Response
     * @throws ApiError
     */
    static campaignDetailV2DateRangeCompareGranularApiDateRangeCompareGranularCampaignDetailV2Post(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/granular/CampaignDetailV2',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Export Campaigndetailv2
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static exportCampaignDetailV2ApiExportCampaignDetailV2Post(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/export/CampaignDetailV2',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Order Accuracy Error Chart
     * @param requestBody
     * @returns ErrorChart Successful Response
     * @throws ApiError
     */
    static callOrderAccuracyErrorChartApiOrderAccuracyErrorChartPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/order_accuracy/error_chart',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Order Accuracy Error Chart
     * @param requestBody
     * @param isPaginated
     * @returns ErrorChartPaginated Successful Response
     * @throws ApiError
     */
    static callOrderAccuracyErrorChartApiPaginatedOrderAccuracyErrorChartPost(requestBody, isPaginated = true) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/paginated/order_accuracy/error_chart',
            query: {
                'is_paginated': isPaginated,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Order Accuracy Error Chart Daterangecompare
     * @param requestBody
     * @returns ErrorChartDateRangeCompare Successful Response
     * @throws ApiError
     */
    static orderAccuracyErrorChartDateRangeCompareApiDateRangeCompareOrderAccuracyErrorChartPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/order_accuracy/error_chart',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Order Accuracy Error Chart Daterangecomparegranular
     * @param requestBody
     * @returns ErrorChartDateRangeCompareGranular Successful Response
     * @throws ApiError
     */
    static orderAccuracyErrorChartDateRangeCompareGranularApiDateRangeCompareGranularOrderAccuracyErrorChartPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/granular/order_accuracy/error_chart',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Export Order Accuracy Error Chart
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static exportOrderAccuracyErrorChartApiExportOrderAccuracyErrorChartPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/export/order_accuracy/error_chart',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Order Channels
     * @param requestBody
     * @returns OrderChannels Successful Response
     * @throws ApiError
     */
    static callOrderChannelsApiOrderChannelsPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/order_channels',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Order Channels
     * @param requestBody
     * @param isPaginated
     * @returns OrderChannelsPaginated Successful Response
     * @throws ApiError
     */
    static callOrderChannelsApiPaginatedOrderChannelsPost(requestBody, isPaginated = true) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/paginated/order_channels',
            query: {
                'is_paginated': isPaginated,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Order Channels Daterangecompare
     * @param requestBody
     * @returns OrderChannelsDateRangeCompare Successful Response
     * @throws ApiError
     */
    static orderChannelsDateRangeCompareApiDateRangeCompareOrderChannelsPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/order_channels',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Order Channels Daterangecomparegranular
     * @param requestBody
     * @returns OrderChannelsDateRangeCompareGranular Successful Response
     * @throws ApiError
     */
    static orderChannelsDateRangeCompareGranularApiDateRangeCompareGranularOrderChannelsPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/granular/order_channels',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Export Order Channels
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static exportOrderChannelsApiExportOrderChannelsPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/export/order_channels',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Issue Discovery Actions
     * @param requestBody
     * @returns IssueDiscoveryAction Successful Response
     * @throws ApiError
     */
    static callIssueDiscoveryActionsApiIssueDiscoveryActionsPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/issue_discovery/actions',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Issue Discovery Actions
     * @param requestBody
     * @param isPaginated
     * @returns IssueDiscoveryActionPaginated Successful Response
     * @throws ApiError
     */
    static callIssueDiscoveryActionsApiPaginatedIssueDiscoveryActionsPost(requestBody, isPaginated = true) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/paginated/issue_discovery/actions',
            query: {
                'is_paginated': isPaginated,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Issue Discovery Actions Daterangecompare
     * @param requestBody
     * @returns IssueDiscoveryActionDateRangeCompare Successful Response
     * @throws ApiError
     */
    static issueDiscoveryActionsDateRangeCompareApiDateRangeCompareIssueDiscoveryActionsPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/issue_discovery/actions',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Issue Discovery Actions Daterangecomparegranular
     * @param requestBody
     * @returns IssueDiscoveryActionDateRangeCompareGranular Successful Response
     * @throws ApiError
     */
    static issueDiscoveryActionsDateRangeCompareGranularApiDateRangeCompareGranularIssueDiscoveryActionsPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/granular/issue_discovery/actions',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Export Issue Discovery Actions
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static exportIssueDiscoveryActionsApiExportIssueDiscoveryActionsPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/export/issue_discovery/actions',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Kpibystore
     * @param requestBody
     * @returns KpiByStore Successful Response
     * @throws ApiError
     */
    static callKpiByStoreApiKpiByStorePost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/KpiByStore',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Kpibystore
     * @param requestBody
     * @param isPaginated
     * @returns KpiByStorePaginated Successful Response
     * @throws ApiError
     */
    static callKpiByStoreApiPaginatedKpiByStorePost(requestBody, isPaginated = true) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/paginated/KpiByStore',
            query: {
                'is_paginated': isPaginated,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Kpibystore Daterangecompare
     * @param requestBody
     * @returns KpiByStoreDateRangeCompare Successful Response
     * @throws ApiError
     */
    static kpiByStoreDateRangeCompareApiDateRangeCompareKpiByStorePost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/KpiByStore',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Kpibystore Daterangecomparegranular
     * @param requestBody
     * @returns KpiByStoreDateRangeCompareGranular Successful Response
     * @throws ApiError
     */
    static kpiByStoreDateRangeCompareGranularApiDateRangeCompareGranularKpiByStorePost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/granular/KpiByStore',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Export Kpibystore
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static exportKpiByStoreApiExportKpiByStorePost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/export/KpiByStore',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Order Accuracy Error Data By Item
     * @param requestBody
     * @returns ErrorDataByItem Successful Response
     * @throws ApiError
     */
    static callOrderAccuracyErrorDataByItemApiOrderAccuracyErrorDataByItemPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/order_accuracy/error_data_by_item',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Order Accuracy Error Data By Item
     * @param requestBody
     * @param isPaginated
     * @returns ErrorDataByItemPaginated Successful Response
     * @throws ApiError
     */
    static callOrderAccuracyErrorDataByItemApiPaginatedOrderAccuracyErrorDataByItemPost(requestBody, isPaginated = true) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/paginated/order_accuracy/error_data_by_item',
            query: {
                'is_paginated': isPaginated,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Order Accuracy Error Data By Item Daterangecompare
     * @param requestBody
     * @returns ErrorDataByItemDateRangeCompare Successful Response
     * @throws ApiError
     */
    static orderAccuracyErrorDataByItemDateRangeCompareApiDateRangeCompareOrderAccuracyErrorDataByItemPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/order_accuracy/error_data_by_item',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Order Accuracy Error Data By Item Daterangecomparegranular
     * @param requestBody
     * @returns ErrorDataByItemDateRangeCompareGranular Successful Response
     * @throws ApiError
     */
    static orderAccuracyErrorDataByItemDateRangeCompareGranularApiDateRangeCompareGranularOrderAccuracyErrorDataByItemPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/date_range_compare/granular/order_accuracy/error_data_by_item',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Export Order Accuracy Error Data By Item
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static exportOrderAccuracyErrorDataByItemApiExportOrderAccuracyErrorDataByItemPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/export/order_accuracy/error_data_by_item',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Bname Details
     * @param bname
     * @returns any Successful Response
     * @throws ApiError
     */
    static getBnameDetailsCompetitionBusinessDetailsPost(bname) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/competition/business/details',
            query: {
                'bname': bname,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Item Metrics
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static getItemMetricsCompetitionItemMetricsPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/competition/item/metrics',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Stores With Item
     * @param requestBody
     * @param limit
     * @param offset
     * @param orderBy
     * @param ascending
     * @returns any Successful Response
     * @throws ApiError
     */
    static getStoresWithItemCompetitionItemStoresPost(requestBody, limit = 30, offset, orderBy = 'rating_score', ascending = false) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/competition/item/stores',
            query: {
                'limit': limit,
                'offset': offset,
                'order_by': orderBy,
                'ascending': ascending,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Stores With Cuisine
     * @param requestBody
     * @param limit
     * @param offset
     * @param orderBy
     * @param ascending
     * @returns any Successful Response
     * @throws ApiError
     */
    static getStoresWithCuisineCompetitionCuisineStoresPost(requestBody, limit = 30, offset, orderBy = 'rating_score', ascending = false) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/competition/cuisine/stores',
            query: {
                'limit': limit,
                'offset': offset,
                'order_by': orderBy,
                'ascending': ascending,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Popular Items
     * @param requestBody
     * @param limit
     * @param offset
     * @param orderBy
     * @param ascending
     * @returns any Successful Response
     * @throws ApiError
     */
    static getPopularItemsCompetitionCuisinePopularItemsPost(requestBody, limit = 30, offset, orderBy = 'rating_score', ascending = false) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/competition/cuisine/popular_items',
            query: {
                'limit': limit,
                'offset': offset,
                'order_by': orderBy,
                'ascending': ascending,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Export Csv To Gcs
     * Export CSV report to GCS bucket for the customer
     *
     * :param request: FiltersForQueryForReportGeneration
     * :param chain: Chain name
     * :param start_date: yyyy-mm-dd
     * :param end_date: yyyy-mm-dd
     * :param report_type: REPORT_TYPE enum
     * :return: Success or Failure
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static exportCsvToGcsReportsExportCsvGcsPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/reports/export/csv/gcs',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Platform Options
     * @param csvboxChain
     * @returns any Successful Response
     * @throws ApiError
     */
    static getPlatformOptionsCsvDropdownPlatformsGet(csvboxChain) {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/csv/dropdown/platforms',
            query: {
                'csvbox_chain': csvboxChain,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Bname Options
     * @param csvboxChain
     * @param csvboxMultiselect
     * @returns any Successful Response
     * @throws ApiError
     */
    static getBnameOptionsCsvDropdownBnamesGet(csvboxChain, csvboxMultiselect = false) {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/csv/dropdown/bnames',
            query: {
                'csvbox_chain': csvboxChain,
                'csvbox_multiselect': csvboxMultiselect,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Crunchtime Locations
     * @param csvboxChain
     * @returns any Successful Response
     * @throws ApiError
     */
    static getCrunchtimeLocationsCsvDropdownCrunchtimeLocationsGet(csvboxChain) {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/csv/dropdown/crunchtime/locations',
            query: {
                'csvbox_chain': csvboxChain,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get User Options
     * @param csvboxChain
     * @returns any Successful Response
     * @throws ApiError
     */
    static getUserOptionsCsvDropdownUsersGet(csvboxChain) {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/csv/dropdown/users',
            query: {
                'csvbox_chain': csvboxChain,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Accesslevel Options
     * @returns any Successful Response
     * @throws ApiError
     */
    static getAccesslevelOptionsCsvDropdownAccesslevelsGet() {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/csv/dropdown/accesslevels',
        });
    }
    /**
     * Get User Options V2
     * @param csvboxOrg
     * @param csvboxMultiselect
     * @param csvboxHideInternal
     * @returns any Successful Response
     * @throws ApiError
     */
    static getUserOptionsV2CsvDropdownUsersV2Get(csvboxOrg, csvboxMultiselect = false, csvboxHideInternal = true) {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/csv/dropdown/users/v2',
            query: {
                'csvbox_org': csvboxOrg,
                'csvbox_multiselect': csvboxMultiselect,
                'csvbox_hide_internal': csvboxHideInternal,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Notification Type Options
     * @returns any Successful Response
     * @throws ApiError
     */
    static getNotificationTypeOptionsCsvDropdownNotificationTypesGet() {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/csv/dropdown/notification_types',
        });
    }
    /**
     * Send Otp Email
     * @param requestBody
     * @returns SendOtpResponse Successful Response
     * @throws ApiError
     */
    static sendOtpEmailSendPasswordOtpPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/send/password/otp',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Verify Otp Email
     * @param requestBody
     * @returns VerifyOtpResponse Successful Response
     * @throws ApiError
     */
    static verifyOtpEmailVerifyPasswordOtpPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/verify/password/otp',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Run Procedure And Get Data With Previous Date Range
     * Call procedure for this date range and previous date range and return both. Assumes last two paramaters are start_date and end_date.
     * @param procedureName
     * @param requestBody
     * @returns DataResponse Successful Response
     * @throws ApiError
     */
    static runProcedureAndGetDataWithPreviousDateRangeRunQueryDateRangeComparePost(procedureName, requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/run/query/date_range_compare',
            query: {
                'procedure_name': procedureName,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Run Procedure And Get Data
     * @param procedureName
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static runProcedureAndGetDataRunQueryPost(procedureName, requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/run/query',
            query: {
                'procedure_name': procedureName,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Run Procedure And Get Data No Cache
     * @param procedureName
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static runProcedureAndGetDataNoCacheRunQueryNoCachePost(procedureName, requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/run/query/no_cache',
            query: {
                'procedure_name': procedureName,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Chain Filters
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static getChainFiltersChainFiltersPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/chain/filters',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Run Procedure And Get Data V2
     * @param procedureName
     * @param requestBody
     * @param dateRangeCompare
     * @returns any Successful Response
     * @throws ApiError
     */
    static runProcedureAndGetDataV2RunQueryV2Post(procedureName, requestBody, dateRangeCompare = false) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/run/query/v2',
            query: {
                'procedure_name': procedureName,
                'date_range_compare': dateRangeCompare,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Run Procedure V1 And Get Data Paginated
     * @param procedureName
     * @param requestBody
     * @param offset
     * @param limit
     * @returns any Successful Response
     * @throws ApiError
     */
    static runProcedureV1AndGetDataPaginatedRunQueryV1PaginatedPost(procedureName, requestBody, offset, limit = 100) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/run/query/v1/paginated',
            query: {
                'procedure_name': procedureName,
                'offset': offset,
                'limit': limit,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Run Procedure V2 And Get Data Paginated
     * @param procedureName
     * @param requestBody
     * @param dateRangeCompare
     * @param offset
     * @param limit
     * @returns any Successful Response
     * @throws ApiError
     */
    static runProcedureV2AndGetDataPaginatedRunQueryV2PaginatedPost(procedureName, requestBody, dateRangeCompare = false, offset, limit = 100) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/run/query/v2/paginated',
            query: {
                'procedure_name': procedureName,
                'date_range_compare': dateRangeCompare,
                'offset': offset,
                'limit': limit,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Run Procedure And Get Data With Pagination
     * @param procedureName
     * @param requestBody
     * @param offset
     * @param limit
     * @returns any Successful Response
     * @throws ApiError
     */
    static runProcedureAndGetDataWithPaginationRunQueryPaginatedPost(procedureName, requestBody, offset, limit = 500) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/run/query/paginated',
            query: {
                'procedure_name': procedureName,
                'offset': offset,
                'limit': limit,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Run Procedure And Get Data Named
     * @param procedureName
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static runProcedureAndGetDataNamedRunQueryNamedPost(procedureName, requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/run/query_named',
            query: {
                'procedure_name': procedureName,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Query Params
     * @param procedureName
     * @returns any Successful Response
     * @throws ApiError
     */
    static getQueryParamsQueryParamsGet(procedureName) {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/query/params',
            query: {
                'procedure_name': procedureName,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Print Query
     * @param procedureName
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static printQueryPrintQueryPost(procedureName, requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/print_query',
            query: {
                'procedure_name': procedureName,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Store Avalability Counts
     * @param requestBody
     * @param groupByPlatform
     * @returns any Successful Response
     * @throws ApiError
     */
    static getStoreAvalabilityCountsStoreAvailabilityCountsPost(requestBody, groupByPlatform = true) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/store_availability_counts',
            query: {
                'group_by_platform': groupByPlatform,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Store Availability
     * @param chain
     * @param limit
     * @param offset
     * @param inactiveOnly
     * @param orderBy
     * @param ascending
     * @param tableId
     * @returns StoreAvailabilityResponse Successful Response
     * @throws ApiError
     */
    static getStoreAvailabilityStoreAvailabilityPaginatedChainGet(chain, limit = 100, offset, inactiveOnly = false, orderBy, ascending = true, tableId) {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/store_availability/paginated/{chain}',
            path: {
                'chain': chain,
            },
            query: {
                'limit': limit,
                'offset': offset,
                'inactive_only': inactiveOnly,
                'order_by': orderBy,
                'ascending': ascending,
                'table_id': tableId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Store Availability
     * @param chain
     * @returns StoreAvailabilityResponse Successful Response
     * @throws ApiError
     */
    static getStoreAvailabilityStoreAvailabilityChainGet(chain) {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/store_availability/{chain}',
            path: {
                'chain': chain,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Store Availability History Endpoint
     * @param slug
     * @returns StoreMenuHoursAndInactiveHours Successful Response
     * @throws ApiError
     */
    static getStoreAvailabilityHistoryEndpointStoreAvailabilityHistorySlugGet(slug) {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/store_availability/history/{slug}',
            path: {
                'slug': slug,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * @deprecated
     * Get Disputes
     * @param requestBody
     * @returns DisputeResponse Successful Response
     * @throws ApiError
     */
    static getDisputesDisputesPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/disputes',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Dispute Reasons
     * @returns DisputeReasonConfigRow Successful Response
     * @throws ApiError
     */
    static getDisputeReasonsDisputeReasonsGet() {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dispute_reasons',
        });
    }
    /**
     * Get Date Range Filter
     * @param chain
     * @returns DateRangeFilterResponse Successful Response
     * @throws ApiError
     */
    static getDateRangeFilterDateRangeFilterChainGet(chain) {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/date_range_filter/{chain}',
            path: {
                'chain': chain,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Flush Keys
     * Endpoint used to flush out all the cached keys in Redis store.
     * @returns any Successful Response
     * @throws ApiError
     */
    static flushKeysCacheFlushKeysDelete() {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/cache/flush_keys',
        });
    }
    /**
     * Get Keys
     * Endpoint used to get all the cached keys in Redis store.
     * @param pattern
     * @returns any Successful Response
     * @throws ApiError
     */
    static getKeysCacheKeysGet(pattern = '*') {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/cache/keys',
            query: {
                'pattern': pattern,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Reviews Summary
     * @param startDate
     * @param endDate
     * @param chain
     * @param requestBody
     * @returns ReviewsSummaryStoreLevel Successful Response
     * @throws ApiError
     */
    static getReviewsSummaryReviewsSummaryPost(startDate, endDate, chain, requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/reviews/summary',
            query: {
                'start_date': startDate,
                'end_date': endDate,
                'chain': chain,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Generate Review Summary
     * @param requestBody
     * @returns ReviewsSummaryData Successful Response
     * @throws ApiError
     */
    static generateReviewSummaryReviewsSummaryGeneratePost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/reviews/summary/generate',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Load Chain Level Queries To Redis
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static loadChainLevelQueriesToRedisLoadChainLevelQueriesToRedisPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/load_chain_level_queries_to_redis',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Add Procedure To Redis
     * @param procedureName
     * @param chain
     * @returns any Successful Response
     * @throws ApiError
     */
    static addProcedureToRedisLoadProcedureToRedisPost(procedureName, chain) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/load_procedure_to_redis',
            query: {
                'procedure_name': procedureName,
                'chain': chain,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Fast Procedure Read Chain Level
     * @param chain
     * @param procedureName
     * @returns any Successful Response
     * @throws ApiError
     */
    static fastProcedureReadChainLevelFastProcedureReadChainLevelChainGet(chain, procedureName) {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/fast_procedure_read_chain_level/{chain}',
            path: {
                'chain': chain,
            },
            query: {
                'procedure_name': procedureName,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Read From Firebase
     * Read from firebase. If document_id is not provided, read all documents from the collection.
     * Use the global firestore_db variable to read from firebase.
     * @param collectionName
     * @param documentId
     * @returns any Successful Response
     * @throws ApiError
     */
    static readFromFirebaseReadDocFromFirebaseGet(collectionName, documentId) {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/read_doc_from_firebase',
            query: {
                'collection_name': collectionName,
                'document_id': documentId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Generate Csv From Legacy Procedure
     * @param procedureName
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static generateCsvFromLegacyProcedureGenerateCsvLegacyPost(procedureName, requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/generate/csv/legacy',
            query: {
                'procedure_name': procedureName,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Generate Csv From Procedure
     * @param procedureFilePath
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static generateCsvFromProcedureGenerateCsvPost(procedureFilePath, requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/generate/csv',
            query: {
                'procedure_file_path': procedureFilePath,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Generate Csv From Procedure
     * @param procedureFilePath
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static generateCsvFromProcedureGenerateCsvBankTransactionsPost(procedureFilePath, requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/generate/csv/bank_transactions',
            query: {
                'procedure_file_path': procedureFilePath,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Ask Chatgpt
     * @param question
     * @param lat
     * @param lng
     * @returns any Successful Response
     * @throws ApiError
     */
    static askChatgptAskChatgptPost(question, lat, lng) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/ask_chatgpt',
            query: {
                'question': question,
                'lat': lat,
                'lng': lng,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Langchain Ask
     * @param query
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static langchainAskLangchainAskPost(query, requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/langchain/ask',
            query: {
                'query': query,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Langchain Ask Sql
     * @param query
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static langchainAskSqlLangchainAskSqlPost(query, requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/langchain/ask/sql',
            query: {
                'query': query,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Order Details
     * @param requestBody
     * @returns OrderContextModel Successful Response
     * @throws ApiError
     */
    static orderDetailsOrderDetailsPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/order_details',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Onboarded Usernames
     * @param chain
     * @returns any Successful Response
     * @throws ApiError
     */
    static getOnboardedUsernamesOnboardedUsernamesGet(chain) {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/onboarded_usernames',
            query: {
                'chain': chain,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Sales Overview
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static getSalesOverviewKpiSalesOverviewPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/kpi/sales_overview',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Sales Overview V2
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static getSalesOverviewV2KpiSalesOverviewV2Post(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/kpi/sales_overview/v2',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Sales Overview By Location
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static getSalesOverviewByLocationKpiSalesOverviewLocationPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/kpi/sales_overview/location',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Error Overview
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static getErrorOverviewKpiErrorOverviewPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/kpi/error_overview',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Error Overview V2
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static getErrorOverviewV2KpiErrorOverviewV2Post(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/kpi/error_overview/v2',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Error Overview By Location
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static getErrorOverviewByLocationKpiErrorOverviewLocationPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/kpi/error_overview/location',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Error Overview By Brand
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static getErrorOverviewByBrandKpiErrorOverviewBrandPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/kpi/error_overview/brand',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Lost Sales History
     * @param chain
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static getLostSalesHistoryLostSalesHistoryChainPost(chain, requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/lost_sales/history/{chain}',
            path: {
                'chain': chain,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get History
     * @param historyType
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static getHistoryHistoryHistoryTypePost(historyType, requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/history/{history_type}',
            path: {
                'history_type': historyType,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * History By Store
     * @param field
     * @param chain
     * @param offset
     * @param limit
     * @param aggregrate
     * @returns any Successful Response
     * @throws ApiError
     */
    static historyByStoreHistoryByStorePost(field, chain, offset, limit = 10, aggregrate) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/history_by_store',
            query: {
                'field': field,
                'chain': chain,
                'offset': offset,
                'limit': limit,
                'aggregrate': aggregrate,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Signed Url
     * @param url
     * @returns any Successful Response
     * @throws ApiError
     */
    static getSignedUrlGcpSignedUrlGet(url) {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/gcp/signed/url',
            query: {
                'url': url,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Trigger Notifications
     * @param overrideLastTrigger
     * @returns any Successful Response
     * @throws ApiError
     */
    static triggerNotificationsTriggerNotificationsPost(overrideLastTrigger = false) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/trigger_notifications',
            query: {
                'override_last_trigger': overrideLastTrigger,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Webhook Handler
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static webhookHandlerNotificationHookUePost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/notification/hook/ue',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Webhook Business Hours
     * Webhook endpoint to handle business hours updates on interfaces such as Olo.
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static webhookBusinessHoursHookBusinessHoursPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/hook/business-hours',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Webhook Help Scout
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static webhookHelpScoutHookHelpScoutPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/hook/help-scout',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Webhook Mailslurp
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static webhookMailslurpHookMailslurpPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/hook/mailslurp',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Webhook Mailslurp
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static webhookMailslurpHookMailslurpEmailDisputePost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/hook/mailslurp/email_dispute',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Olo Webhook Orders
     * @param chain
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static oloWebhookOrdersHookOloChainPost(chain, requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/hook/olo/{chain}',
            path: {
                'chain': chain,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Slack Oauth Handler
     * @param code
     * @param chain
     * @param error
     * @returns any Successful Response
     * @throws ApiError
     */
    static slackOauthHandlerSlackOauthGet(code, chain, error) {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/slack-oauth',
            query: {
                'code': code,
                'chain': chain,
                'error': error,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Set Default Notification Config
     * @param chain
     * @returns any Successful Response
     * @throws ApiError
     */
    static setDefaultNotificationConfigDefaultNotificationConfigChainSetPost(chain) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/default_notification_config/{chain}/set',
            path: {
                'chain': chain,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Send User Email
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static sendUserEmailSendUserEmailPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/send_user_email',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Sendgrid Email Webhook
     * Store sendgrid email webhook event in bq
     * @param requestBody
     * @returns string Successful Response
     * @throws ApiError
     */
    static sendgridEmailWebhookSendgridEmailWebhookPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/sendgrid/email/webhook',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Send Refresh And Etl Slack Message
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static sendRefreshAndEtlSlackMessageSendRefreshAndEtlSlackMessagePost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/send_refresh_and_etl_slack_message',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Send Email
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static sendEmailNotificationEmailPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/notification/email',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Send Magic Link Email
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static sendMagicLinkEmailSendMagicLinkEmailPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/send/magic/link/email',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Trigger Email Digest
     * @param requestBody
     * @param userLevel
     * @returns any Successful Response
     * @throws ApiError
     */
    static triggerEmailDigestNotificationEmailDigestPost(requestBody, userLevel = false) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/notification/email_digest',
            query: {
                'user_level': userLevel,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Verify Email
     * @param authLink
     * @returns any Successful Response
     * @throws ApiError
     */
    static verifyEmailVerifyEmailGet(authLink) {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/verify_email',
            query: {
                'auth_link': authLink,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Link Phone With Email
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static linkPhoneWithEmailLinkPhoneWithEmailPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/link_phone_with_email',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Unlink Phone
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static unlinkPhoneUnlinkPhonePost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/unlink_phone',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Reset Password
     * @param email
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static resetPasswordResetPasswordEmailPost(email, requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/reset_password/{email}',
            path: {
                'email': email,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Link Phone
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static linkPhoneLinkPhonePost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/link_phone',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Trigger Email Digest Template Data
     * This function is used for internal testing of email digest template data. This will return the template data without sending email.
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static triggerEmailDigestTemplateDataNotificationEmailDigestTemplateDataPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/notification/email_digest_template_data',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Download Generated Pdf
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static downloadGeneratedPdfDownloadGeneratedPdfPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/download_generated_pdf',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Intercom Web Id
     * @returns any Successful Response
     * @throws ApiError
     */
    static getIntercomWebIdIntercomVerifyWebPost() {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/intercom/verify_web',
        });
    }
    /**
     * Get Short Url
     * @param url
     * @returns any Successful Response
     * @throws ApiError
     */
    static getShortUrlUrlShortPost(url) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/url/short',
            query: {
                'url': url,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Long Url
     * @param id
     * @returns any Successful Response
     * @throws ApiError
     */
    static getLongUrlUrlLongPost(id) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/url/long',
            query: {
                'id': id,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Set Configs For Bnames
     * @param chain
     * @param bnameIdsIn
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static setConfigsForBnamesBnameConfigSetPost(chain, bnameIdsIn, requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/bname/config/set',
            query: {
                'chain': chain,
                'bname_ids_in': bnameIdsIn,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Bname Configs
     * @param chain
     * @param bnameIdsIn
     * @returns BNameFeatureConfig Successful Response
     * @throws ApiError
     */
    static getBnameConfigsBnameConfigGetGet(chain, bnameIdsIn) {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/bname/config/get',
            query: {
                'chain': chain,
                'bname_ids_in': bnameIdsIn,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Check Data Refresh
     * @param dataRefreshRunId
     * @param responseType
     * @returns any Successful Response
     * @throws ApiError
     */
    static checkDataRefreshCheckDataRefreshGet(dataRefreshRunId, responseType) {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/check_data_refresh',
            query: {
                'data_refresh_run_id': dataRefreshRunId,
                'response_type': responseType,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Failed Or Missed Runs
     * Gives data that can be used to rerun `bootstrap_with_credentials` and `download_report_uber_batch` workflows for the failed or missed runs
     * @param dataRefreshRunId
     * @returns BatchRefreshRerunData Successful Response
     * @throws ApiError
     */
    static getFailedOrMissedRunsGetFailedOrMissedRunsGet(dataRefreshRunId) {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/get_failed_or_missed_runs',
            query: {
                'data_refresh_run_id': dataRefreshRunId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Check Bootstrap Status
     * @param requestBody
     * @param checkPartial
     * @returns RefreshValidationStatus Successful Response
     * @throws ApiError
     */
    static checkBootstrapStatusCheckBootstrapStatusPost(requestBody, checkPartial = false) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/check_bootstrap_status',
            query: {
                'check_partial': checkPartial,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Trigger Failed Slugs
     * @param platform
     * @param dataRefreshRunId
     * @param delay
     * @param numDays
     * @param timestamp
     * @returns any Successful Response
     * @throws ApiError
     */
    static triggerFailedSlugsTriggerFailedSlugsPost(platform, dataRefreshRunId, delay = 120, numDays = 22, timestamp) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/trigger_failed_slugs',
            query: {
                'platform': platform,
                'data_refresh_run_id': dataRefreshRunId,
                'delay': delay,
                'num_days': numDays,
                'timestamp': timestamp,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Trigger Failed Username
     * @param platform
     * @param delay
     * @param numDays
     * @param timestamp
     * @returns any Successful Response
     * @throws ApiError
     */
    static triggerFailedUsernameTriggerFailedUsernamePost(platform, delay = 120, numDays = 22, timestamp = '2024-05-14T21:20:40.861830') {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/trigger_failed_username',
            query: {
                'platform': platform,
                'delay': delay,
                'num_days': numDays,
                'timestamp': timestamp,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Uber Slugs To Run Separately
     * @param slug
     * @returns any Successful Response
     * @throws ApiError
     */
    static uberSlugsToRunSeparatelyUberSlugsToRunSeparatelyPost(slug) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/uber_slugs_to_run_separately',
            query: {
                'slug': slug,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Trigger All Usernames
     * @param delay
     * @param numDays
     * @param timestamp
     * @returns any Successful Response
     * @throws ApiError
     */
    static triggerAllUsernamesTriggerAllUsernamesPost(delay = 300, numDays = 14, timestamp = '2024-06-13T21:20:40.863227') {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/trigger_all_usernames',
            query: {
                'delay': delay,
                'num_days': numDays,
                'timestamp': timestamp,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Trigger Uber Ad Refresh Workflow
     * @param numDays
     * @param timestamp
     * @returns any Successful Response
     * @throws ApiError
     */
    static triggerUberAdRefreshWorkflowTriggerUberAdRefreshWorkflowPost(numDays = 10, timestamp = '2024-06-13T21:20:40.863939') {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/trigger_uber_ad_refresh_workflow',
            query: {
                'num_days': numDays,
                'timestamp': timestamp,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Trigger All Slugs
     * @param platform
     * @param dataRefreshRunId
     * @param delay
     * @param numDays
     * @param timestamp
     * @param workflowName
     * @param endpointName
     * @returns any Successful Response
     * @throws ApiError
     */
    static triggerAllSlugsTriggerAllSlugsPost(platform, dataRefreshRunId, delay = 120, numDays = 22, timestamp, workflowName = 'bootstrap_with_credentials', endpointName = 'ingest_menu_hours') {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/trigger_all_slugs',
            query: {
                'platform': platform,
                'data_refresh_run_id': dataRefreshRunId,
                'delay': delay,
                'num_days': numDays,
                'timestamp': timestamp,
                'workflow_name': workflowName,
                'endpoint_name': endpointName,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Trigger Workflow
     * @param workflow
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static triggerWorkflowTriggerWorkflowPost(workflow, requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/trigger_workflow',
            query: {
                'workflow': workflow,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Bootstrap Bulk
     * @param requestBody
     * @param delay
     * @param dataRefreshRunId
     * @param numDays
     * @param timestamp
     * @param workflowName
     * @param endpointName
     * @returns any Successful Response
     * @throws ApiError
     */
    static bootstrapBulkBootstrapBulkPost(requestBody, delay = 60, dataRefreshRunId, numDays = 22, timestamp, workflowName = 'bootstrap_with_credentials', endpointName = 'ingest_menu_hours') {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/bootstrap_bulk',
            query: {
                'delay': delay,
                'data_refresh_run_id': dataRefreshRunId,
                'num_days': numDays,
                'timestamp': timestamp,
                'workflow_name': workflowName,
                'endpoint_name': endpointName,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Otp
     * @param username
     * @returns any Successful Response
     * @throws ApiError
     */
    static getOtpGetLastOtpGet(username) {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/get_last_otp',
            query: {
                'username': username,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Last Uber Otp
     * @param username
     * @returns any Successful Response
     * @throws ApiError
     */
    static getLastUberOtpGetLastUberOtpGet(username) {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/get_last_uber_otp',
            query: {
                'username': username,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Sheet To Bigquery
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static sheetToBigquerySheetToBigqueryPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/sheet_to_bigquery',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Fetch Uber Public
     * @param uuid
     * @returns any Successful Response
     * @throws ApiError
     */
    static fetchUberPublicFetchUberPublicPost(uuid) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/fetch_uber_public',
            query: {
                'uuid': uuid,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Fetch Uber Public Batch
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static fetchUberPublicBatchFetchUberPublicBatchPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/fetch_uber_public_batch',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Bulk Custom
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static callBulkCustomCallBulkCustomPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/call_bulk_custom',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Bulk Custom Slugs
     * @param endpoint
     * @param requestBody
     * @param delay
     * @returns any Successful Response
     * @throws ApiError
     */
    static callBulkCustomSlugsTriggerTasksForSlugsCustomEndpointPost(endpoint, requestBody, delay = 120) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/trigger_tasks_for_slugs_custom_endpoint',
            query: {
                'endpoint': endpoint,
                'delay': delay,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Oath Redirect
     * Handle store link in selenium flow.
     * @param code
     * @returns any Successful Response
     * @throws ApiError
     */
    static getOathRedirectUeLinkStoresGet(code) {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/ue/link-stores',
            query: {
                'code': code,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Link Stores Manual
     * @param code
     * @param chain
     * @param redirectUri
     * @returns any Successful Response
     * @throws ApiError
     */
    static linkStoresManualUeLinkStoresManualPost(code, chain, redirectUri = 'https://api.loopapplication.xyz/ue/link-stores') {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/ue/link-stores-manual',
            query: {
                'code': code,
                'chain': chain,
                'redirect_uri': redirectUri,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Trigger Link Stores
     * @param code
     * @param chain
     * @returns any Successful Response
     * @throws ApiError
     */
    static triggerLinkStoresUeTriggerStoreLinkPost(code, chain) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/ue/trigger-store-link',
            query: {
                'code': code,
                'chain': chain,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * List All Orders
     * @param orgId
     * @returns OrdersList Successful Response
     * @throws ApiError
     */
    static listAllOrdersStoresAllOrdersGet(orgId) {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/stores/all-orders',
            query: {
                'org_id': orgId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Delete Ue Store
     * @param platform
     * @param storeId
     * @returns any Successful Response
     * @throws ApiError
     */
    static deleteUeStorePlatformStoresStoreIdPosDataDelete(platform, storeId) {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/{platform}/stores/{store_id}/pos_data',
            path: {
                'platform': platform,
                'store_id': storeId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Upload To Firestore From Bq
     * @param tableName
     * @param datasetName
     * @param collectionName
     * @param documentIdField
     * @returns any Successful Response
     * @throws ApiError
     */
    static uploadToFirestoreFromBqBqToFirestorePost(tableName = 'slug_am_mapping_v2', datasetName = 'restaurant_aggregate_metrics', collectionName = 'credentials_v3', documentIdField) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/bq_to_firestore',
            query: {
                'table_name': tableName,
                'dataset_name': datasetName,
                'collection_name': collectionName,
                'document_id_field': documentIdField,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Update Credentials V2
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static updateCredentialsV2UpdateCredentialsV2Post(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/update_credentials_v2',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get All Configs For Uber Batch Reports
     * @param dataRefreshRunId
     * @param numDays
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static getAllConfigsForUberBatchReportsGetAllConfigsForUberBatchReportsPost(dataRefreshRunId, numDays = 14, requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/get_all_configs_for_uber_batch_reports',
            query: {
                'data_refresh_run_id': dataRefreshRunId,
                'num_days': numDays,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Trigger Failed Configurations
     * @param dataRefreshRunId
     * @param reportBatchRunId
     * @param delayStep
     * @returns any Successful Response
     * @throws ApiError
     */
    static triggerFailedConfigurationsTriggerFailedConfigsForUberBatchReportsPost(dataRefreshRunId, reportBatchRunId, delayStep = 120) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/trigger_failed_configs_for_uber_batch_reports',
            query: {
                'data_refresh_run_id': dataRefreshRunId,
                'report_batch_run_id': reportBatchRunId,
                'delay_step': delayStep,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Trigger Doordash Batch Reports
     * @param dataRefreshRunId
     * @param numDays
     * @param delayStep
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static triggerDoordashBatchReportsTriggerDoordashBatchReportsPost(dataRefreshRunId, numDays = 14, delayStep = 15, requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/trigger_doordash_batch_reports',
            query: {
                'data_refresh_run_id': dataRefreshRunId,
                'num_days': numDays,
                'delay_step': delayStep,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Trigger All Configs For Uber Batch Reports
     * @param dataRefreshRunId
     * @param numDays
     * @param delayStep
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static triggerAllConfigsForUberBatchReportsTriggerUberBatchReportsPost(dataRefreshRunId, numDays = 14, delayStep = 120, requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/trigger_uber_batch_reports',
            query: {
                'data_refresh_run_id': dataRefreshRunId,
                'num_days': numDays,
                'delay_step': delayStep,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Trigger Given Configs For Uber Batch Reports
     * @param requestBody
     * @param delayStep
     * @returns any Successful Response
     * @throws ApiError
     */
    static triggerGivenConfigsForUberBatchReportsTriggerUberBatchReportsFromConfigsPost(requestBody, delayStep = 120) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/trigger_uber_batch_reports_from_configs',
            query: {
                'delay_step': delayStep,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Split And Trigger Doordash Batch Reports
     * @param username
     * @param numDays
     * @param batchDays
     * @param delayStep
     * @param timestamp
     * @returns any Successful Response
     * @throws ApiError
     */
    static splitAndTriggerDoordashBatchReportsSplitAndTriggerDoordashBatchReportsPost(username, numDays = 90, batchDays = 10, delayStep = 15, timestamp = '2024-06-13') {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/split_and_trigger_doordash_batch_reports',
            query: {
                'username': username,
                'num_days': numDays,
                'batch_days': batchDays,
                'delay_step': delayStep,
                'timestamp': timestamp,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Slug Count
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static getSlugCountGetSlugCountPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/get_slug_count',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Run Id
     * @returns any Successful Response
     * @throws ApiError
     */
    static getRunIdGetRunIdGet() {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/get_run_id',
        });
    }
    /**
     * Get Recent Orders In Range
     * Get orders for a given platform in the last num_hours for list of slugs.
     * Note: Currently only supports Uber Eats.
     *
     * Args:
     * platform: Platform to get orders for
     * num_hours: Number of hours to go back to get orders for.
     * slugs: List of slugs to get orders for.
     * @param platform
     * @param numHours
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static getRecentOrdersInRangeRecentOrdersPlatformPost(platform, numHours, requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/recent_orders/{platform}',
            path: {
                'platform': platform,
            },
            query: {
                'num_hours': numHours,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Invoice History
     * Get invoice history for a given chain.
     * @param chain
     * @param limit
     * @returns InvoiceHistory Successful Response
     * @throws ApiError
     */
    static getInvoiceHistoryInvoiceHistoryGet(chain, limit = 30) {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/invoice/history',
            query: {
                'chain': chain,
                'limit': limit,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Generate Invoice
     * @param invoiceType
     * @param bName
     * @param chain
     * @param startDate
     * @param endDate
     * @returns any Successful Response
     * @throws ApiError
     */
    static generateInvoiceInvoiceInvoiceTypeGet(invoiceType, bName, chain, startDate, endDate) {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/invoice/{invoice_type}',
            path: {
                'invoice_type': invoiceType,
            },
            query: {
                'b_name': bName,
                'chain': chain,
                'start_date': startDate,
                'end_date': endDate,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Finance Breakdown
     * @param chain
     * @param bNameIn
     * @param startDate
     * @param endDate
     * @param aggregateAll
     * @returns FinanceBreakdown Successful Response
     * @throws ApiError
     */
    static getFinanceBreakdownFinanceBreakdownGet(chain, bNameIn, startDate, endDate, aggregateAll) {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/finance/breakdown',
            query: {
                'chain': chain,
                'b_name_in': bNameIn,
                'start_date': startDate,
                'end_date': endDate,
                'aggregate_all': aggregateAll,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Delete Tasks
     * @param dataRefreshRunId
     * @returns any Successful Response
     * @throws ApiError
     */
    static deleteTasksRefreshDeleteTasksDelete(dataRefreshRunId) {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/refresh/delete/tasks',
            query: {
                'data_refresh_run_id': dataRefreshRunId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Failed Workflow Executions
     * :@param request: request object
     * :@return: status of the request
     *
     * Optional query params:
     * :limit: number of executions to return
     * default: 10
     * :end_date: date in format YYYY-MM-DD
     * :last_n_hour: number of hours to go back from current time and having failed executions
     * :send_slack_message: if true, send slack message with failed executions
     *
     * required query params:
     * :workflow_name: name of the workflow
     * @param workflowName Name of the workflow to get failed executions for
     * @param limit Number of executions to return
     * @param endDate Date in format YYYY-MM-DD
     * @param lastNHour Number of hours to go back from current time and having failed executions
     * @param sendSlackMessage If true, send slack message with failed executions
     * @returns FailedExecutionsResponse Successful Response
     * @throws ApiError
     */
    static getFailedWorkflowExecutionsGetFailedWorkflowExecutionsGet(workflowName, limit = 10, endDate, lastNHour, sendSlackMessage = false) {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/get-failed-workflow-executions',
            query: {
                'workflow_name': workflowName,
                'limit': limit,
                'end_date': endDate,
                'last_n_hour': lastNHour,
                'send_slack_message': sendSlackMessage,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Chain Refresh Progress
     * @returns ChainRefreshProgress Successful Response
     * @throws ApiError
     */
    static getChainRefreshProgressChainRefreshProgressGet() {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/chain_refresh_progress',
        });
    }
    /**
     * Get Chain Refresh Schedules
     * Get the refresh schedule at a daily level for each chain
     * @returns any Successful Response
     * @throws ApiError
     */
    static getChainRefreshSchedulesRefreshScheduleGetGet() {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/refresh/schedule/get',
        });
    }
    /**
     * Set Chain Refresh Schedules
     * updates org_config_2 for every chain
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static setChainRefreshSchedulesRefreshScheduleSetPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/refresh/schedule/set',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Trigger Data Refresh Workflow
     * 1. Daily GrubHub ingestion for all chains except (_EXCLUDE_CHAIN_INGESTION_MAP)
     * 2. Grubhub Ingestion for _EXCLUDE_CHAIN_INGESTION_MAP only on Wednesday and Sunday.
     * 3. Doordash and UberEats ingestion for all chains on Wednesday and Sunday.
     * @param priority
     * @returns any Successful Response
     * @throws ApiError
     */
    static triggerDataRefreshWorkflowRefreshDataRefreshPost(priority) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/refresh/data-refresh',
            query: {
                'priority': priority,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Ingestion Slug Status
     * @param requestBody
     * @returns IngestionSlugStatus Successful Response
     * @throws ApiError
     */
    static callIngestionSlugStatusApiIngestionSlugStatusPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/ingestion/slug_status',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Call Ingestion Chain Status
     * @param requestBody
     * @returns IngestionChainStatus Successful Response
     * @throws ApiError
     */
    static callIngestionChainStatusApiIngestionChainStatusPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/ingestion/chain_status',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get All Login Username Info
     * @param chain
     * @returns any Successful Response
     * @throws ApiError
     */
    static getAllLoginUsernameInfoStoreMappingUsernameGetGet(chain) {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/store_mapping/username/get',
            query: {
                'chain': chain,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Add Login Username
     * @param chain
     * @returns any Successful Response
     * @throws ApiError
     */
    static addLoginUsernameStoreMappingUsernameAddPost(chain) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/store_mapping/username/add',
            query: {
                'chain': chain,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Unmapped Stores Details
     * @param chain
     * @param limit
     * @param offset
     * @param search
     * @param sortBy
     * @param ascending
     * @returns any Successful Response
     * @throws ApiError
     */
    static getUnmappedStoresDetailsStoreMappingUnmappedGetGet(chain, limit = 30, offset, search = '', sortBy = 'name', ascending = true) {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/store_mapping/unmapped/get',
            query: {
                'chain': chain,
                'limit': limit,
                'offset': offset,
                'search': search,
                'sort_by': sortBy,
                'ascending': ascending,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Deleted Stores Details
     * @param chain
     * @param limit
     * @param offset
     * @param search
     * @param sortBy
     * @param ascending
     * @returns any Successful Response
     * @throws ApiError
     */
    static getDeletedStoresDetailsStoreMappingDeletedGetGet(chain, limit = 30, offset, search = '', sortBy = 'name', ascending = true) {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/store_mapping/deleted/get',
            query: {
                'chain': chain,
                'limit': limit,
                'offset': offset,
                'search': search,
                'sort_by': sortBy,
                'ascending': ascending,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Restore Deleted Store
     * @param storeId
     * @param forceUnmapped
     * @returns any Successful Response
     * @throws ApiError
     */
    static restoreDeletedStoreStoreMappingDeletedRestorePost(storeId, forceUnmapped = false) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/store_mapping/deleted/restore',
            query: {
                'store_id': storeId,
                'force_unmapped': forceUnmapped,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get All Bname Info
     * @param chain
     * @returns any Successful Response
     * @throws ApiError
     */
    static getAllBnameInfoStoreMappingBnamesGetGet(chain) {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/store_mapping/bnames/get',
            query: {
                'chain': chain,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Update Digital Stores
     * @param chain
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static updateDigitalStoresStoreMappingStoresUpdatePost(chain, requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/store_mapping/stores/update',
            query: {
                'chain': chain,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Integration Status
     * @param chain
     * @param bNameIdsIn
     * @returns any Successful Response
     * @throws ApiError
     */
    static getIntegrationStatusStoreMappingIntegrationStatusPost(chain, bNameIdsIn) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/store_mapping/integration/status',
            query: {
                'chain': chain,
                'b_name_ids_in': bNameIdsIn,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Store Mapping History
     * @param requestBody
     * @returns dao__store_mapping_history__StoreMappingHistory Successful Response
     * @throws ApiError
     */
    static getStoreMappingHistoryStoreMappingHistoryPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/store_mapping/history',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Store Mapping History In Date Range
     * @param requestBody
     * @returns StoreMappingHistoryRange Successful Response
     * @throws ApiError
     */
    static getStoreMappingHistoryInDateRangeStoreMappingHistoryDateRangePost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/store_mapping/history/date_range',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get All Chain Status
     * @returns ChainStatusInfo Successful Response
     * @throws ApiError
     */
    static getAllChainStatusChainStatusAllGet() {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/chain/status/all',
        });
    }
    /**
     * Set Platform Meta
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static setPlatformMetaSetPlatformMetaPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/set/platform/meta',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Platform Meta
     * @param chainName
     * @returns any Successful Response
     * @throws ApiError
     */
    static getPlatformMetaGetPlatformMetaGet(chainName) {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/get/platform/meta',
            query: {
                'chain_name': chainName,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Set Expected Locations
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static setExpectedLocationsSetExpectedLocationsPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/set/expected/locations',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Chain Default Configs
     * @returns any Successful Response
     * @throws ApiError
     */
    static getChainDefaultConfigsGetChainDefaultConfigsGet() {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/get/chain/default/configs',
        });
    }
    /**
     * Set Chain Default Configs
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static setChainDefaultConfigsSetChainDefaultConfigsPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/set/chain/default/configs',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Set Blocked On Cs
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static setBlockedOnCsSetBlockedOnCsPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/set/blocked/on/cs',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Set Blocked On Sales
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static setBlockedOnSalesSetBlockedOnSalesPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/set/blocked/on/sales',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Latest Org Store Availability Sms
     * @param requestBody
     * @returns StoreAvailabilitySmsResponse Successful Response
     * @throws ApiError
     */
    static getLatestOrgStoreAvailabilitySmsGetLatestOrgStoreAvailabilitySmsPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/get/latest/org/store/availability/sms',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Latest Org Store Performance Report Email
     * @param requestBody
     * @returns StorePerformanceReportEmailResponse Successful Response
     * @throws ApiError
     */
    static getLatestOrgStorePerformanceReportEmailGetLatestOrgStorePerformanceReportEmailPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/get/latest/org/store/performance/report/email',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Latest Org Chargeback Won And Raised
     * @param requestBody
     * @returns ChargebackWonAndRaisedResponse Successful Response
     * @throws ApiError
     */
    static getLatestOrgChargebackWonAndRaisedGetLatestOrgChargebackWonAndRaisedPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/get/latest/org/chargeback/won/and/raised',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Login Superset
     * @returns SupersetDashboardLoginResponse Successful Response
     * @throws ApiError
     */
    static loginSupersetLoginSupersetPost() {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/login/superset',
        });
    }
    /**
     * Get Super Set Guest Token
     * @param requestBody
     * @returns SupersetGuestTokenResponse Successful Response
     * @throws ApiError
     */
    static getSuperSetGuestTokenGetSupersetGuestTokenPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/get/superset/guest/token',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
